// Generated from static client-portal UI copy. No client data is included.
export default {
  "A GOSI periods and wages certificate may be helpful when there is a wage discrepancy.": {
    "ur": "اجرت میں تفاوت ہونے پر GOSI کی مدت اور اجرت کا سرٹیفکیٹ مددگار ثابت ہو سکتا ہے۔",
    "bn": "একটি GOSI মেয়াদ এবং মজুরি শংসাপত্র সহায়ক হতে পারে যখন মজুরি বৈষম্য থাকে।",
    "id": "Periode GOSI dan sertifikat upah mungkin berguna ketika ada perbedaan upah.",
    "ml": "വേതനത്തിലെ പൊരുത്തക്കേടുകൾ ഉണ്ടാകുമ്പോൾ ഒരു GOSI കാലയളവുകളും വേജസ് സർട്ടിഫിക്കറ്റും സഹായകമായേക്കാം.",
    "tl": "Maaaring makatulong ang isang GOSI period at wages certificate kapag may pagkakaiba sa sahod."
  },
  "A bank statement may be needed to support delayed wage-related claims.": {
    "ur": "تاخیر سے اجرت سے متعلق دعووں کی حمایت کے لیے بینک اسٹیٹمنٹ کی ضرورت ہو سکتی ہے۔",
    "bn": "বিলম্বিত মজুরি-সম্পর্কিত দাবি সমর্থন করার জন্য একটি ব্যাঙ্ক স্টেটমেন্টের প্রয়োজন হতে পারে।",
    "id": "Laporan bank mungkin diperlukan untuk mendukung klaim terkait upah yang tertunda.",
    "ml": "വൈകിയ വേതനവുമായി ബന്ധപ്പെട്ട ക്ലെയിമുകളെ പിന്തുണയ്ക്കാൻ ഒരു ബാങ്ക് സ്റ്റേറ്റ്മെൻ്റ് ആവശ്യമായി വന്നേക്കാം.",
    "tl": "Maaaring kailanganin ang isang bank statement upang suportahan ang mga naantalang claim na nauugnay sa sahod."
  },
  "A dedicated tracking page has been created until the public Wazin platform is launched.": {
    "ur": "عوامی وازین پلیٹ فارم کے شروع ہونے تک ایک سرشار ٹریکنگ صفحہ بنایا گیا ہے۔",
    "bn": "পাবলিক ওয়াজিন প্ল্যাটফর্ম চালু না হওয়া পর্যন্ত একটি ডেডিকেটেড ট্র্যাকিং পেজ তৈরি করা হয়েছে।",
    "id": "Halaman pelacakan khusus telah dibuat hingga platform publik Wazin diluncurkan.",
    "ml": "പൊതു Wazin പ്ലാറ്റ്‌ഫോം ആരംഭിക്കുന്നത് വരെ ഒരു സമർപ്പിത ട്രാക്കിംഗ് പേജ് സൃഷ്‌ടിച്ചിട്ടുണ്ട്.",
    "tl": "Isang nakalaang pahina sa pagsubaybay ang nalikha hanggang sa mailunsad ang pampublikong Wazin platform."
  },
  "A page dedicated to submitting information and documents": {
    "ur": "ایک صفحہ معلومات اور دستاویزات جمع کرانے کے لیے وقف ہے۔",
    "bn": "তথ্য এবং নথি জমা দেওয়ার জন্য নিবেদিত একটি পৃষ্ঠা",
    "id": "Halaman yang didedikasikan untuk mengirimkan informasi dan dokumen",
    "ml": "വിവരങ്ങളും രേഖകളും സമർപ്പിക്കുന്നതിനായി സമർപ്പിച്ചിരിക്കുന്ന ഒരു പേജ്",
    "tl": "Isang pahina na nakatuon sa pagsusumite ng impormasyon at mga dokumento"
  },
  "A saved draft was found": {
    "ur": "ایک محفوظ کردہ مسودہ ملا",
    "bn": "একটি সংরক্ষিত খসড়া পাওয়া গেছে",
    "id": "Draf tersimpan ditemukan",
    "ml": "സംരക്ഷിച്ച ഡ്രാഫ്റ്റ് കണ്ടെത്തി",
    "tl": "May nakitang naka-save na draft"
  },
  "Actions": {
    "ur": "اعمال",
    "bn": "কর্ম",
    "id": "Tindakan",
    "ml": "പ്രവർത്തനങ്ങൾ",
    "tl": "Mga aksyon"
  },
  "Active": {
    "ur": "فعال",
    "bn": "সক্রিয়",
    "id": "Aktif",
    "ml": "സജീവമാണ്",
    "tl": "Aktibo"
  },
  "Actual Relationship Details and Working Conditions": {
    "ur": "حقیقی تعلقات کی تفصیلات اور کام کرنے کے حالات",
    "bn": "প্রকৃত সম্পর্কের বিবরণ এবং কাজের শর্ত",
    "id": "Detail Hubungan Sebenarnya dan Kondisi Kerja",
    "ml": "യഥാർത്ഥ ബന്ധത്തിൻ്റെ വിശദാംശങ്ങളും പ്രവർത്തന സാഹചര്യങ്ങളും",
    "tl": "Aktwal na Mga Detalye ng Relasyon at Kondisyon sa Paggawa"
  },
  "Add Attachment": {
    "ur": "اٹیچمنٹ شامل کریں۔",
    "bn": "সংযুক্তি যোগ করুন",
    "id": "Tambahkan Lampiran",
    "ml": "അറ്റാച്ച്മെൻ്റ് ചേർക്കുക",
    "tl": "Magdagdag ng Attachment"
  },
  "Add advance": {
    "ur": "پیشگی شامل کریں۔",
    "bn": "অগ্রিম যোগ করুন",
    "id": "Tambahkan uang muka",
    "ml": "മുൻകൂർ ചേർക്കുക",
    "tl": "Magdagdag ng advance"
  },
  "Add case-related documents through a structured list, with support for multiple files under the same attachment type when needed.": {
    "ur": "ضرورت پڑنے پر ایک ہی اٹیچمنٹ کی قسم کے تحت متعدد فائلوں کے لیے سپورٹ کے ساتھ، تشکیل شدہ فہرست کے ذریعے کیس سے متعلق دستاویزات شامل کریں۔",
    "bn": "প্রয়োজনে একই সংযুক্তি টাইপের অধীনে একাধিক ফাইলের সমর্থন সহ একটি কাঠামোবদ্ধ তালিকার মাধ্যমে কেস-সম্পর্কিত নথি যোগ করুন।",
    "id": "Tambahkan dokumen terkait kasus melalui daftar terstruktur, dengan dukungan untuk beberapa file dengan jenis lampiran yang sama bila diperlukan.",
    "ml": "ആവശ്യമുള്ളപ്പോൾ ഒരേ അറ്റാച്ച്‌മെൻ്റ് തരത്തിന് കീഴിലുള്ള ഒന്നിലധികം ഫയലുകൾക്കുള്ള പിന്തുണയോടെ, ഘടനാപരമായ ലിസ്റ്റിലൂടെ കേസുമായി ബന്ധപ്പെട്ട ഡോക്യുമെൻ്റുകൾ ചേർക്കുക.",
    "tl": "Magdagdag ng mga dokumentong nauugnay sa kaso sa pamamagitan ng isang structured na listahan, na may suporta para sa maraming file sa ilalim ng parehong uri ng attachment kapag kinakailangan."
  },
  "Add custody": {
    "ur": "تحویل شامل کریں۔",
    "bn": "হেফাজত যোগ করুন",
    "id": "Tambahkan hak asuh",
    "ml": "കസ്റ്റഡി ചേർക്കുക",
    "tl": "Magdagdag ng kustodiya"
  },
  "Add employee advances received during employment, if any.": {
    "ur": "ملازمت کے دوران موصول ہونے والے ملازم ایڈوانسز کو شامل کریں، اگر کوئی ہو۔",
    "bn": "কর্মসংস্থানের সময় প্রাপ্ত কর্মচারী অগ্রিম যোগ করুন, যদি থাকে।",
    "id": "Tambahkan uang muka karyawan yang diterima selama bekerja, jika ada.",
    "ml": "ജോലി സമയത്ത് ലഭിച്ച ജീവനക്കാരുടെ അഡ്വാൻസുകൾ, എന്തെങ്കിലും ഉണ്ടെങ്കിൽ ചേർക്കുക.",
    "tl": "Magdagdag ng mga advance ng empleyado na natanggap sa panahon ng trabaho, kung mayroon man."
  },
  "Additional number": {
    "ur": "اضافی نمبر",
    "bn": "অতিরিক্ত সংখ্যা",
    "id": "Nomor tambahan",
    "ml": "അധിക നമ്പർ",
    "tl": "Karagdagang numero"
  },
  "Advance amount": {
    "ur": "پیشگی رقم",
    "bn": "অগ্রিম পরিমাণ",
    "id": "Jumlah uang muka",
    "ml": "അഡ്വാൻസ് തുക",
    "tl": "Paunang halaga"
  },
  "Advance date": {
    "ur": "پیشگی تاریخ",
    "bn": "অগ্রিম তারিখ",
    "id": "Tanggal sebelumnya",
    "ml": "മുൻകൂർ തീയതി",
    "tl": "Advance date"
  },
  "Advances and Financial Obligations": {
    "ur": "پیش قدمی اور مالی ذمہ داریاں",
    "bn": "অগ্রিম এবং আর্থিক বাধ্যবাধকতা",
    "id": "Uang Muka dan Kewajiban Finansial",
    "ml": "അഡ്വാൻസുകളും സാമ്പത്തിക ബാധ്യതകളും",
    "tl": "Mga Advance at Obligasyon sa Pinansyal"
  },
  "After reviewing the summary and uploading attachments, please confirm the following declaration to submit the request to the Wazin team.": {
    "ur": "خلاصہ کا جائزہ لینے اور منسلکات کو اپ لوڈ کرنے کے بعد، براہ کرم Wazin ٹیم کو درخواست جمع کرانے کے لیے درج ذیل اعلامیے کی تصدیق کریں۔",
    "bn": "সারাংশ পর্যালোচনা এবং সংযুক্তি আপলোড করার পর, Wazin টিমের কাছে অনুরোধ জমা দেওয়ার জন্য নিম্নলিখিত ঘোষণাটি নিশ্চিত করুন।",
    "id": "Setelah meninjau ringkasan dan mengunggah lampiran, harap konfirmasi pernyataan berikut untuk mengirimkan permintaan ke tim Wazin.",
    "ml": "സംഗ്രഹം അവലോകനം ചെയ്‌ത് അറ്റാച്ച്‌മെൻ്റുകൾ അപ്‌ലോഡ് ചെയ്‌ത ശേഷം, Wazin ടീമിന് അഭ്യർത്ഥന സമർപ്പിക്കുന്നതിന് ഇനിപ്പറയുന്ന പ്രഖ്യാപനം സ്ഥിരീകരിക്കുക.",
    "tl": "Pagkatapos suriin ang buod at mag-upload ng mga attachment, mangyaring kumpirmahin ang sumusunod na deklarasyon upang isumite ang kahilingan sa Wazin team."
  },
  "Allowed formats": {
    "ur": "اجازت شدہ فارمیٹس",
    "bn": "অনুমোদিত ফরম্যাট",
    "id": "Format yang diizinkan",
    "ml": "അനുവദനീയമായ ഫോർമാറ്റുകൾ",
    "tl": "Mga pinapayagang format"
  },
  "Allowed formats: PDF / JPG / PNG / DOCX / XLSX / ZIP - Maximum 10 MB per file": {
    "ur": "اجازت شدہ فارمیٹس: PDF / JPG / PNG / DOCX / XLSX / ZIP - فی فائل زیادہ سے زیادہ 10 MB",
    "bn": "অনুমোদিত ফর্ম্যাট: PDF / JPG / PNG / DOCX / XLSX / ZIP - প্রতি ফাইলে সর্বাধিক 10 MB",
    "id": "Format yang diperbolehkan: PDF / JPG / PNG / DOCX / XLSX / ZIP - Maksimum 10 MB per file",
    "ml": "അനുവദനീയമായ ഫോർമാറ്റുകൾ: PDF / JPG / PNG / DOCX / XLSX / ZIP - ഓരോ ഫയലിനും പരമാവധി 10 MB",
    "tl": "Mga pinapayagang format: PDF / JPG / PNG / DOCX / XLSX / ZIP - Maximum na 10 MB bawat file"
  },
  "Analyze the actual relationship, wage and benefits, leave and overtime, and material changes during the relationship to derive initial legal claims.": {
    "ur": "ابتدائی قانونی دعوے حاصل کرنے کے لیے اصل تعلق، اجرت اور فوائد، چھٹی اور اوور ٹائم، اور تعلقات کے دوران ہونے والی مادی تبدیلیوں کا تجزیہ کریں۔",
    "bn": "প্রাথমিক আইনি দাবিগুলি অর্জনের জন্য প্রকৃত সম্পর্ক, মজুরি এবং সুবিধা, ছুটি এবং ওভারটাইম এবং সম্পর্কের সময় উপাদান পরিবর্তনগুলি বিশ্লেষণ করুন।",
    "id": "Analisis hubungan sebenarnya, upah dan tunjangan, cuti dan lembur, serta perubahan material selama hubungan untuk memperoleh tuntutan hukum awal.",
    "ml": "പ്രാഥമിക നിയമപരമായ ക്ലെയിമുകൾ ലഭിക്കുന്നതിന് യഥാർത്ഥ ബന്ധം, വേതനം, ആനുകൂല്യങ്ങൾ, ലീവ്, ഓവർടൈം, ബന്ധത്തിനിടയിലെ ഭൗതിക മാറ്റങ്ങൾ എന്നിവ വിശകലനം ചെയ്യുക.",
    "tl": "Suriin ang aktwal na relasyon, sahod at mga benepisyo, bakasyon at overtime, at mga materyal na pagbabago sa panahon ng relasyon upang makakuha ng mga paunang legal na paghahabol."
  },
  "Annual increment": {
    "ur": "سالانہ اضافہ",
    "bn": "বার্ষিক বৃদ্ধি",
    "id": "Kenaikan tahunan",
    "ml": "വാർഷിക വർദ്ധനവ്",
    "tl": "Taunang pagtaas"
  },
  "Any important notes about leave, overtime, or weekly rest": {
    "ur": "چھٹی، اوور ٹائم، یا ہفتہ وار آرام کے بارے میں کوئی اہم نوٹ",
    "bn": "ছুটি, ওভারটাইম, বা সাপ্তাহিক বিশ্রাম সম্পর্কে কোনো গুরুত্বপূর্ণ নোট",
    "id": "Catatan penting apa pun tentang cuti, lembur, atau istirahat mingguan",
    "ml": "അവധി, ഓവർടൈം, അല്ലെങ്കിൽ പ്രതിവാര വിശ്രമം എന്നിവയെ കുറിച്ചുള്ള ഏതെങ്കിലും പ്രധാന കുറിപ്പുകൾ",
    "tl": "Anumang mahahalagang tala tungkol sa bakasyon, overtime, o lingguhang pahinga"
  },
  "Applicant Summary": {
    "ur": "درخواست گزار کا خلاصہ",
    "bn": "আবেদনকারীর সারাংশ",
    "id": "Ringkasan Pelamar",
    "ml": "അപേക്ഷകൻ്റെ സംഗ്രഹം",
    "tl": "Buod ng Aplikante"
  },
  "Are there messages or emails proving the agreement?": {
    "ur": "کیا معاہدے کو ثابت کرنے والے پیغامات یا ای میلز ہیں؟",
    "bn": "চুক্তি প্রমাণ করার বার্তা বা ইমেল আছে?",
    "id": "Apakah ada pesan atau email yang membuktikan persetujuan tersebut?",
    "ml": "കരാർ തെളിയിക്കുന്ന സന്ദേശങ്ങളോ ഇമെയിലുകളോ ഉണ്ടോ?",
    "tl": "Mayroon bang mga mensahe o email na nagpapatunay ng kasunduan?"
  },
  "Are there witnesses to the receipt?": {
    "ur": "کیا رسید کے گواہ ہیں؟",
    "bn": "রসিদের সাক্ষী আছে?",
    "id": "Apakah ada saksi yang menerima tanda terima tersebut?",
    "ml": "രസീതിന് സാക്ഷികളുണ്ടോ?",
    "tl": "May mga saksi ba sa resibo?"
  },
  "Are you still employed?": {
    "ur": "کیا آپ اب بھی ملازم ہیں؟",
    "bn": "আপনি কি এখনও চাকরি করেন?",
    "id": "Apakah Anda masih bekerja?",
    "ml": "നിങ്ങൾ ഇപ്പോഴും ജോലിയിലാണോ?",
    "tl": "May trabaho ka pa ba?"
  },
  "As shown in the contract or commercial registration.": {
    "ur": "جیسا کہ معاہدہ یا تجارتی رجسٹریشن میں دکھایا گیا ہے۔",
    "bn": "চুক্তি বা বাণিজ্যিক নিবন্ধন দেখানো হিসাবে.",
    "id": "Seperti yang ditunjukkan dalam kontrak atau pendaftaran komersial.",
    "ml": "കരാറിലോ വാണിജ്യ രജിസ്ട്രേഷനിലോ കാണിച്ചിരിക്കുന്നതുപോലെ.",
    "tl": "Gaya ng ipinapakita sa kontrata o komersyal na pagpaparehistro."
  },
  "Assignment allowance": {
    "ur": "اسائنمنٹ الاؤنس",
    "bn": "অ্যাসাইনমেন্ট ভাতা",
    "id": "Tunjangan tugas",
    "ml": "അസൈൻമെൻ്റ് അലവൻസ്",
    "tl": "Assignment allowance"
  },
  "Attach document (optional)": {
    "ur": "دستاویز منسلک کریں (اختیاری)",
    "bn": "নথি সংযুক্ত করুন (ঐচ্ছিক)",
    "id": "Lampirkan dokumen (opsional)",
    "ml": "പ്രമാണം അറ്റാച്ചുചെയ്യുക (ഓപ്ഷണൽ)",
    "tl": "Maglakip ng dokumento (opsyonal)"
  },
  "Attach receipt (optional)": {
    "ur": "رسید منسلک کریں (اختیاری)",
    "bn": "রসিদ সংযুক্ত করুন (ঐচ্ছিক)",
    "id": "Lampirkan tanda terima (opsional)",
    "ml": "രസീത് അറ്റാച്ചുചെയ്യുക (ഓപ്ഷണൽ)",
    "tl": "Maglakip ng resibo (opsyonal)"
  },
  "Attach receipt record (optional)": {
    "ur": "رسید کا ریکارڈ منسلک کریں (اختیاری)",
    "bn": "রসিদ রেকর্ড সংযুক্ত করুন (ঐচ্ছিক)",
    "id": "Lampirkan catatan tanda terima (opsional)",
    "ml": "രസീത് റെക്കോർഡ് അറ്റാച്ചുചെയ്യുക (ഓപ്ഷണൽ)",
    "tl": "Maglakip ng talaan ng resibo (opsyonal)"
  },
  "Attach return record (optional)": {
    "ur": "واپسی کا ریکارڈ منسلک کریں (اختیاری)",
    "bn": "রিটার্ন রেকর্ড সংযুক্ত করুন (ঐচ্ছিক)",
    "id": "Lampirkan catatan pengembalian (opsional)",
    "ml": "റിട്ടേൺ റെക്കോർഡ് അറ്റാച്ചുചെയ്യുക (ഓപ്ഷണൽ)",
    "tl": "Maglakip ng tala sa pagbabalik (opsyonal)"
  },
  "Attach transfer notice (optional)": {
    "ur": "منتقلی کا نوٹس منسلک کریں (اختیاری)",
    "bn": "স্থানান্তর বিজ্ঞপ্তি সংযুক্ত করুন (ঐচ্ছিক)",
    "id": "Lampirkan pemberitahuan transfer (opsional)",
    "ml": "കൈമാറ്റ അറിയിപ്പ് അറ്റാച്ചുചെയ്യുക (ഓപ്ഷണൽ)",
    "tl": "Maglakip ng paunawa sa paglipat (opsyonal)"
  },
  "Attachment Name": {
    "ur": "اٹیچمنٹ کا نام",
    "bn": "সংযুক্তির নাম",
    "id": "Nama Lampiran",
    "ml": "അറ്റാച്ചുമെൻ്റ് പേര്",
    "tl": "Pangalan ng Kalakip"
  },
  "Attachment Type": {
    "ur": "اٹیچمنٹ کی قسم",
    "bn": "সংযুক্তির ধরন",
    "id": "Jenis Lampiran",
    "ml": "അറ്റാച്ച്മെൻ്റ് തരം",
    "tl": "Uri ng Attachment"
  },
  "Attachments": {
    "ur": "منسلکات",
    "bn": "সংযুক্তি",
    "id": "Lampiran",
    "ml": "അറ്റാച്ചുമെൻ്റുകൾ",
    "tl": "Mga kalakip"
  },
  "Available evidence and proof": {
    "ur": "دستیاب ثبوت اور ثبوت",
    "bn": "উপলব্ধ প্রমাণ এবং প্রমাণ",
    "id": "Bukti dan bukti yang tersedia",
    "ml": "ലഭ്യമായ തെളിവുകളും തെളിവുകളും",
    "tl": "Magagamit na ebidensya at patunay"
  },
  "Available notices or correspondence": {
    "ur": "دستیاب نوٹس یا خط و کتابت",
    "bn": "উপলব্ধ বিজ্ঞপ্তি বা চিঠিপত্র",
    "id": "Pemberitahuan atau korespondensi yang tersedia",
    "ml": "ലഭ്യമായ അറിയിപ്പുകൾ അല്ലെങ്കിൽ കത്തിടപാടുകൾ",
    "tl": "Magagamit na mga abiso o sulat"
  },
  "Average number of overtime hours": {
    "ur": "اوور ٹائم گھنٹوں کی اوسط تعداد",
    "bn": "ওভারটাইম ঘন্টার গড় সংখ্যা",
    "id": "Jumlah rata-rata jam lembur",
    "ml": "ഓവർടൈം മണിക്കൂറുകളുടെ ശരാശരി എണ്ണം",
    "tl": "Average na bilang ng mga oras ng overtime"
  },
  "Bank": {
    "ur": "بینک",
    "bn": "ব্যাঙ্ক",
    "id": "Bank",
    "ml": "ബാങ്ക്",
    "tl": "Bangko"
  },
  "Bank name": {
    "ur": "بینک کا نام",
    "bn": "ব্যাঙ্কের নাম",
    "id": "Nama bank",
    "ml": "ബാങ്കിൻ്റെ പേര്",
    "tl": "Pangalan ng bangko"
  },
  "Basic data": {
    "ur": "بنیادی ڈیٹا",
    "bn": "মৌলিক তথ্য",
    "id": "Data dasar",
    "ml": "അടിസ്ഥാന ഡാറ്റ",
    "tl": "Pangunahing datos"
  },
  "Basic wage": {
    "ur": "بنیادی اجرت",
    "bn": "মৌলিক মজুরি",
    "id": "Gaji pokok",
    "ml": "അടിസ്ഥാന കൂലി",
    "tl": "Pangunahing sahod"
  },
  "Briefly explain the current issue with the employer.": {
    "ur": "آجر کے ساتھ موجودہ مسئلے کی مختصر وضاحت کریں۔",
    "bn": "নিয়োগকর্তার সাথে বর্তমান সমস্যাটি সংক্ষেপে ব্যাখ্যা করুন।",
    "id": "Jelaskan secara singkat masalah terkini dengan pemberi kerja.",
    "ml": "തൊഴിലുടമയുമായുള്ള നിലവിലെ പ്രശ്നം ഹ്രസ്വമായി വിശദീകരിക്കുക.",
    "tl": "Maikling ipaliwanag ang kasalukuyang isyu sa employer."
  },
  "Briefly explain the main material changes during the relationship": {
    "ur": "تعلقات کے دوران اہم مادی تبدیلیوں کی مختصر وضاحت کریں۔",
    "bn": "সম্পর্কের সময় প্রধান উপাদান পরিবর্তনগুলি সংক্ষেপে ব্যাখ্যা করুন",
    "id": "Jelaskan secara singkat perubahan materi utama selama hubungan",
    "ml": "ബന്ധത്തിലെ പ്രധാന ഭൌതിക മാറ്റങ്ങൾ സംക്ഷിപ്തമായി വിശദീകരിക്കുക",
    "tl": "Ipaliwanag nang maikli ang mga pangunahing pagbabago sa materyal sa panahon ng relasyon"
  },
  "Building number": {
    "ur": "عمارت نمبر",
    "bn": "বিল্ডিং নম্বর",
    "id": "Nomor gedung",
    "ml": "കെട്ടിട നമ്പർ",
    "tl": "Numero ng gusali"
  },
  "Cancel": {
    "ur": "منسوخ کریں۔",
    "bn": "বাতিল করুন",
    "id": "Membatalkan",
    "ml": "റദ്ദാക്കുക",
    "tl": "Kanselahin"
  },
  "Cash custody amount": {
    "ur": "نقد تحویل کی رقم",
    "bn": "নগদ হেফাজতের পরিমাণ",
    "id": "Jumlah penitipan tunai",
    "ml": "ക്യാഷ് കസ്റ്റഡി തുക",
    "tl": "Halaga ng cash custody"
  },
  "Cash custody details": {
    "ur": "نقد تحویل کی تفصیلات",
    "bn": "নগদ হেফাজত বিবরণ",
    "id": "Detail penitipan uang tunai",
    "ml": "ക്യാഷ് കസ്റ്റഡി വിശദാംശങ്ങൾ",
    "tl": "Mga detalye ng cash custody"
  },
  "Cash salary receipt details": {
    "ur": "نقد تنخواہ کی رسید کی تفصیلات",
    "bn": "নগদ বেতন প্রাপ্তির বিবরণ",
    "id": "Detail penerimaan gaji tunai",
    "ml": "പണ ശമ്പള രസീതിൻ്റെ വിശദാംശങ്ങൾ",
    "tl": "Mga detalye ng resibo ng suweldo ng pera"
  },
  "Changes in Employment Terms During the Relationship": {
    "ur": "تعلقات کے دوران ملازمت کی شرائط میں تبدیلیاں",
    "bn": "সম্পর্কের সময় চাকরির শর্তাবলীর পরিবর্তন",
    "id": "Perubahan Persyaratan Pekerjaan Selama Hubungan",
    "ml": "ബന്ധത്തിനിടയിലെ തൊഴിൽ നിബന്ധനകളിലെ മാറ്റങ്ങൾ",
    "tl": "Mga Pagbabago sa Mga Tuntunin sa Pagtatrabaho Sa Panahon ng Relasyon"
  },
  "Choose the attachment type, then add one or more files under the same category in a structured way.": {
    "ur": "اٹیچمنٹ کی قسم کا انتخاب کریں، پھر ایک یا زیادہ فائلوں کو ایک ہی زمرے کے تحت ایک منظم طریقے سے شامل کریں۔",
    "bn": "সংযুক্তি প্রকার চয়ন করুন, তারপরে একই বিভাগের অধীনে একটি কাঠামোগত উপায়ে এক বা একাধিক ফাইল যুক্ত করুন৷",
    "id": "Pilih jenis lampiran, lalu tambahkan satu atau lebih file dalam kategori yang sama secara terstruktur.",
    "ml": "അറ്റാച്ച്മെൻ്റ് തരം തിരഞ്ഞെടുക്കുക, തുടർന്ന് ഘടനാപരമായ രീതിയിൽ ഒരേ വിഭാഗത്തിന് കീഴിൽ ഒന്നോ അതിലധികമോ ഫയലുകൾ ചേർക്കുക.",
    "tl": "Piliin ang uri ng attachment, pagkatapos ay magdagdag ng isa o higit pang mga file sa ilalim ng parehong kategorya sa isang structured na paraan."
  },
  "City": {
    "ur": "شہر",
    "bn": "শহর",
    "id": "Kota",
    "ml": "നഗരം",
    "tl": "lungsod"
  },
  "City is required.": {
    "ur": "شہر کی ضرورت ہے۔",
    "bn": "শহর প্রয়োজন.",
    "id": "Kota diperlukan.",
    "ml": "നഗരം ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang lungsod."
  },
  "Claims and Supporting Information": {
    "ur": "دعوے اور معاون معلومات",
    "bn": "দাবি এবং সমর্থন তথ্য",
    "id": "Klaim dan Informasi Pendukung",
    "ml": "ക്ലെയിമുകളും സഹായ വിവരങ്ങളും",
    "tl": "Mga Claim at Impormasyon sa Pagsuporta"
  },
  "Clearance date": {
    "ur": "کلیئرنس کی تاریخ",
    "bn": "ক্লিয়ারেন্স তারিখ",
    "id": "Tanggal izin",
    "ml": "ക്ലിയറൻസ് തീയതി",
    "tl": "Petsa ng clearance"
  },
  "Clearance date is required.": {
    "ur": "کلیئرنس کی تاریخ درکار ہے۔",
    "bn": "ক্লিয়ারেন্স তারিখ প্রয়োজন.",
    "id": "Tanggal izin diperlukan.",
    "ml": "ക്ലിയറൻസ് തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng clearance."
  },
  "Click add advance to enter each advance separately.": {
    "ur": "ہر پیشگی کو الگ سے داخل کرنے کے لیے ایڈوانس ایڈوانس پر کلک کریں۔",
    "bn": "প্রতিটি অগ্রিম আলাদাভাবে প্রবেশ করতে অগ্রিম যোগ করুন ক্লিক করুন।",
    "id": "Klik tambahkan uang muka untuk memasukkan setiap uang muka secara terpisah.",
    "ml": "ഓരോ അഡ്വാൻസും വെവ്വേറെ നൽകാൻ അഡ്വാൻസ് ചേർക്കുക ക്ലിക്ക് ചെയ്യുക.",
    "tl": "I-click ang magdagdag ng advance upang ipasok ang bawat advance nang hiwalay."
  },
  "Click add custody to enter each custody separately.": {
    "ur": "ہر ایک حراست میں الگ سے داخل ہونے کے لیے تحویل شامل کریں پر کلک کریں۔",
    "bn": "প্রতিটি হেফাজতে আলাদাভাবে প্রবেশ করতে কাস্টডি যোগ করুন ক্লিক করুন।",
    "id": "Klik tambahkan hak asuh untuk memasukkan setiap hak asuh secara terpisah.",
    "ml": "ഓരോ കസ്റ്റഡിയും വെവ്വേറെ നൽകുന്നതിന് കസ്റ്റഡി ചേർക്കുക ക്ലിക്ക് ചെയ്യുക.",
    "tl": "I-click ang magdagdag ng kustodiya upang ipasok ang bawat kustodiya nang hiwalay."
  },
  "Client name": {
    "ur": "کلائنٹ کا نام",
    "bn": "ক্লায়েন্টের নাম",
    "id": "Nama klien",
    "ml": "ഉപഭോക്താവിൻ്റെ പേര്",
    "tl": "Pangalan ng kliyente"
  },
  "Coming soon... Wazin platform is being launched gradually.": {
    "ur": "جلد آرہا ہے... وازین پلیٹ فارم بتدریج شروع کیا جا رہا ہے۔",
    "bn": "শীঘ্রই আসছে... ধীরে ধীরে ওয়াজিন প্ল্যাটফর্ম চালু হচ্ছে।",
    "id": "Segera hadir... Platform Wazin diluncurkan secara bertahap.",
    "ml": "ഉടൻ വരുന്നു... Wazin പ്ലാറ്റ്ഫോം ക്രമേണ സമാരംഭിക്കുന്നു.",
    "tl": "Malapit na... Unti-unting inilulunsad ang Wazin platform."
  },
  "Commissions": {
    "ur": "کمیشن",
    "bn": "কমিশন",
    "id": "Komisi",
    "ml": "കമ്മീഷനുകൾ",
    "tl": "Mga komisyon"
  },
  "Communication allowance": {
    "ur": "مواصلاتی الاؤنس",
    "bn": "যোগাযোগ ভাতা",
    "id": "Tunjangan komunikasi",
    "ml": "ആശയവിനിമയ അലവൻസ്",
    "tl": "Allowance sa komunikasyon"
  },
  "Complete": {
    "ur": "مکمل",
    "bn": "সম্পূর্ণ",
    "id": "Menyelesaikan",
    "ml": "പൂർത്തിയാക്കുക",
    "tl": "Kumpleto"
  },
  "Complete the termination details, dispute correspondence, and the claims you reported through a clear structured flow.": {
    "ur": "ختم کرنے کی تفصیلات، تنازعات کی خط و کتابت، اور ان دعووں کو مکمل کریں جن کی آپ نے واضح ساختی بہاؤ کے ذریعے اطلاع دی ہے۔",
    "bn": "সমাপ্তির বিশদ বিবরণ, বিবাদের চিঠিপত্র, এবং একটি স্পষ্ট কাঠামোগত প্রবাহের মাধ্যমে আপনি যে দাবিগুলি রিপোর্ট করেছেন তা সম্পূর্ণ করুন।",
    "id": "Lengkapi detail pengakhiran, korespondensi sengketa, dan klaim yang Anda laporkan melalui alur terstruktur yang jelas.",
    "ml": "അവസാനിപ്പിക്കൽ വിശദാംശങ്ങൾ, തർക്ക കത്തിടപാടുകൾ, നിങ്ങൾ റിപ്പോർട്ട് ചെയ്ത ക്ലെയിമുകൾ എന്നിവ വ്യക്തമായ ഘടനാപരമായ ഫ്ലോയിലൂടെ പൂർത്തിയാക്കുക.",
    "tl": "Kumpletuhin ang mga detalye ng pagwawakas, pagsusulatan ng hindi pagkakaunawaan, at ang mga claim na iniulat mo sa pamamagitan ng isang malinaw na structured na daloy."
  },
  "Completed sections": {
    "ur": "مکمل شدہ حصے",
    "bn": "সম্পূর্ণ বিভাগ",
    "id": "Bagian yang sudah selesai",
    "ml": "പൂർത്തിയാക്കിയ വിഭാഗങ്ങൾ",
    "tl": "Mga nakumpletong seksyon"
  },
  "Condition when received": {
    "ur": "موصول ہونے پر حالت",
    "bn": "প্রাপ্তির সময় শর্ত",
    "id": "Kondisi saat diterima",
    "ml": "ലഭിക്കുമ്പോൾ അവസ്ഥ",
    "tl": "Kundisyon kapag natanggap"
  },
  "Contract Documentation and Proof of Agreement": {
    "ur": "معاہدے کی دستاویزات اور معاہدے کا ثبوت",
    "bn": "চুক্তির নথিপত্র এবং চুক্তির প্রমাণ",
    "id": "Dokumentasi Kontrak dan Bukti Perjanjian",
    "ml": "കരാർ ഡോക്യുമെൻ്റേഷനും കരാറിൻ്റെ തെളിവും",
    "tl": "Dokumentasyon ng Kontrata at Katibayan ng Kasunduan"
  },
  "Contract end date": {
    "ur": "معاہدہ ختم ہونے کی تاریخ",
    "bn": "চুক্তির শেষ তারিখ",
    "id": "Tanggal akhir kontrak",
    "ml": "കരാർ അവസാന തീയതി",
    "tl": "Petsa ng pagtatapos ng kontrata"
  },
  "Contract end date is required.": {
    "ur": "معاہدہ ختم ہونے کی تاریخ درکار ہے۔",
    "bn": "চুক্তি শেষ তারিখ প্রয়োজন.",
    "id": "Tanggal akhir kontrak wajib diisi.",
    "ml": "കരാർ അവസാനിക്കുന്ന തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng pagtatapos ng kontrata."
  },
  "Contract or agreement date": {
    "ur": "معاہدہ یا معاہدے کی تاریخ",
    "bn": "চুক্তি বা চুক্তির তারিখ",
    "id": "Tanggal kontrak atau perjanjian",
    "ml": "കരാർ അല്ലെങ്കിൽ കരാർ തീയതി",
    "tl": "Petsa ng kontrata o kasunduan"
  },
  "Contractual Relationship Foundation": {
    "ur": "کنٹریکٹوئل ریلیشن شپ فاؤنڈیشن",
    "bn": "চুক্তিভিত্তিক সম্পর্ক ফাউন্ডেশন",
    "id": "Landasan Hubungan Kontraktual",
    "ml": "കോൺട്രാക്‌ച്വൽ റിലേഷൻഷിപ്പ് ഫൗണ്ടേഷൻ",
    "tl": "Contractual Relationship Foundation"
  },
  "Contractual Relationship and Core Facts": {
    "ur": "معاہدہی تعلق اور بنیادی حقائق",
    "bn": "চুক্তিভিত্তিক সম্পর্ক এবং মূল তথ্য",
    "id": "Hubungan Kontraktual dan Fakta Inti",
    "ml": "കരാർ ബന്ധവും പ്രധാന വസ്തുതകളും",
    "tl": "Kontratwal na Relasyon at Mga Pangunahing Katotohanan"
  },
  "Contractual relationship": {
    "ur": "معاہدہ رشتہ",
    "bn": "চুক্তিভিত্তিক সম্পর্ক",
    "id": "Hubungan kontraktual",
    "ml": "കരാർ ബന്ധം",
    "tl": "Kontratwal na relasyon"
  },
  "Copy Link": {
    "ur": "لنک کاپی کریں۔",
    "bn": "লিংক কপি করুন",
    "id": "Salin Tautan",
    "ml": "ലിങ്ക് പകർത്തുക",
    "tl": "Kopyahin ang Link"
  },
  "Copy Number": {
    "ur": "نمبر کاپی کریں۔",
    "bn": "নম্বর কপি করুন",
    "id": "Salin Nomor",
    "ml": "നമ്പർ പകർത്തുക",
    "tl": "Kopyahin ang Numero"
  },
  "Core legal and identification details for preparing the labor claim file.": {
    "ur": "لیبر کلیم فائل کی تیاری کے لیے بنیادی قانونی اور شناختی تفصیلات۔",
    "bn": "শ্রম দাবি ফাইল প্রস্তুত করার জন্য মূল আইনি এবং শনাক্তকরণ বিশদ।",
    "id": "Detail hukum dan identifikasi inti untuk mempersiapkan berkas klaim tenaga kerja.",
    "ml": "ലേബർ ക്ലെയിം ഫയൽ തയ്യാറാക്കുന്നതിനുള്ള പ്രധാന നിയമപരവും തിരിച്ചറിയൽ വിശദാംശങ്ങളും.",
    "tl": "Mga pangunahing detalye ng legal at pagkakakilanlan para sa paghahanda ng file ng paghahabol sa paggawa."
  },
  "Create New Request": {
    "ur": "نئی درخواست بنائیں",
    "bn": "নতুন অনুরোধ তৈরি করুন",
    "id": "Buat Permintaan Baru",
    "ml": "പുതിയ അഭ്യർത്ഥന സൃഷ്ടിക്കുക",
    "tl": "Gumawa ng Bagong Kahilingan"
  },
  "Current Relationship Status": {
    "ur": "موجودہ تعلقات کی حیثیت",
    "bn": "বর্তমান সম্পর্কের অবস্থা",
    "id": "Status Hubungan Saat Ini",
    "ml": "നിലവിലെ ബന്ധ നില",
    "tl": "Kasalukuyang Katayuan ng Relasyon"
  },
  "Current attachments": {
    "ur": "موجودہ منسلکات",
    "bn": "বর্তমান সংযুক্তি",
    "id": "Lampiran saat ini",
    "ml": "നിലവിലെ അറ്റാച്ചുമെൻ്റുകൾ",
    "tl": "Mga kasalukuyang attachment"
  },
  "Current dispute details": {
    "ur": "موجودہ تنازعہ کی تفصیلات",
    "bn": "বর্তমান বিরোধের বিবরণ",
    "id": "Detail perselisihan saat ini",
    "ml": "നിലവിലെ തർക്ക വിശദാംശങ്ങൾ",
    "tl": "Kasalukuyang mga detalye ng hindi pagkakaunawaan"
  },
  "Custodies and Employer Property": {
    "ur": "تحویل اور آجر کی جائیداد",
    "bn": "হেফাজত এবং নিয়োগকর্তা সম্পত্তি",
    "id": "Penitipan dan Properti Majikan",
    "ml": "കസ്റ്റഡികളും തൊഴിലുടമയുടെ സ്വത്തും",
    "tl": "Mga Kustodiya at Ari-arian ng Employer"
  },
  "Custody description": {
    "ur": "تحویل کی تفصیل",
    "bn": "হেফাজতের বিবরণ",
    "id": "Deskripsi hak asuh",
    "ml": "കസ്റ്റഡി വിവരണം",
    "tl": "Paglalarawan ng pag-iingat"
  },
  "Custody type": {
    "ur": "تحویل کی قسم",
    "bn": "হেফাজতের ধরন",
    "id": "Jenis hak asuh",
    "ml": "കസ്റ്റഡി തരം",
    "tl": "Uri ng pangangalaga"
  },
  "Data and Document Completion Indicator": {
    "ur": "ڈیٹا اور دستاویز کی تکمیل کا اشارے",
    "bn": "ডেটা এবং ডকুমেন্ট কমপ্লিশন ইন্ডিকেটর",
    "id": "Indikator Kelengkapan Data dan Dokumen",
    "ml": "ഡാറ്റയും ഡോക്യുമെൻ്റ് പൂർത്തീകരണ സൂചകവും",
    "tl": "Indicator ng Pagkumpleto ng Data at Dokumento"
  },
  "Date of birth": {
    "ur": "تاریخ پیدائش",
    "bn": "জন্ম তারিখ",
    "id": "Tanggal lahir",
    "ml": "ജനനത്തീയതി",
    "tl": "Petsa ng kapanganakan"
  },
  "Date of birth is required.": {
    "ur": "تاریخ پیدائش درکار ہے۔",
    "bn": "জন্ম তারিখ প্রয়োজন।",
    "id": "Tanggal lahir wajib diisi.",
    "ml": "ജനനത്തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng kapanganakan."
  },
  "Date of the objection or claim": {
    "ur": "اعتراض یا دعویٰ کی تاریخ",
    "bn": "আপত্তি বা দাবির তারিখ",
    "id": "Tanggal keberatan atau klaim",
    "ml": "എതിർപ്പിൻ്റെയോ ക്ലെയിമിൻ്റെയോ തീയതി",
    "tl": "Petsa ng pagtutol o paghahabol"
  },
  "Delete": {
    "ur": "حذف کریں۔",
    "bn": "মুছুন",
    "id": "Menghapus",
    "ml": "ഇല്ലാതാക്കുക",
    "tl": "Tanggalin"
  },
  "Delivered by": {
    "ur": "کی طرف سے پہنچایا",
    "bn": "দ্বারা বিতরণ করা হয়",
    "id": "Dikirim oleh",
    "ml": "വിതരണം ചെയ്തത്",
    "tl": "Inihatid ni"
  },
  "Deliverer position": {
    "ur": "ڈیلیور کی پوزیشن",
    "bn": "বিতরণকারী অবস্থান",
    "id": "Posisi pengantar",
    "ml": "വിതരണക്കാരൻ്റെ സ്ഥാനം",
    "tl": "Posisyon ng tagapaghatid"
  },
  "Describe the other change": {
    "ur": "دوسری تبدیلی کی وضاحت کریں۔",
    "bn": "অন্য পরিবর্তনের বর্ণনা দাও",
    "id": "Jelaskan perubahan lainnya",
    "ml": "മറ്റൊരു മാറ്റം വിവരിക്കുക",
    "tl": "Ilarawan ang iba pang pagbabago"
  },
  "Describe the timeline of the main notices or messages": {
    "ur": "اہم نوٹسز یا پیغامات کی ٹائم لائن کی وضاحت کریں۔",
    "bn": "প্রধান নোটিশ বা বার্তাগুলির টাইমলাইন বর্ণনা করুন",
    "id": "Jelaskan garis waktu pemberitahuan atau pesan utama",
    "ml": "പ്രധാന അറിയിപ്പുകളുടെയോ സന്ദേശങ്ങളുടെയോ ടൈംലൈൻ വിവരിക്കുക",
    "tl": "Ilarawan ang timeline ng mga pangunahing abiso o mensahe"
  },
  "Did it cover the family?": {
    "ur": "کیا اس نے خاندان کا احاطہ کیا؟",
    "bn": "এটা কি পরিবারকে আচ্ছাদিত করেছিল?",
    "id": "Apakah itu mencakup keluarga?",
    "ml": "അത് കുടുംബത്തെ കവർ ചെയ്തോ?",
    "tl": "Sinakop ba nito ang pamilya?"
  },
  "Did the duties increase?": {
    "ur": "کیا ڈیوٹی بڑھ گئی؟",
    "bn": "দায়িত্ব কি বেড়েছে?",
    "id": "Apakah bea masuknya bertambah?",
    "ml": "ഡ്യൂട്ടി വർധിച്ചോ?",
    "tl": "Nadagdagan ba ang mga tungkulin?"
  },
  "Did the employer comply with the signed contract?": {
    "ur": "کیا آجر نے دستخط شدہ معاہدے کی تعمیل کی؟",
    "bn": "নিয়োগকর্তা কি স্বাক্ষরিত চুক্তি মেনে চলেন?",
    "id": "Apakah pemberi kerja mematuhi kontrak yang ditandatangani?",
    "ml": "തൊഴിലുടമ ഒപ്പിട്ട കരാർ അനുസരിച്ചോ?",
    "tl": "Sinunod ba ng employer ang pinirmahang kontrata?"
  },
  "Did the employer send a response?": {
    "ur": "کیا آجر نے جواب بھیجا؟",
    "bn": "নিয়োগকর্তা একটি প্রতিক্রিয়া পাঠান?",
    "id": "Apakah majikan mengirimkan tanggapan?",
    "ml": "തൊഴിലുടമ പ്രതികരണം അയച്ചോ?",
    "tl": "Nagpadala ba ng tugon ang employer?"
  },
  "Did the employment terms change during the relationship?": {
    "ur": "کیا تعلقات کے دوران ملازمت کی شرائط تبدیل ہوئیں؟",
    "bn": "সম্পর্কের সময় কি চাকরির শর্তাবলী পরিবর্তিত হয়েছিল?",
    "id": "Apakah persyaratan kerja berubah selama hubungan berlangsung?",
    "ml": "ബന്ധത്തിനിടയിൽ തൊഴിൽ നിബന്ധനകൾ മാറിയോ?",
    "tl": "Nagbago ba ang mga termino sa pagtatrabaho sa panahon ng relasyon?"
  },
  "Did the job title change?": {
    "ur": "کیا نوکری کا عنوان بدل گیا؟",
    "bn": "চাকরির শিরোনাম কি পরিবর্তন হয়েছে?",
    "id": "Apakah jabatannya berubah?",
    "ml": "ജോലിയുടെ പേര് മാറിയോ?",
    "tl": "Nagbago ba ang titulo ng trabaho?"
  },
  "Did the wage change?": {
    "ur": "کیا اجرت تبدیل ہوئی؟",
    "bn": "মজুরি কি পরিবর্তন হয়েছে?",
    "id": "Apakah upahnya berubah?",
    "ml": "കൂലി മാറിയോ?",
    "tl": "Nagbago ba ang sahod?"
  },
  "Did the wage registered in GOSI match the actual wage?": {
    "ur": "کیا GOSI میں درج اجرت اصل اجرت سے ملتی ہے؟",
    "bn": "GOSI-তে নিবন্ধিত মজুরি কি প্রকৃত মজুরির সাথে মেলে?",
    "id": "Apakah upah yang tercatat di GOSI sesuai dengan upah sebenarnya?",
    "ml": "GOSI-ൽ രജിസ്റ്റർ ചെയ്ത കൂലി യഥാർത്ഥ വേതനവുമായി പൊരുത്തപ്പെടുന്നുണ്ടോ?",
    "tl": "Ang sahod ba na nakarehistro sa GOSI ay tumugma sa aktwal na sahod?"
  },
  "Did the wage stated in the contract match the wage you actually received?": {
    "ur": "کیا معاہدے میں بیان کردہ اجرت آپ کو ملنے والی اجرت سے ملتی ہے؟",
    "bn": "চুক্তিতে উল্লিখিত মজুরি কি প্রকৃতপক্ষে আপনি প্রাপ্ত মজুরির সাথে মেলে?",
    "id": "Apakah upah yang tercantum dalam kontrak sesuai dengan upah yang sebenarnya Anda terima?",
    "ml": "കരാറിൽ പറഞ്ഞിരിക്കുന്ന കൂലി യഥാർത്ഥത്തിൽ നിങ്ങൾക്ക് ലഭിച്ച വേതനവുമായി പൊരുത്തപ്പെട്ടുവോ?",
    "tl": "Ang sahod ba na nakasaad sa kontrata ay tumugma sa sahod na natanggap mo?"
  },
  "Did the worker receive any custody or employer property?": {
    "ur": "کیا کارکن کو کوئی تحویل یا آجر کی جائیداد ملی؟",
    "bn": "কর্মী কি কোনো হেফাজত বা নিয়োগকর্তার সম্পত্তি পেয়েছেন?",
    "id": "Apakah pekerja menerima hak asuh atau harta milik majikan?",
    "ml": "തൊഴിലാളിക്ക് എന്തെങ്കിലും കസ്റ്റഡിയോ തൊഴിലുടമയുടെ സ്വത്തോ ലഭിച്ചിട്ടുണ്ടോ?",
    "tl": "Nakatanggap ba ang manggagawa ng anumang kustodiya o pag-aari ng employer?"
  },
  "Did the worker receive one or more advances during employment?": {
    "ur": "کیا کارکن کو ملازمت کے دوران ایک یا زیادہ ایڈوانس ملے؟",
    "bn": "কর্মসংস্থানের সময় কর্মী কি এক বা একাধিক অগ্রিম পেয়েছেন?",
    "id": "Apakah pekerja menerima satu atau lebih uang muka selama bekerja?",
    "ml": "ജോലി സമയത്ത് തൊഴിലാളിക്ക് ഒന്നോ അതിലധികമോ അഡ്വാൻസ് ലഭിച്ചോ?",
    "tl": "Nakatanggap ba ang manggagawa ng isa o higit pang mga advance sa panahon ng trabaho?"
  },
  "Did the workplace change?": {
    "ur": "کیا کام کی جگہ بدل گئی؟",
    "bn": "কর্মক্ষেত্র কি পরিবর্তন হয়েছে?",
    "id": "Apakah tempat kerja berubah?",
    "ml": "ജോലിസ്ഥലം മാറിയോ?",
    "tl": "Nagbago ba ang lugar ng trabaho?"
  },
  "Did you agree to the change?": {
    "ur": "کیا آپ تبدیلی سے متفق تھے؟",
    "bn": "আপনি কি পরিবর্তনে রাজি ছিলেন?",
    "id": "Apakah Anda setuju dengan perubahan tersebut?",
    "ml": "മാറ്റത്തിന് നിങ്ങൾ സമ്മതിച്ചോ?",
    "tl": "Pumayag ka ba sa pagbabago?"
  },
  "Did you keep a copy of the notice?": {
    "ur": "کیا آپ نے نوٹس کی کاپی اپنے پاس رکھی؟",
    "bn": "আপনি কি নোটিশের একটি কপি রেখেছিলেন?",
    "id": "Apakah Anda menyimpan salinan pemberitahuan tersebut?",
    "ml": "നോട്ടീസിൻ്റെ പകർപ്പ് സൂക്ഷിച്ചിരുന്നോ?",
    "tl": "Nagtabi ka ba ng kopya ng notice?"
  },
  "Did you perform duties different from your job title?": {
    "ur": "کیا آپ نے اپنے کام کے عنوان سے مختلف فرائض انجام دیے؟",
    "bn": "আপনি কি আপনার কাজের শিরোনাম থেকে ভিন্ন দায়িত্ব পালন করেছেন?",
    "id": "Apakah Anda melakukan tugas yang berbeda dari jabatan Anda?",
    "ml": "നിങ്ങളുടെ ജോലി ശീർഷകത്തിൽ നിന്ന് വ്യത്യസ്തമായ ചുമതലകൾ നിങ്ങൾ നിർവഹിച്ചിട്ടുണ്ടോ?",
    "tl": "Ginawa mo ba ang mga tungkulin na naiiba sa iyong titulo sa trabaho?"
  },
  "Did you receive a copy of the clearance?": {
    "ur": "کیا آپ کو کلیئرنس کی کاپی موصول ہوئی؟",
    "bn": "আপনি কি ছাড়পত্রের একটি অনুলিপি পেয়েছেন?",
    "id": "Apakah Anda menerima salinan izinnya?",
    "ml": "അനുമതിയുടെ പകർപ്പ് നിങ്ങൾക്ക് ലഭിച്ചോ?",
    "tl": "Nakatanggap ka ba ng kopya ng clearance?"
  },
  "Did you receive a copy?": {
    "ur": "کیا آپ کو ایک کاپی موصول ہوئی؟",
    "bn": "আপনি একটি কপি পেয়েছেন?",
    "id": "Apakah Anda menerima salinannya?",
    "ml": "നിങ്ങൾക്ക് ഒരു കോപ്പി ലഭിച്ചോ?",
    "tl": "Nakatanggap ka ba ng kopya?"
  },
  "Did you receive a receipt or payment voucher?": {
    "ur": "کیا آپ کو رسید یا ادائیگی کا واؤچر ملا ہے؟",
    "bn": "আপনি কি একটি রসিদ বা পেমেন্ট ভাউচার পেয়েছেন?",
    "id": "Apakah Anda menerima tanda terima atau voucher pembayaran?",
    "ml": "നിങ്ങൾക്ക് ഒരു രസീതോ പേയ്‌മെൻ്റ് വൗച്ചറോ ലഭിച്ചോ?",
    "tl": "Nakatanggap ka ba ng resibo o voucher sa pagbabayad?"
  },
  "Did you receive a release or settlement?": {
    "ur": "کیا آپ کو رہائی ملی یا تصفیہ؟",
    "bn": "আপনি একটি মুক্তি বা নিষ্পত্তি পেয়েছেন?",
    "id": "Apakah Anda menerima pembebasan atau penyelesaian?",
    "ml": "നിങ്ങൾക്ക് ഒരു മോചനമോ സെറ്റിൽമെൻ്റോ ലഭിച്ചോ?",
    "tl": "Nakatanggap ka ba ng release o settlement?"
  },
  "Did you receive a signed copy?": {
    "ur": "کیا آپ کو دستخط شدہ کاپی موصول ہوئی ہے؟",
    "bn": "আপনি একটি স্বাক্ষরিত কপি পেয়েছেন?",
    "id": "Apakah Anda menerima salinan yang ditandatangani?",
    "ml": "നിങ്ങൾക്ക് ഒപ്പിട്ട ഒരു പകർപ്പ് ലഭിച്ചോ?",
    "tl": "Nakatanggap ka ba ng pinirmahang kopya?"
  },
  "Did you receive your annual leave?": {
    "ur": "کیا آپ کو اپنی سالانہ چھٹی ملی ہے؟",
    "bn": "আপনি কি আপনার বার্ষিক ছুটি পেয়েছেন?",
    "id": "Apakah Anda menerima cuti tahunan?",
    "ml": "നിങ്ങൾക്ക് വാർഷിക അവധി ലഭിച്ചോ?",
    "tl": "Natanggap mo ba ang iyong taunang bakasyon?"
  },
  "Did you sign a release or settlement?": {
    "ur": "کیا آپ نے رہائی یا تصفیہ پر دستخط کیے؟",
    "bn": "আপনি একটি মুক্তি বা নিষ্পত্তি স্বাক্ষরিত?",
    "id": "Apakah Anda menandatangani pembebasan atau penyelesaian?",
    "ml": "നിങ്ങൾ ഒരു റിലീസ് അല്ലെങ്കിൽ സെറ്റിൽമെൻ്റിൽ ഒപ്പുവെച്ചോ?",
    "tl": "Pumirma ka ba ng release o settlement?"
  },
  "Did you sign payroll receipt sheets?": {
    "ur": "کیا آپ نے پے رول کی رسید پر دستخط کیے ہیں؟",
    "bn": "আপনি কি বেতনের রসিদ শীটে স্বাক্ষর করেছেন?",
    "id": "Apakah Anda menandatangani lembar tanda terima gaji?",
    "ml": "നിങ്ങൾ ശമ്പള രസീത് ഷീറ്റുകളിൽ ഒപ്പിട്ടിട്ടുണ്ടോ?",
    "tl": "Pinirmahan mo ba ang mga payroll receipt sheets?"
  },
  "Did you sign payroll sheets?": {
    "ur": "کیا آپ نے پے رول شیٹس پر دستخط کیے ہیں؟",
    "bn": "আপনি বেতন শীটে স্বাক্ষর করেছেন?",
    "id": "Apakah Anda menandatangani lembar penggajian?",
    "ml": "നിങ്ങൾ പേറോൾ ഷീറ്റിൽ ഒപ്പിട്ടിട്ടുണ്ടോ?",
    "tl": "Pinirmahan mo ba ang mga payroll sheet?"
  },
  "Did you work hours beyond what was agreed?": {
    "ur": "کیا آپ نے طے شدہ وقت سے زیادہ کام کیا؟",
    "bn": "আপনি কি সম্মত হওয়ার বাইরে কাজ করেছেন?",
    "id": "Apakah Anda bekerja melebihi jam kerja yang disepakati?",
    "ml": "സമ്മതിച്ചതിലും കൂടുതൽ സമയം നിങ്ങൾ ജോലി ചെയ്തിട്ടുണ്ടോ?",
    "tl": "Nagtrabaho ka ba nang lampas sa napagkasunduan?"
  },
  "Did you work on the weekly rest day?": {
    "ur": "کیا آپ نے ہفتہ وار آرام کے دن کام کیا؟",
    "bn": "আপনি কি সাপ্তাহিক বিশ্রাম দিনে কাজ করেছেন?",
    "id": "Apakah Anda bekerja pada hari istirahat mingguan?",
    "ml": "പ്രതിവാര വിശ്രമ ദിനത്തിൽ നിങ്ങൾ ജോലി ചെയ്തിരുന്നോ?",
    "tl": "Nagtrabaho ka ba sa lingguhang araw ng pahinga?"
  },
  "Did you work overtime?": {
    "ur": "کیا آپ نے اوور ٹائم کام کیا؟",
    "bn": "আপনি কি ওভারটাইম কাজ করেছেন?",
    "id": "Apakah Anda bekerja lembur?",
    "ml": "നിങ്ങൾ ഓവർടൈം ജോലി ചെയ്തിരുന്നോ?",
    "tl": "Nag-overtime ka ba?"
  },
  "Direct supervisor name": {
    "ur": "براہ راست سپروائزر کا نام",
    "bn": "সরাসরি সুপারভাইজার নাম",
    "id": "Nama atasan langsung",
    "ml": "നേരിട്ടുള്ള സൂപ്പർവൈസർ പേര്",
    "tl": "Direktang pangalan ng superbisor"
  },
  "District": {
    "ur": "ضلع",
    "bn": "জেলা",
    "id": "Daerah",
    "ml": "ജില്ല",
    "tl": "Distrito"
  },
  "Do the Qiwa details match reality?": {
    "ur": "کیا Qiwa کی تفصیلات حقیقت سے ملتی ہیں؟",
    "bn": "Qiwa বিবরণ বাস্তবতা মেলে?",
    "id": "Apakah detail Qiwa sesuai dengan kenyataan?",
    "ml": "ക്വിവ വിശദാംശങ്ങൾ യാഥാർത്ഥ്യവുമായി പൊരുത്തപ്പെടുന്നുണ്ടോ?",
    "tl": "Tumutugma ba ang mga detalye ng Qiwa sa katotohanan?"
  },
  "Do you confirm the accuracy of the summary of data and facts above?": {
    "ur": "کیا آپ مندرجہ بالا اعداد و شمار اور حقائق کے خلاصے کی درستگی کی تصدیق کرتے ہیں؟",
    "bn": "আপনি কি উপরের তথ্য এবং তথ্যের সারাংশের নির্ভুলতা নিশ্চিত করেন?",
    "id": "Apakah Anda memastikan keakuratan rangkuman data dan fakta di atas?",
    "ml": "മുകളിലുള്ള ഡാറ്റയുടെയും വസ്തുതകളുടെയും സംഗ്രഹത്തിൻ്റെ കൃത്യത നിങ്ങൾ സ്ഥിരീകരിക്കുന്നുണ്ടോ?",
    "tl": "Kinukumpirma mo ba ang katumpakan ng buod ng data at mga katotohanan sa itaas?"
  },
  "Do you have a copy of the amendment or addendum?": {
    "ur": "کیا آپ کے پاس ترمیم یا ضمیمہ کی کاپی ہے؟",
    "bn": "আপনার কাছে সংশোধনী বা সংযোজনের একটি অনুলিপি আছে?",
    "id": "Apakah Anda memiliki salinan amandemen atau adendumnya?",
    "ml": "ഭേദഗതിയുടെയോ അനുബന്ധത്തിൻ്റെയോ പകർപ്പ് നിങ്ങളുടെ കൈവശമുണ്ടോ?",
    "tl": "Mayroon ka bang kopya ng pag-amyenda o addendum?"
  },
  "Do you have a copy of the contract?": {
    "ur": "کیا آپ کے پاس معاہدے کی کاپی ہے؟",
    "bn": "আপনার কাছে চুক্তির একটি অনুলিপি আছে?",
    "id": "Apakah Anda memiliki salinan kontraknya?",
    "ml": "കരാറിൻ്റെ പകർപ്പ് നിങ്ങളുടെ പക്കലുണ്ടോ?",
    "tl": "Mayroon ka bang kopya ng kontrata?"
  },
  "Do you have a copy of the objection or claim?": {
    "ur": "کیا آپ کے پاس اعتراض یا دعوے کی کاپی ہے؟",
    "bn": "আপনার কাছে আপত্তি বা দাবির একটি অনুলিপি আছে?",
    "id": "Apakah Anda memiliki salinan keberatan atau klaim tersebut?",
    "ml": "എതിർപ്പിൻ്റെയോ അവകാശവാദത്തിൻ്റെയോ പകർപ്പ് നിങ്ങളുടെ പക്കലുണ്ടോ?",
    "tl": "Mayroon ka bang kopya ng pagtutol o paghahabol?"
  },
  "Do you have a copy of the response?": {
    "ur": "کیا آپ کے پاس جواب کی کاپی ہے؟",
    "bn": "আপনি প্রতিক্রিয়া একটি কপি আছে?",
    "id": "Apakah Anda memiliki salinan tanggapannya?",
    "ml": "പ്രതികരണത്തിൻ്റെ പകർപ്പ് നിങ്ങളുടെ പക്കലുണ്ടോ?",
    "tl": "Mayroon ka bang kopya ng tugon?"
  },
  "Do you have copies or photos?": {
    "ur": "کیا آپ کے پاس کاپیاں یا تصاویر ہیں؟",
    "bn": "আপনার কি কপি বা ফটো আছে?",
    "id": "Apakah Anda memiliki salinan atau foto?",
    "ml": "നിങ്ങൾക്ക് പകർപ്പുകളോ ഫോട്ടോകളോ ഉണ്ടോ?",
    "tl": "Mayroon ka bang mga kopya o larawan?"
  },
  "Do you have proof of the change?": {
    "ur": "کیا آپ کے پاس تبدیلی کا ثبوت ہے؟",
    "bn": "আপনার কি পরিবর্তনের প্রমাণ আছে?",
    "id": "Apakah Anda punya bukti perubahannya?",
    "ml": "മാറ്റത്തിന് നിങ്ങളുടെ പക്കൽ തെളിവുണ്ടോ?",
    "tl": "Mayroon ka bang patunay ng pagbabago?"
  },
  "Do you keep copies of them?": {
    "ur": "کیا آپ ان کی کاپیاں رکھتے ہیں؟",
    "bn": "আপনি কি তাদের কপি রাখেন?",
    "id": "Apakah Anda menyimpan salinannya?",
    "ml": "നിങ്ങൾ അവയുടെ പകർപ്പുകൾ സൂക്ഷിക്കുന്നുണ്ടോ?",
    "tl": "Nag-iingat ka ba ng mga kopya ng mga ito?"
  },
  "Document number (optional)": {
    "ur": "دستاویز نمبر (اختیاری)",
    "bn": "নথি নম্বর (ঐচ্ছিক)",
    "id": "Nomor dokumen (opsional)",
    "ml": "പ്രമാണ നമ്പർ (ഓപ്ഷണൽ)",
    "tl": "Numero ng dokumento (opsyonal)"
  },
  "Documents": {
    "ur": "دستاویزات",
    "bn": "নথিপত্র",
    "id": "Dokumen",
    "ml": "പ്രമാണങ്ങൾ",
    "tl": "Mga dokumento"
  },
  "Draft reference": {
    "ur": "مسودہ حوالہ",
    "bn": "খসড়া রেফারেন্স",
    "id": "Referensi draf",
    "ml": "ഡ്രാഫ്റ്റ് റഫറൻസ്",
    "tl": "Draft reference"
  },
  "Drag a file here or click to choose": {
    "ur": "فائل کو یہاں گھسیٹیں یا منتخب کرنے کے لیے کلک کریں۔",
    "bn": "এখানে একটি ফাইল টেনে আনুন বা বেছে নিতে ক্লিক করুন",
    "id": "Seret file ke sini atau klik untuk memilih",
    "ml": "ഒരു ഫയൽ ഇവിടെ വലിച്ചിടുക അല്ലെങ്കിൽ തിരഞ്ഞെടുക്കാൻ ക്ലിക്ക് ചെയ്യുക",
    "tl": "Mag-drag ng file dito o i-click para pumili"
  },
  "Email address": {
    "ur": "ای میل ایڈریس",
    "bn": "ইমেইল ঠিকানা",
    "id": "Alamat email",
    "ml": "ഇമെയിൽ വിലാസം",
    "tl": "Email address"
  },
  "Email address is required.": {
    "ur": "ای میل ایڈریس درکار ہے۔",
    "bn": "ইমেল ঠিকানা প্রয়োজন.",
    "id": "Alamat email diperlukan.",
    "ml": "ഇമെയിൽ വിലാസം ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang email address."
  },
  "Employer": {
    "ur": "آجر",
    "bn": "নিয়োগকর্তা",
    "id": "Pemberi pekerjaan",
    "ml": "തൊഴിലുടമ",
    "tl": "Employer"
  },
  "Employer Summary": {
    "ur": "آجر کا خلاصہ",
    "bn": "নিয়োগকর্তার সারাংশ",
    "id": "Ringkasan Perusahaan",
    "ml": "തൊഴിലുടമയുടെ സംഗ്രഹം",
    "tl": "Buod ng Employer"
  },
  "Employer data": {
    "ur": "آجر کا ڈیٹا",
    "bn": "নিয়োগকর্তার তথ্য",
    "id": "Data pemberi kerja",
    "ml": "തൊഴിലുടമയുടെ ഡാറ്റ",
    "tl": "Data ng employer"
  },
  "End of the Employment Relationship": {
    "ur": "ملازمت کے تعلقات کا خاتمہ",
    "bn": "কর্মসংস্থান সম্পর্কের সমাপ্তি",
    "id": "Akhir dari Hubungan Kerja",
    "ml": "തൊഴിൽ ബന്ധത്തിൻ്റെ അവസാനം",
    "tl": "Pagtatapos ng Relasyon sa Pagtatrabaho"
  },
  "Ended": {
    "ur": "ختم ہوا۔",
    "bn": "শেষ হয়েছে",
    "id": "Berakhir",
    "ml": "അവസാനിച്ചു",
    "tl": "Natapos na"
  },
  "Establishment name": {
    "ur": "اسٹیبلشمنٹ کا نام",
    "bn": "প্রতিষ্ঠানের নাম",
    "id": "Nama pendirian",
    "ml": "സ്ഥാപനത്തിൻ്റെ പേര്",
    "tl": "Pangalan ng pagtatatag"
  },
  "Establishment name is required.": {
    "ur": "اسٹیبلشمنٹ کا نام درکار ہے۔",
    "bn": "প্রতিষ্ঠানের নাম প্রয়োজন।",
    "id": "Nama pendirian wajib diisi.",
    "ml": "സ്ഥാപനത്തിൻ്റെ പേര് ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang pangalan ng pagtatatag."
  },
  "Establishment phone": {
    "ur": "اسٹیبلشمنٹ کا فون",
    "bn": "প্রতিষ্ঠানের ফোন",
    "id": "Telepon pendirian",
    "ml": "സ്ഥാപന ഫോൺ",
    "tl": "Telepono ng pagtatatag"
  },
  "Establishment size": {
    "ur": "اسٹیبلشمنٹ کا سائز",
    "bn": "প্রতিষ্ঠার আকার",
    "id": "Ukuran pendirian",
    "ml": "സ്ഥാപന വലുപ്പം",
    "tl": "Laki ng pagtatatag"
  },
  "Establishment type": {
    "ur": "اسٹیبلشمنٹ کی قسم",
    "bn": "প্রতিষ্ঠার ধরন",
    "id": "Tipe pendirian",
    "ml": "സ്ഥാപന തരം",
    "tl": "Uri ng pagtatatag"
  },
  "Estimated value": {
    "ur": "تخمینی قیمت",
    "bn": "আনুমানিক মান",
    "id": "Nilai perkiraan",
    "ml": "കണക്കാക്കിയ മൂല്യം",
    "tl": "Tinantyang halaga"
  },
  "Example: Saudi": {
    "ur": "مثال: سعودی",
    "bn": "উদাহরণ: সৌদি",
    "id": "Contoh: Saudi",
    "ml": "ഉദാഹരണം: സൗദി",
    "tl": "Halimbawa: Saudi"
  },
  "Explain receipt method": {
    "ur": "رسید کا طریقہ بیان کریں۔",
    "bn": "প্রাপ্তি পদ্ধতি ব্যাখ্যা কর",
    "id": "Jelaskan metode penerimaan",
    "ml": "രസീത് രീതി വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang paraan ng pagtanggap"
  },
  "Explain the actual duties performed": {
    "ur": "ادا کیے گئے اصل فرائض کی وضاحت کریں۔",
    "bn": "সম্পাদিত প্রকৃত দায়িত্ব ব্যাখ্যা কর",
    "id": "Jelaskan tugas sebenarnya yang dilakukan",
    "ml": "നിർവഹിച്ച യഥാർത്ഥ ചുമതലകൾ വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang mga aktwal na tungkuling ginagampanan"
  },
  "Explain the additional assignments or duties": {
    "ur": "اضافی تفویض یا فرائض کی وضاحت کریں۔",
    "bn": "অতিরিক্ত দায়িত্ব বা দায়িত্ব ব্যাখ্যা করুন",
    "id": "Jelaskan tugas atau tugas tambahan",
    "ml": "അധിക ചുമതലകൾ അല്ലെങ്കിൽ ചുമതലകൾ വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang mga karagdagang takdang-aralin o tungkulin"
  },
  "Explain the aspects of non-compliance with the contract": {
    "ur": "معاہدے کی عدم تعمیل کے پہلوؤں کی وضاحت کریں۔",
    "bn": "চুক্তির সাথে অ-সম্মতির দিকগুলি ব্যাখ্যা করুন",
    "id": "Jelaskan aspek ketidakpatuhan terhadap kontrak",
    "ml": "കരാർ പാലിക്കാത്തതിൻ്റെ വശങ്ങൾ വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang mga aspeto ng hindi pagsunod sa kontrata"
  },
  "Explain the claim or deduction details.": {
    "ur": "دعویٰ یا کٹوتی کی تفصیلات بتائیں۔",
    "bn": "দাবি বা কর্তনের বিবরণ ব্যাখ্যা করুন।",
    "id": "Jelaskan rincian klaim atau pengurangan.",
    "ml": "ക്ലെയിം അല്ലെങ്കിൽ കിഴിവ് വിശദാംശങ്ങൾ വിശദീകരിക്കുക.",
    "tl": "Ipaliwanag ang mga detalye ng paghahabol o pagbabawas."
  },
  "Explain the difference between the actual wage and the wage registered in GOSI": {
    "ur": "GOSI میں رجسٹرڈ اصل اجرت اور اجرت کے درمیان فرق کی وضاحت کریں۔",
    "bn": "GOSI-তে নিবন্ধিত প্রকৃত মজুরি এবং মজুরির মধ্যে পার্থক্য ব্যাখ্যা কর",
    "id": "Jelaskan perbedaan antara upah sebenarnya dan upah yang tercatat di GOSI",
    "ml": "യഥാർത്ഥ വേതനവും GOSI-ൽ രജിസ്റ്റർ ചെയ്തിരിക്കുന്ന വേതനവും തമ്മിലുള്ള വ്യത്യാസം വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang pagkakaiba sa pagitan ng aktwal na sahod at sahod na nakarehistro sa GOSI"
  },
  "Explain the difference between the actual wage and the wage stated in the contract": {
    "ur": "معاہدے میں بیان کردہ اصل اجرت اور اجرت کے درمیان فرق کی وضاحت کریں۔",
    "bn": "চুক্তিতে বর্ণিত প্রকৃত মজুরি ও মজুরির মধ্যে পার্থক্য ব্যাখ্যা কর",
    "id": "Jelaskan perbedaan antara upah sebenarnya dan upah yang tercantum dalam kontrak",
    "ml": "യഥാർത്ഥ വേതനവും കരാറിൽ പറഞ്ഞിരിക്കുന്ന വേതനവും തമ്മിലുള്ള വ്യത്യാസം വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang pagkakaiba sa pagitan ng aktwal na sahod at sahod na nakasaad sa kontrata"
  },
  "Explain the threat or pressure incident": {
    "ur": "دھمکی یا دباؤ کے واقعے کی وضاحت کریں۔",
    "bn": "হুমকি বা চাপের ঘটনা ব্যাখ্যা করুন",
    "id": "Menjelaskan ancaman atau tekanan yang terjadi",
    "ml": "ഭീഷണി അല്ലെങ്കിൽ സമ്മർദ്ദ സംഭവം വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang banta o pressure incident"
  },
  "Explain the unpaid commissions, incentives, or allowances": {
    "ur": "بلا معاوضہ کمیشن، مراعات، یا الاؤنسز کی وضاحت کریں۔",
    "bn": "অবৈতনিক কমিশন, প্রণোদনা বা ভাতা ব্যাখ্যা করুন",
    "id": "Jelaskan komisi, insentif, atau tunjangan yang belum dibayar",
    "ml": "അടക്കാത്ത കമ്മീഷനുകൾ, പ്രോത്സാഹനങ്ങൾ അല്ലെങ്കിൽ അലവൻസുകൾ എന്നിവ വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang mga hindi nabayarang komisyon, insentibo, o allowance"
  },
  "Explain the work pattern and how the work was actually carried out": {
    "ur": "کام کے پیٹرن کی وضاحت کریں اور کام کو اصل میں کیسے انجام دیا گیا تھا۔",
    "bn": "কাজের ধরণ এবং কাজটি আসলে কীভাবে সম্পাদিত হয়েছিল তা ব্যাখ্যা করুন",
    "id": "Jelaskan pola kerja dan bagaimana pekerjaan itu sebenarnya dilakukan",
    "ml": "വർക്ക് പാറ്റേണും ജോലി യഥാർത്ഥത്തിൽ എങ്ങനെ നടത്തി എന്നതും വിശദീകരിക്കുക",
    "tl": "Ipaliwanag ang pattern ng trabaho at kung paano aktwal na isinagawa ang gawain"
  },
  "Explain which documents you were asked to sign without receiving a copy": {
    "ur": "وضاحت کریں کہ آپ سے کن دستاویزات پر کاپی حاصل کیے بغیر دستخط کرنے کو کہا گیا تھا۔",
    "bn": "কপি না পেয়ে আপনাকে কোন নথিতে স্বাক্ষর করতে বলা হয়েছে তা ব্যাখ্যা করুন",
    "id": "Jelaskan dokumen mana yang diminta untuk Anda tanda tangani tanpa menerima salinannya",
    "ml": "ഒരു പകർപ്പ് ലഭിക്കാതെ ഏതൊക്കെ രേഖകളിലാണ് നിങ്ങളോട് ഒപ്പിടാൻ ആവശ്യപ്പെട്ടതെന്ന് വിശദീകരിക്കുക",
    "tl": "Ipaliwanag kung aling mga dokumento ang hiniling sa iyo na lagdaan nang hindi nakakatanggap ng kopya"
  },
  "Facts and claims": {
    "ur": "حقائق اور دعوے",
    "bn": "তথ্য এবং দাবি",
    "id": "Fakta dan klaim",
    "ml": "വസ്തുതകളും അവകാശവാദങ്ങളും",
    "tl": "Mga katotohanan at claim"
  },
  "Failed to upload attachment.": {
    "ur": "منسلکہ اپ لوڈ کرنے میں ناکام۔",
    "bn": "সংযুক্তি আপলোড করতে ব্যর্থ হয়েছে.",
    "id": "Gagal mengunggah lampiran.",
    "ml": "അറ്റാച്ച്‌മെൻ്റ് അപ്‌ലോഡ് ചെയ്യാനായില്ല.",
    "tl": "Nabigong mag-upload ng attachment."
  },
  "Family name": {
    "ur": "خاندانی نام",
    "bn": "পরিবারের নাম",
    "id": "Nama keluarga",
    "ml": "കുടുംബ പേര്",
    "tl": "Pangalan ng pamilya"
  },
  "Family name is required.": {
    "ur": "خاندانی نام درکار ہے۔",
    "bn": "পরিবারের নাম প্রয়োজন।",
    "id": "Nama keluarga wajib diisi.",
    "ml": "കുടുംബപ്പേര് ആവശ്യമാണ്.",
    "tl": "Kailangan ang pangalan ng pamilya."
  },
  "Father name": {
    "ur": "باپ کا نام",
    "bn": "পিতার নাম",
    "id": "Nama ayah",
    "ml": "അച്ഛൻ്റെ പേര്",
    "tl": "Pangalan ng ama"
  },
  "Father name is required.": {
    "ur": "والد کا نام درکار ہے۔",
    "bn": "পিতার নাম আবশ্যক।",
    "id": "Nama ayah wajib diisi.",
    "ml": "പിതാവിൻ്റെ പേര് ആവശ്യമാണ്.",
    "tl": "Pangalan ng ama ang kailangan."
  },
  "File Name": {
    "ur": "فائل کا نام",
    "bn": "ফাইলের নাম",
    "id": "Nama File",
    "ml": "ഫയലിന്റെ പേര്",
    "tl": "Pangalan ng File"
  },
  "Final Declaration and Submission": {
    "ur": "حتمی اعلان اور جمع کروانا",
    "bn": "চূড়ান্ত ঘোষণা এবং জমা",
    "id": "Deklarasi dan Penyerahan Akhir",
    "ml": "അന്തിമ പ്രഖ്യാപനവും സമർപ്പണവും",
    "tl": "Pangwakas na Pahayag at Pagsusumite"
  },
  "First deduction date": {
    "ur": "پہلی کٹوتی کی تاریخ",
    "bn": "প্রথম কাটানোর তারিখ",
    "id": "Tanggal pemotongan pertama",
    "ml": "ആദ്യ കിഴിവ് തീയതി",
    "tl": "Petsa ng unang pagbabawas"
  },
  "First name": {
    "ur": "پہلا نام",
    "bn": "প্রথম নাম",
    "id": "Nama depan",
    "ml": "പേരിന്റെ ആദ്യഭാഗം",
    "tl": "Pangalan"
  },
  "First name is required.": {
    "ur": "پہلا نام درکار ہے۔",
    "bn": "প্রথম নাম প্রয়োজন.",
    "id": "Nama depan wajib diisi.",
    "ml": "ആദ്യ നാമം ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang pangalan."
  },
  "From this page, you can resume the saved draft or go to the tracking page.": {
    "ur": "اس صفحہ سے، آپ محفوظ کردہ مسودے کو دوبارہ شروع کر سکتے ہیں یا ٹریکنگ صفحہ پر جا سکتے ہیں۔",
    "bn": "এই পৃষ্ঠা থেকে, আপনি সংরক্ষিত খসড়া পুনরায় শুরু করতে পারেন বা ট্র্যাকিং পৃষ্ঠায় যেতে পারেন৷",
    "id": "Dari halaman ini, Anda dapat melanjutkan draf yang disimpan atau membuka halaman pelacakan.",
    "ml": "ഈ പേജിൽ നിന്ന്, നിങ്ങൾക്ക് സംരക്ഷിച്ച ഡ്രാഫ്റ്റ് പുനരാരംഭിക്കാം അല്ലെങ്കിൽ ട്രാക്കിംഗ് പേജിലേക്ക് പോകാം.",
    "tl": "Mula sa page na ito, maaari mong ipagpatuloy ang naka-save na draft o pumunta sa tracking page."
  },
  "Go to Tracking Page": {
    "ur": "ٹریکنگ پیج پر جائیں۔",
    "bn": "ট্র্যাকিং পেজে যান",
    "id": "Buka Halaman Pelacakan",
    "ml": "ട്രാക്കിംഗ് പേജിലേക്ക് പോകുക",
    "tl": "Pumunta sa Tracking Page"
  },
  "Grandfather name": {
    "ur": "دادا کا نام",
    "bn": "দাদার নাম",
    "id": "Nama kakek",
    "ml": "മുത്തച്ഛൻ്റെ പേര്",
    "tl": "Pangalan ng lolo"
  },
  "HR or responsible contact": {
    "ur": "HR یا ذمہ دار رابطہ",
    "bn": "এইচআর বা দায়িত্বশীল যোগাযোগ",
    "id": "SDM atau kontak yang bertanggung jawab",
    "ml": "എച്ച്ആർ അല്ലെങ്കിൽ ഉത്തരവാദിത്തമുള്ള കോൺടാക്റ്റ്",
    "tl": "HR o responsableng contact"
  },
  "Has the employer claimed this advance or deducted any amount for it?": {
    "ur": "کیا آجر نے اس پیشگی کا دعویٰ کیا ہے یا اس کے لیے کوئی رقم کاٹی ہے؟",
    "bn": "নিয়োগকর্তা কি এই অগ্রিম দাবি করেছেন বা এর জন্য কোন পরিমাণ কেটেছেন?",
    "id": "Apakah pemberi kerja sudah mengklaim uang muka ini atau memotong sejumlah uang untuk itu?",
    "ml": "തൊഴിലുടമ ഈ അഡ്വാൻസ് ക്ലെയിം ചെയ്തിട്ടുണ്ടോ അല്ലെങ്കിൽ അതിനായി എന്തെങ്കിലും തുക കുറച്ചിട്ടുണ്ടോ?",
    "tl": "Na-claim ba ng employer ang advance na ito o ibinawas ang anumang halaga para dito?"
  },
  "Has the employer claimed this custody or deducted any amount for it?": {
    "ur": "کیا آجر نے اس تحویل کا دعویٰ کیا ہے یا اس کے لیے کوئی رقم کاٹی ہے؟",
    "bn": "নিয়োগকর্তা কি এই হেফাজত দাবি করেছেন বা এর জন্য কোন পরিমাণ কেটেছেন?",
    "id": "Apakah majikan sudah mengklaim hak asuh ini atau memotong sejumlah uang untuk itu?",
    "ml": "തൊഴിലുടമ ഈ കസ്റ്റഡി ക്ലെയിം ചെയ്തിട്ടുണ്ടോ അല്ലെങ്കിൽ അതിനായി എന്തെങ്കിലും തുക കുറച്ചിട്ടുണ്ടോ?",
    "tl": "Inangkin ba ng employer ang kustodiya na ito o ibinawas ang anumang halaga para dito?"
  },
  "Have you previously sent any objection, claim, or complaint against the employer?": {
    "ur": "کیا آپ نے پہلے آجر کے خلاف کوئی اعتراض، دعویٰ یا شکایت بھیجی ہے؟",
    "bn": "আপনি কি আগে নিয়োগকর্তার বিরুদ্ধে কোনো আপত্তি, দাবি বা অভিযোগ পাঠিয়েছেন?",
    "id": "Pernahkah Anda mengajukan keberatan, tuntutan, atau pengaduan terhadap pemberi kerja sebelumnya?",
    "ml": "നിങ്ങൾ മുമ്പ് തൊഴിലുടമയ്‌ക്കെതിരെ എന്തെങ്കിലും എതിർപ്പ്, ക്ലെയിം അല്ലെങ്കിൽ പരാതി അയച്ചിട്ടുണ്ടോ?",
    "tl": "Nauna ka bang nagpadala ng anumang pagtutol, paghahabol, o reklamo laban sa employer?"
  },
  "Head office": {
    "ur": "ہیڈ آفس",
    "bn": "হেড অফিস",
    "id": "Kantor pusat",
    "ml": "ഹെഡ് ഓഫീസ്",
    "tl": "punong tanggapan"
  },
  "Hijri": {
    "ur": "ہجری",
    "bn": "হিজরি",
    "id": "Hijriah",
    "ml": "ഹിജ്രി",
    "tl": "Hijri"
  },
  "Housing allowance": {
    "ur": "ہاؤسنگ الاؤنس",
    "bn": "আবাসন ভাতা",
    "id": "Tunjangan perumahan",
    "ml": "ഭവന അലവൻസ്",
    "tl": "Allowance sa pabahay"
  },
  "How did you receive your salary?": {
    "ur": "آپ نے اپنی تنخواہ کیسے وصول کی؟",
    "bn": "আপনি আপনার বেতন কিভাবে পেয়েছেন?",
    "id": "Bagaimana Anda menerima gaji Anda?",
    "ml": "നിങ്ങളുടെ ശമ്പളം എങ്ങനെയാണ് ലഭിച്ചത്?",
    "tl": "Paano mo natanggap ang iyong suweldo?"
  },
  "How was the notice delivered?": {
    "ur": "نوٹس کیسے پہنچایا گیا؟",
    "bn": "কিভাবে নোটিশ বিতরণ করা হয়েছে?",
    "id": "Bagaimana pemberitahuan tersebut disampaikan?",
    "ml": "എങ്ങനെയാണ് നോട്ടീസ് നൽകിയത്?",
    "tl": "Paano naihatid ang paunawa?"
  },
  "I agree to the declaration.": {
    "ur": "میں اعلان سے اتفاق کرتا ہوں۔",
    "bn": "আমি ঘোষণার সাথে একমত।",
    "id": "Saya menyetujui deklarasi tersebut.",
    "ml": "ഞാൻ പ്രഖ്യാപനത്തോട് യോജിക്കുന്നു.",
    "tl": "Sumasang-ayon ako sa deklarasyon."
  },
  "I declare that all submitted data and documents are accurate to the best of my knowledge, that I reviewed the summary of data and facts and confirmed it fully or partially based on my selection, that I bear responsibility for any inaccurate or incomplete data, and that I agree to Wazin Law Firm and Legal Consultations reviewing the request and documents and contacting me when needed.": {
    "ur": "میں اعلان کرتا ہوں کہ جمع کرائے گئے تمام ڈیٹا اور دستاویزات میرے بہترین علم کے مطابق درست ہیں، کہ میں نے ڈیٹا اور حقائق کے خلاصے کا جائزہ لیا اور اپنے انتخاب کی بنیاد پر اس کی مکمل یا جزوی طور پر تصدیق کی، کہ میں کسی بھی غلط یا نامکمل ڈیٹا کی ذمہ داری قبول کرتا ہوں، اور یہ کہ میں درخواست اور دستاویزات کا جائزہ لینے اور ضرورت پڑنے پر مجھ سے رابطہ کرنے والی وازین لا فرم اور قانونی مشاورت سے اتفاق کرتا ہوں۔",
    "bn": "আমি ঘোষণা করছি যে সমস্ত জমা দেওয়া ডেটা এবং নথিগুলি আমার সর্বোত্তম জ্ঞান অনুসারে নির্ভুল, যে আমি ডেটা এবং তথ্যগুলির সারাংশ পর্যালোচনা করেছি এবং আমার নির্বাচনের ভিত্তিতে এটি সম্পূর্ণ বা আংশিকভাবে নিশ্চিত করেছি, যে কোনও ভুল বা অসম্পূর্ণ ডেটার জন্য আমি দায়বদ্ধ, এবং আমি অনুরোধ এবং নথিপত্রের পর্যালোচনা এবং আমার সাথে যোগাযোগ করার সময় ওয়াজিন ল ফার্ম এবং আইনি পরামর্শের সাথে সম্মত।",
    "id": "Saya menyatakan bahwa semua data dan dokumen yang diserahkan adalah akurat sepanjang pengetahuan saya, bahwa saya telah meninjau ringkasan data dan fakta dan mengonfirmasikannya seluruhnya atau sebagian berdasarkan pilihan saya, bahwa saya bertanggung jawab atas setiap data yang tidak akurat atau tidak lengkap, dan bahwa saya setuju dengan Firma Hukum dan Konsultasi Hukum Wazin untuk meninjau permintaan dan dokumen tersebut dan menghubungi saya bila diperlukan.",
    "ml": "സമർപ്പിച്ച എല്ലാ ഡാറ്റയും ഡോക്യുമെൻ്റുകളും എൻ്റെ അറിവിൻ്റെ പരമാവധി കൃത്യമാണെന്നും, ഡാറ്റയുടെയും വസ്തുതകളുടെയും സംഗ്രഹം ഞാൻ അവലോകനം ചെയ്യുകയും, എൻ്റെ തിരഞ്ഞെടുപ്പിനെ അടിസ്ഥാനമാക്കി പൂർണ്ണമായോ ഭാഗികമായോ സ്ഥിരീകരിച്ചിട്ടുണ്ടെന്നും, കൃത്യമല്ലാത്തതോ അപൂർണ്ണമോ ആയ ഏതെങ്കിലും ഡാറ്റയുടെ ഉത്തരവാദിത്തം ഞാൻ വഹിക്കുമെന്നും, അഭ്യർത്ഥനയും രേഖകളും പരിശോധിച്ച് എന്നെ ബന്ധപ്പെടുന്ന വസിൻ നിയമ സ്ഥാപനത്തിനും നിയമപരമായ കൺസൾട്ടേഷനുകൾക്കും ഞാൻ സമ്മതിക്കുന്നുവെന്നും ഞാൻ പ്രഖ്യാപിക്കുന്നു.",
    "tl": "Ipinapahayag ko na ang lahat ng isinumiteng data at mga dokumento ay tumpak sa abot ng aking kaalaman, na sinuri ko ang buod ng data at mga katotohanan at kinumpirma ko ito nang buo o bahagyang batay sa aking napili, na pananagutan ko ang anumang hindi tumpak o hindi kumpletong data, at na sumasang-ayon ako sa Wazin Law Firm at Legal na Konsultasyon na suriin ang kahilingan at mga dokumento at makipag-ugnayan sa akin kapag kinakailangan."
  },
  "Identity / document number": {
    "ur": "شناخت / دستاویز نمبر",
    "bn": "পরিচয়/ নথি নম্বর",
    "id": "Nomor identitas/dokumen",
    "ml": "ഐഡൻ്റിറ്റി / ഡോക്യുമെൻ്റ് നമ്പർ",
    "tl": "Numero ng pagkakakilanlan / dokumento"
  },
  "Identity type": {
    "ur": "شناخت کی قسم",
    "bn": "পরিচয়ের ধরন",
    "id": "Tipe identitas",
    "ml": "ഐഡൻ്റിറ്റി തരം",
    "tl": "Uri ng pagkakakilanlan"
  },
  "Identity type is required.": {
    "ur": "شناخت کی قسم درکار ہے۔",
    "bn": "পরিচয় টাইপ প্রয়োজন.",
    "id": "Jenis identitas wajib diisi.",
    "ml": "ഐഡൻ്റിറ്റി തരം ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang uri ng pagkakakilanlan."
  },
  "If the request has already been submitted and additional documents were requested, you can go to the tracking page and use the reference number and tracking token to upload the required files.": {
    "ur": "اگر درخواست پہلے ہی جمع کر دی گئی ہے اور اضافی دستاویزات کی درخواست کی گئی ہے، تو آپ ٹریکنگ صفحہ پر جا سکتے ہیں اور مطلوبہ فائلوں کو اپ لوڈ کرنے کے لیے حوالہ نمبر اور ٹریکنگ ٹوکن استعمال کر سکتے ہیں۔",
    "bn": "যদি অনুরোধটি ইতিমধ্যে জমা দেওয়া হয়ে থাকে এবং অতিরিক্ত নথির অনুরোধ করা হয়, আপনি ট্র্যাকিং পৃষ্ঠায় যেতে পারেন এবং প্রয়োজনীয় ফাইলগুলি আপলোড করতে রেফারেন্স নম্বর এবং ট্র্যাকিং টোকেন ব্যবহার করতে পারেন৷",
    "id": "Jika permintaan telah diajukan dan dokumen tambahan telah diminta, Anda dapat membuka halaman pelacakan dan menggunakan nomor referensi dan token pelacakan untuk mengunggah file yang diperlukan.",
    "ml": "അഭ്യർത്ഥന ഇതിനകം സമർപ്പിക്കുകയും അധിക രേഖകൾ അഭ്യർത്ഥിക്കുകയും ചെയ്തിട്ടുണ്ടെങ്കിൽ, നിങ്ങൾക്ക് ട്രാക്കിംഗ് പേജിലേക്ക് പോയി ആവശ്യമായ ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുന്നതിന് റഫറൻസ് നമ്പറും ട്രാക്കിംഗ് ടോക്കണും ഉപയോഗിക്കാം.",
    "tl": "Kung naisumite na ang kahilingan at hiniling ang mga karagdagang dokumento, maaari kang pumunta sa page ng pagsubaybay at gamitin ang reference number at tracking token para i-upload ang mga kinakailangang file."
  },
  "If the request was previously saved during completion, you can resume it from where you stopped or start a new request if needed.": {
    "ur": "اگر درخواست مکمل ہونے کے دوران پہلے محفوظ کی گئی تھی، تو آپ اسے وہیں سے دوبارہ شروع کر سکتے ہیں جہاں سے آپ نے روکا تھا یا ضرورت پڑنے پر نئی درخواست شروع کر سکتے ہیں۔",
    "bn": "যদি অনুরোধটি পূর্বে সমাপ্তির সময় সংরক্ষিত হয়ে থাকে, তাহলে আপনি যেখানে থামিয়েছিলেন সেখান থেকে এটি পুনরায় শুরু করতে পারেন বা প্রয়োজনে একটি নতুন অনুরোধ শুরু করতে পারেন।",
    "id": "Jika permintaan sebelumnya disimpan selama penyelesaian, Anda dapat melanjutkannya dari tempat Anda berhenti atau memulai permintaan baru jika diperlukan.",
    "ml": "പൂർത്തിയാകുമ്പോൾ അഭ്യർത്ഥന മുമ്പ് സംരക്ഷിച്ചിട്ടുണ്ടെങ്കിൽ, നിങ്ങൾ നിർത്തിയിടത്ത് നിന്ന് അത് പുനരാരംഭിക്കാം അല്ലെങ്കിൽ ആവശ്യമെങ്കിൽ ഒരു പുതിയ അഭ്യർത്ഥന ആരംഭിക്കാം.",
    "tl": "Kung dati nang na-save ang kahilingan sa panahon ng pagkumpleto, maaari mo itong ipagpatuloy kung saan ka huminto o magsimula ng bagong kahilingan kung kinakailangan."
  },
  "If the work terms changed during the relationship, only the relevant follow-up questions will appear to evaluate their legal impact.": {
    "ur": "اگر تعلقات کے دوران کام کی شرائط بدل جاتی ہیں، تو صرف متعلقہ فالو اپ سوالات ہی ان کے قانونی اثرات کا جائزہ لیتے نظر آئیں گے۔",
    "bn": "সম্পর্কের সময় কাজের শর্তাবলী পরিবর্তিত হলে, শুধুমাত্র প্রাসঙ্গিক ফলো-আপ প্রশ্নগুলি তাদের আইনি প্রভাবের মূল্যায়ন করতে উপস্থিত হবে।",
    "id": "Jika persyaratan kerja berubah selama hubungan, hanya pertanyaan lanjutan yang relevan yang akan muncul untuk mengevaluasi dampak hukumnya.",
    "ml": "ബന്ധത്തിനിടയിൽ തൊഴിൽ നിബന്ധനകൾ മാറിയെങ്കിൽ, അവയുടെ നിയമപരമായ സ്വാധീനം വിലയിരുത്തുന്നതിന് പ്രസക്തമായ ഫോളോ-അപ്പ് ചോദ്യങ്ങൾ മാത്രമേ ദൃശ്യമാകൂ.",
    "tl": "Kung nagbago ang mga tuntunin sa trabaho sa panahon ng relasyon, ang mga nauugnay na follow-up na tanong lang ang lalabas upang suriin ang kanilang legal na epekto."
  },
  "If there was a difference, what do you believe caused it?": {
    "ur": "اگر کوئی فرق تھا تو آپ کے خیال میں اس کی وجہ کیا ہے؟",
    "bn": "যদি একটি পার্থক্য ছিল, তাহলে আপনি কি বিশ্বাস করেন যে এটি ঘটেছে?",
    "id": "Jika ada perbedaan, menurut Anda apa penyebabnya?",
    "ml": "ഒരു വ്യത്യാസമുണ്ടെങ്കിൽ, അതിന് കാരണമായത് എന്താണെന്ന് നിങ്ങൾ വിശ്വസിക്കുന്നു?",
    "tl": "Kung nagkaroon ng pagkakaiba, ano sa palagay mo ang sanhi nito?"
  },
  "Incentives": {
    "ur": "مراعات",
    "bn": "প্রণোদনা",
    "id": "Insentif",
    "ml": "പ്രോത്സാഹനങ്ങൾ",
    "tl": "Mga insentibo"
  },
  "Includes devices, vehicles, equipment, work tools, or cash entrusted to the employee.": {
    "ur": "آلات، گاڑیاں، سامان، کام کے اوزار، یا ملازم کو سونپے گئے نقد شامل ہیں۔",
    "bn": "ডিভাইস, যানবাহন, সরঞ্জাম, কাজের সরঞ্জাম, বা কর্মচারীর কাছে অর্পিত নগদ অন্তর্ভুক্ত।",
    "id": "Meliputi perangkat, kendaraan, perlengkapan, perkakas kerja, atau uang tunai yang dipercayakan kepada karyawan.",
    "ml": "ഉപകരണങ്ങൾ, വാഹനങ്ങൾ, ഉപകരണങ്ങൾ, ജോലി ഉപകരണങ്ങൾ, അല്ലെങ്കിൽ ജീവനക്കാരനെ ഏൽപ്പിച്ച പണം എന്നിവ ഉൾപ്പെടുന്നു.",
    "tl": "Kasama ang mga device, sasakyan, kagamitan, work tool, o cash na ipinagkatiwala sa empleyado."
  },
  "Indicators that help establish the relationship as an employment relationship": {
    "ur": "اشارے جو تعلقات کو روزگار کے تعلقات کے طور پر قائم کرنے میں مدد کرتے ہیں۔",
    "bn": "যে সূচকগুলি একটি কর্মসংস্থান সম্পর্ক হিসাবে সম্পর্ক স্থাপন করতে সাহায্য করে",
    "id": "Indikator yang membantu menjalin hubungan sebagai hubungan kerja",
    "ml": "ഒരു തൊഴിൽ ബന്ധമായി ബന്ധം സ്ഥാപിക്കാൻ സഹായിക്കുന്ന സൂചകങ്ങൾ",
    "tl": "Mga tagapagpahiwatig na tumutulong sa pagtatatag ng relasyon bilang isang relasyon sa trabaho"
  },
  "Initial Analysis of Potential Claims": {
    "ur": "ممکنہ دعووں کا ابتدائی تجزیہ",
    "bn": "সম্ভাব্য দাবির প্রাথমিক বিশ্লেষণ",
    "id": "Analisis Awal Potensi Klaim",
    "ml": "സാധ്യതയുള്ള ക്ലെയിമുകളുടെ പ്രാരംഭ വിശകലനം",
    "tl": "Paunang Pagsusuri ng Mga Potensyal na Claim"
  },
  "Is any amount still with you?": {
    "ur": "کیا اب بھی آپ کے پاس کوئی رقم ہے؟",
    "bn": "কোন পরিমাণ এখনও আপনার কাছে আছে?",
    "id": "Apakah ada jumlah yang masih ada pada Anda?",
    "ml": "എന്തെങ്കിലും തുക ഇപ്പോഴും നിങ്ങളുടെ പക്കലുണ്ടോ?",
    "tl": "May halaga pa ba sa iyo?"
  },
  "Is the contract documented in Qiwa?": {
    "ur": "کیا معاہدہ Qiwa میں دستاویزی ہے؟",
    "bn": "চুক্তি কি কিওয়াতে নথিভুক্ত?",
    "id": "Apakah kontraknya didokumentasikan di Qiwa?",
    "ml": "ക്വിവയിൽ കരാർ രേഖപ്പെടുത്തിയിട്ടുണ്ടോ?",
    "tl": "Nakadokumento ba ang kontrata sa Qiwa?"
  },
  "Is the contract fixed-term or indefinite?": {
    "ur": "کیا معاہدہ معینہ مدت کا ہے یا غیر معینہ مدت کا؟",
    "bn": "চুক্তি কি নির্দিষ্ট মেয়াদী বা অনির্দিষ্টকালের?",
    "id": "Apakah kontraknya berjangka waktu tetap atau tidak terbatas?",
    "ml": "കരാർ നിശ്ചിത കാലയളവാണോ അനിശ്ചിതകാലമാണോ?",
    "tl": "Ang kontrata ba ay fixed-term o indefinite?"
  },
  "Is the recorded job title correct?": {
    "ur": "کیا ریکارڈ شدہ ملازمت کا عنوان درست ہے؟",
    "bn": "রেকর্ড করা চাকরির শিরোনাম কি সঠিক?",
    "id": "Apakah jabatan yang dicatat sudah benar?",
    "ml": "രേഖപ്പെടുത്തിയ ജോലിയുടെ പേര് ശരിയാണോ?",
    "tl": "Tama ba ang naitalang titulo ng trabaho?"
  },
  "Is the recorded salary correct?": {
    "ur": "کیا ریکارڈ شدہ تنخواہ درست ہے؟",
    "bn": "রেকর্ডকৃত বেতন কি সঠিক?",
    "id": "Apakah gaji yang tercatat sudah benar?",
    "ml": "രേഖപ്പെടുത്തിയ ശമ്പളം ശരിയാണോ?",
    "tl": "Tama ba ang naitalang suweldo?"
  },
  "Is there medical insurance?": {
    "ur": "کیا میڈیکل انشورنس ہے؟",
    "bn": "চিকিৎসা বীমা আছে কি?",
    "id": "Apakah ada asuransi kesehatan?",
    "ml": "മെഡിക്കൽ ഇൻഷുറൻസ് ഉണ്ടോ?",
    "tl": "Mayroon bang segurong medikal?"
  },
  "Is there proof?": {
    "ur": "کیا ثبوت ہے؟",
    "bn": "প্রমাণ আছে?",
    "id": "Apakah ada buktinya?",
    "ml": "തെളിവുണ്ടോ?",
    "tl": "May patunay ba?"
  },
  "Is there remaining leave balance?": {
    "ur": "کیا چھٹی کا توازن باقی ہے؟",
    "bn": "বাকি আছে ছুটি ব্যালেন্স?",
    "id": "Apakah masih ada sisa cuti?",
    "ml": "ലീവ് ബാലൻസ് ബാക്കിയുണ്ടോ?",
    "tl": "Mayroon bang natitirang balanse sa bakasyon?"
  },
  "Issued by": {
    "ur": "جاری کردہ",
    "bn": "দ্বারা জারি",
    "id": "Dikeluarkan oleh",
    "ml": "പുറപ്പെടുവിച്ചത്",
    "tl": "Inilabas ni"
  },
  "It can be obtained from GOSI and shows the contribution periods and the registered wage.": {
    "ur": "یہ GOSI سے حاصل کیا جا سکتا ہے اور شراکت کی مدت اور رجسٹرڈ اجرت کو ظاہر کرتا ہے۔",
    "bn": "এটি GOSI থেকে পাওয়া যেতে পারে এবং অবদানের সময়কাল এবং নিবন্ধিত মজুরি দেখায়।",
    "id": "Ini dapat diperoleh dari GOSI dan menunjukkan periode iuran dan upah yang terdaftar.",
    "ml": "ഇത് GOSI-യിൽ നിന്ന് ലഭിക്കും കൂടാതെ സംഭാവന കാലയളവുകളും രജിസ്റ്റർ ചെയ്ത വേതനവും കാണിക്കുന്നു.",
    "tl": "Maaari itong makuha mula sa GOSI at ipinapakita ang mga panahon ng kontribusyon at ang nakarehistrong sahod."
  },
  "It may also be referred to as: periods and wages statement or GOSI printout.": {
    "ur": "اسے بھی کہا جا سکتا ہے: مدت اور اجرت کا بیان یا GOSI پرنٹ آؤٹ۔",
    "bn": "এটিকেও উল্লেখ করা যেতে পারে: মেয়াদ এবং মজুরি বিবৃতি বা GOSI প্রিন্টআউট।",
    "id": "Ini juga dapat disebut sebagai: laporan periode dan gaji atau cetakan GOSI.",
    "ml": "ഇതിനെ ഇങ്ങനെയും പരാമർശിക്കാം: പിരീഡുകളും വേജസ് സ്റ്റേറ്റ്‌മെൻ്റ് അല്ലെങ്കിൽ GOSI പ്രിൻ്റൗട്ട്.",
    "tl": "Maaari rin itong tukuyin bilang: periods and wages statement o GOSI printout."
  },
  "Job title": {
    "ur": "ملازمت کا عنوان",
    "bn": "চাকরির শিরোনাম",
    "id": "Judul pekerjaan",
    "ml": "തൊഴില് പേര്",
    "tl": "Pamagat ng trabaho"
  },
  "Job title changed": {
    "ur": "ملازمت کا عنوان بدل گیا۔",
    "bn": "চাকরির শিরোনাম পরিবর্তন হয়েছে",
    "id": "Judul pekerjaan berubah",
    "ml": "ജോലിയുടെ പേര് മാറ്റി",
    "tl": "Binago ang titulo ng trabaho"
  },
  "Job title is required.": {
    "ur": "ملازمت کا عنوان درکار ہے۔",
    "bn": "কাজের শিরোনাম প্রয়োজন.",
    "id": "Judul pekerjaan diperlukan.",
    "ml": "ജോലിയുടെ പേര് ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang titulo ng trabaho."
  },
  "Labor Cases Portal": {
    "ur": "لیبر کیسز پورٹل",
    "bn": "লেবার কেস পোর্টাল",
    "id": "Portal Kasus Perburuhan",
    "ml": "ലേബർ കേസുകൾ പോർട്ടൽ",
    "tl": "Portal ng mga Kaso sa Paggawa"
  },
  "Last deduction date (optional)": {
    "ur": "آخری کٹوتی کی تاریخ (اختیاری)",
    "bn": "শেষ কাটানোর তারিখ (ঐচ্ছিক)",
    "id": "Tanggal pemotongan terakhir (opsional)",
    "ml": "അവസാന കിഴിവ് തീയതി (ഓപ്ഷണൽ)",
    "tl": "Petsa ng huling pagbabawas (opsyonal)"
  },
  "Last saved": {
    "ur": "آخری محفوظ",
    "bn": "সর্বশেষ সংরক্ষিত",
    "id": "Terakhir disimpan",
    "ml": "അവസാനം സംരക്ഷിച്ചത്",
    "tl": "Huling na-save"
  },
  "Last working day": {
    "ur": "کام کا آخری دن",
    "bn": "শেষ কাজের দিন",
    "id": "Hari kerja terakhir",
    "ml": "അവസാന പ്രവൃത്തി ദിവസം",
    "tl": "Huling araw ng trabaho"
  },
  "Last working day is required.": {
    "ur": "آخری کام کا دن درکار ہے۔",
    "bn": "শেষ কাজের দিন প্রয়োজন।",
    "id": "Hari kerja terakhir wajib diisi.",
    "ml": "അവസാന പ്രവൃത്തി ദിവസം ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang huling araw ng trabaho."
  },
  "Leave, Rest Days, and Overtime": {
    "ur": "چھٹی، آرام کے دن اور اوور ٹائم",
    "bn": "ছুটি, বিশ্রামের দিন এবং ওভারটাইম",
    "id": "Cuti, Hari Istirahat, dan Lembur",
    "ml": "ലീവ്, വിശ്രമ ദിനങ്ങൾ, ഓവർടൈം",
    "tl": "Pag-alis, Araw ng Pahinga, at Overtime"
  },
  "License date": {
    "ur": "لائسنس کی تاریخ",
    "bn": "লাইসেন্সের তারিখ",
    "id": "Tanggal lisensi",
    "ml": "ലൈസൻസ് തീയതി",
    "tl": "Petsa ng lisensya"
  },
  "License details (if available)": {
    "ur": "لائسنس کی تفصیلات (اگر دستیاب ہو)",
    "bn": "লাইসেন্সের বিশদ বিবরণ (যদি পাওয়া যায়)",
    "id": "Detail lisensi (jika tersedia)",
    "ml": "ലൈസൻസ് വിശദാംശങ്ങൾ (ലഭ്യമെങ്കിൽ)",
    "tl": "Mga detalye ng lisensya (kung available)"
  },
  "License number": {
    "ur": "لائسنس نمبر",
    "bn": "লাইসেন্স নম্বর",
    "id": "Nomor lisensi",
    "ml": "ലൈസൻസ് നമ്പർ",
    "tl": "Numero ng lisensya"
  },
  "Material Changes During the Employment Relationship": {
    "ur": "ملازمت کے تعلقات کے دوران مادی تبدیلیاں",
    "bn": "কর্মসংস্থান সম্পর্কের সময় উপাদান পরিবর্তন",
    "id": "Perubahan Material Selama Hubungan Kerja",
    "ml": "തൊഴിൽ ബന്ധത്തിനിടയിലെ മെറ്റീരിയൽ മാറ്റങ്ങൾ",
    "tl": "Mga Materyal na Pagbabago sa Panahon ng Relasyon sa Pagtatrabaho"
  },
  "Mentioned Documents and Evidence": {
    "ur": "ذکر شدہ دستاویزات اور ثبوت",
    "bn": "উল্লেখিত নথি এবং প্রমাণ",
    "id": "Dokumen dan Bukti yang Disebutkan",
    "ml": "സൂചിപ്പിച്ച രേഖകളും തെളിവുകളും",
    "tl": "Mga Binanggit na Dokumento at Ebidensya"
  },
  "Mobile": {
    "ur": "موبائل",
    "bn": "মোবাইল",
    "id": "Seluler",
    "ml": "മൊബൈൽ",
    "tl": "Mobile"
  },
  "Mobile number": {
    "ur": "موبائل نمبر",
    "bn": "মোবাইল নম্বর",
    "id": "Nomor ponsel",
    "ml": "മൊബൈൽ നമ്പർ",
    "tl": "Numero ng mobile"
  },
  "Mobile number is required.": {
    "ur": "موبائل نمبر درکار ہے۔",
    "bn": "মোবাইল নম্বর প্রয়োজন।",
    "id": "Nomor ponsel diperlukan.",
    "ml": "മൊബൈൽ നമ്പർ ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang mobile number."
  },
  "Mobility allowance": {
    "ur": "نقل و حرکت الاؤنس",
    "bn": "গতিশীলতা ভাতা",
    "id": "Tunjangan mobilitas",
    "ml": "മൊബിലിറ്റി അലവൻസ്",
    "tl": "Mobility allowance"
  },
  "National Address": {
    "ur": "قومی خطاب",
    "bn": "জাতীয় ঠিকানা",
    "id": "Alamat Nasional",
    "ml": "ദേശീയ വിലാസം",
    "tl": "Pambansang Address"
  },
  "Nationality": {
    "ur": "قومیت",
    "bn": "জাতীয়তা",
    "id": "Kebangsaan",
    "ml": "ദേശീയത",
    "tl": "Nasyonalidad"
  },
  "Nationality is required.": {
    "ur": "قومیت درکار ہے۔",
    "bn": "জাতীয়তা প্রয়োজন।",
    "id": "Kebangsaan diperlukan.",
    "ml": "ദേശീയത ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang nasyonalidad."
  },
  "Nature of duties changed": {
    "ur": "فرائض کی نوعیت بدل گئی۔",
    "bn": "দায়িত্বের ধরন বদলেছে",
    "id": "Sifat tugas berubah",
    "ml": "ചുമതലകളുടെ സ്വഭാവം മാറി",
    "tl": "Ang kalikasan ng mga tungkulin ay nagbago"
  },
  "Nature-of-work allowance": {
    "ur": "کام کی نوعیت کا الاؤنس",
    "bn": "কাজের প্রকৃতি-ভাতা",
    "id": "Tunjangan sifat pekerjaan",
    "ml": "ജോലിയുടെ സ്വഭാവ അലവൻസ്",
    "tl": "Nature-of-work allowance"
  },
  "Needs completion": {
    "ur": "تکمیل کی ضرورت ہے۔",
    "bn": "পূর্ণতা প্রয়োজন",
    "id": "Perlu penyelesaian",
    "ml": "പൂർത്തീകരണം ആവശ്യമാണ്",
    "tl": "Kailangan ng pagkumpleto"
  },
  "Next": {
    "ur": "اگلا",
    "bn": "পরবর্তী",
    "id": "Berikutnya",
    "ml": "അടുത്തത്",
    "tl": "Susunod"
  },
  "No attachments have been added yet": {
    "ur": "ابھی تک کوئی منسلکات شامل نہیں کیے گئے ہیں۔",
    "bn": "কোনো সংযুক্তি এখনো যোগ করা হয়নি",
    "id": "Belum ada lampiran yang ditambahkan",
    "ml": "ഇതുവരെ അറ്റാച്ച്‌മെൻ്റുകളൊന്നും ചേർത്തിട്ടില്ല",
    "tl": "Wala pang mga attachment na naidagdag"
  },
  "No claims were specified at this stage.": {
    "ur": "اس مرحلے پر کسی دعوے کی وضاحت نہیں کی گئی۔",
    "bn": "এই পর্যায়ে কোন দাবি নির্দিষ্ট করা হয়নি.",
    "id": "Tidak ada klaim yang ditentukan pada tahap ini.",
    "ml": "ഈ ഘട്ടത്തിൽ ക്ലെയിമുകളൊന്നും വ്യക്തമാക്കിയിട്ടില്ല.",
    "tl": "Walang tinukoy na claim sa yugtong ito."
  },
  "No contract or proof of employment relationship appears in the request yet.": {
    "ur": "درخواست میں ابھی تک کوئی معاہدہ یا ملازمت کے تعلق کا ثبوت ظاہر نہیں ہوتا ہے۔",
    "bn": "কোন চুক্তি বা কর্মসংস্থান সম্পর্কের প্রমাণ এখনও অনুরোধে উপস্থিত হয় না।",
    "id": "Belum ada kontrak atau bukti hubungan kerja yang muncul dalam permintaan.",
    "ml": "അഭ്യർത്ഥനയിൽ ഇതുവരെ കരാറോ തൊഴിൽ ബന്ധത്തിൻ്റെ തെളിവോ ദൃശ്യമായിട്ടില്ല.",
    "tl": "Wala pang lumalabas na kontrata o patunay ng relasyon sa trabaho sa kahilingan."
  },
  "No documents or evidence have been clearly identified yet.": {
    "ur": "ابھی تک کسی دستاویز یا ثبوت کی واضح طور پر شناخت نہیں ہو سکی ہے۔",
    "bn": "কোন নথি বা প্রমাণ এখনও স্পষ্টভাবে চিহ্নিত করা হয়নি.",
    "id": "Belum ada dokumen atau bukti yang teridentifikasi secara jelas.",
    "ml": "രേഖകളോ തെളിവുകളോ ഇതുവരെ വ്യക്തമായിട്ടില്ല.",
    "tl": "Wala pang mga dokumento o ebidensya na malinaw na natukoy."
  },
  "No obvious gaps appear at this stage other than what may arise during review.": {
    "ur": "جائزے کے دوران پیدا ہونے والی چیزوں کے علاوہ اس مرحلے پر کوئی واضح خلا نظر نہیں آتا ہے۔",
    "bn": "পর্যালোচনার সময় যা হতে পারে তা ছাড়া এই পর্যায়ে কোন সুস্পষ্ট ফাঁক দেখা যায় না।",
    "id": "Tidak ada kesenjangan nyata yang muncul pada tahap ini selain apa yang mungkin timbul selama peninjauan.",
    "ml": "അവലോകന വേളയിൽ ഉണ്ടാകാവുന്നതല്ലാതെ ഈ ഘട്ടത്തിൽ വ്യക്തമായ വിടവുകളൊന്നും ദൃശ്യമാകില്ല.",
    "tl": "Walang nakikitang gaps sa yugtong ito maliban sa kung ano ang maaaring lumabas sa panahon ng pagsusuri."
  },
  "No saved draft currently exists": {
    "ur": "کوئی محفوظ کردہ مسودہ فی الحال موجود نہیں ہے۔",
    "bn": "বর্তমানে কোনো সংরক্ষিত খসড়া নেই",
    "id": "Saat ini tidak ada draf tersimpan",
    "ml": "സംരക്ഷിച്ച ഡ്രാഫ്റ്റൊന്നും നിലവിൽ നിലവിലില്ല",
    "tl": "Walang naka-save na draft sa kasalukuyan"
  },
  "No supporting attachment for overtime work appears yet.": {
    "ur": "اوور ٹائم کام کے لیے کوئی معاون منسلکہ ابھی تک ظاہر نہیں ہوتا ہے۔",
    "bn": "ওভারটাইম কাজের জন্য কোন সমর্থনকারী সংযুক্তি এখনও প্রদর্শিত হয় না.",
    "id": "Belum muncul lampiran pendukung kerja lembur.",
    "ml": "ഓവർടൈം ജോലിക്ക് പിന്തുണ നൽകുന്ന അറ്റാച്ച്‌മെൻ്റുകളൊന്നും ഇതുവരെ ദൃശ്യമാകുന്നില്ല.",
    "tl": "Wala pang lumalabas na pansuportang attachment para sa overtime na trabaho."
  },
  "No visible gaps": {
    "ur": "کوئی نظر آنے والا خلا نہیں ہے۔",
    "bn": "কোন দৃশ্যমান ফাঁক নেই",
    "id": "Tidak ada celah yang terlihat",
    "ml": "ദൃശ്യമായ വിടവുകളൊന്നുമില്ല",
    "tl": "Walang nakikitang gaps"
  },
  "Not available": {
    "ur": "دستیاب نہیں۔",
    "bn": "পাওয়া যায় না",
    "id": "Tidak tersedia",
    "ml": "ലഭ്യമല്ല",
    "tl": "Hindi available"
  },
  "Not entered yet": {
    "ur": "ابھی داخل نہیں ہوا۔",
    "bn": "এখনো ঢোকেনি",
    "id": "Belum masuk",
    "ml": "ഇതുവരെ പ്രവേശിച്ചിട്ടില്ല",
    "tl": "Hindi pa nakapasok"
  },
  "Not specified": {
    "ur": "متعین نہیں ہے۔",
    "bn": "উল্লেখ করা হয়নি",
    "id": "Tidak ditentukan",
    "ml": "വ്യക്തമാക്കിയിട്ടില്ല",
    "tl": "Hindi tinukoy"
  },
  "Notice date": {
    "ur": "نوٹس کی تاریخ",
    "bn": "নোটিশ তারিখ",
    "id": "Tanggal pemberitahuan",
    "ml": "അറിയിപ്പ് തീയതി",
    "tl": "Petsa ng paunawa"
  },
  "Notice date is required.": {
    "ur": "نوٹس کی تاریخ درکار ہے۔",
    "bn": "নোটিশ তারিখ প্রয়োজন.",
    "id": "Tanggal pemberitahuan wajib diisi.",
    "ml": "അറിയിപ്പ് തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng paunawa."
  },
  "Number of unpaid wages": {
    "ur": "غیر ادا شدہ اجرتوں کی تعداد",
    "bn": "অপরিশোধিত মজুরির সংখ্যা",
    "id": "Jumlah gaji yang belum dibayar",
    "ml": "നൽകാത്ത വേതനങ്ങളുടെ എണ്ണം",
    "tl": "Bilang ng hindi nababayarang sahod"
  },
  "Official and organizational employer details needed to identify the establishment in dispute.": {
    "ur": "تنازع میں اسٹیبلشمنٹ کی شناخت کے لیے سرکاری اور تنظیمی آجر کی تفصیلات درکار ہیں۔",
    "bn": "সরকারী এবং সাংগঠনিক নিয়োগকর্তার বিশদ বিবরণ বিবাদে থাকা প্রতিষ্ঠানটিকে চিহ্নিত করার জন্য প্রয়োজন।",
    "id": "Rincian resmi dan organisasi pemberi kerja diperlukan untuk mengidentifikasi perusahaan yang disengketakan.",
    "ml": "തർക്കത്തിലുള്ള സ്ഥാപനം തിരിച്ചറിയാൻ ഔദ്യോഗികവും സംഘടനാപരവുമായ തൊഴിലുടമ വിശദാംശങ്ങൾ ആവശ്യമാണ്.",
    "tl": "Mga detalye ng opisyal at organisasyonal na tagapag-empleyo na kailangan upang matukoy ang pagtatalo sa pagtatalo."
  },
  "Official data type": {
    "ur": "سرکاری ڈیٹا کی قسم",
    "bn": "অফিসিয়াল ডেটা টাইপ",
    "id": "Tipe data resmi",
    "ml": "ഔദ്യോഗിക ഡാറ്റ തരം",
    "tl": "Opisyal na uri ng data"
  },
  "Official email": {
    "ur": "سرکاری ای میل",
    "bn": "অফিসিয়াল ইমেইল",
    "id": "Email resmi",
    "ml": "ഔദ്യോഗിക ഇമെയിൽ",
    "tl": "Opisyal na email"
  },
  "Official establishment data": {
    "ur": "سرکاری اسٹیبلشمنٹ ڈیٹا",
    "bn": "সরকারী সংস্থার তথ্য",
    "id": "Data pendirian resmi",
    "ml": "ഔദ്യോഗിക സ്ഥാപന ഡാറ്റ",
    "tl": "Data ng opisyal na pagtatatag"
  },
  "Open Tracking Page": {
    "ur": "ٹریکنگ پیج کھولیں۔",
    "bn": "ট্র্যাকিং পৃষ্ঠা খুলুন",
    "id": "Buka Halaman Pelacakan",
    "ml": "ട്രാക്കിംഗ് പേജ് തുറക്കുക",
    "tl": "Buksan ang Tracking Page"
  },
  "Other": {
    "ur": "دیگر",
    "bn": "অন্যান্য",
    "id": "Lainnya",
    "ml": "മറ്റുള്ളവ",
    "tl": "Iba pa"
  },
  "Periodic bonuses": {
    "ur": "متواتر بونس",
    "bn": "পর্যায়ক্রমিক বোনাস",
    "id": "Bonus berkala",
    "ml": "ആനുകാലിക ബോണസുകൾ",
    "tl": "Mga pana-panahong bonus"
  },
  "Physical custody return status": {
    "ur": "جسمانی حراستی واپسی کی حیثیت",
    "bn": "শারীরিক হেফাজত ফেরত অবস্থা",
    "id": "Status pengembalian hak asuh fisik",
    "ml": "ശാരീരിക കസ്റ്റഡി റിട്ടേൺ നില",
    "tl": "Katayuan ng pagbabalik ng pisikal na pag-iingat"
  },
  "Please briefly explain the main issue.": {
    "ur": "برائے مہربانی مختصراً اصل مسئلہ بیان فرمائیں۔",
    "bn": "মূল সমস্যাটি সংক্ষেপে ব্যাখ্যা করুন।",
    "id": "Tolong jelaskan secara singkat masalah utamanya.",
    "ml": "പ്രധാന പ്രശ്നം ഹ്രസ്വമായി വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag nang maikli ang pangunahing isyu."
  },
  "Please choose at least one file.": {
    "ur": "براہ کرم کم از کم ایک فائل منتخب کریں۔",
    "bn": "অন্তত একটি ফাইল চয়ন করুন.",
    "id": "Silakan pilih setidaknya satu file.",
    "ml": "ദയവായി ഒരു ഫയലെങ്കിലും തിരഞ്ഞെടുക്കുക.",
    "tl": "Mangyaring pumili ng hindi bababa sa isang file."
  },
  "Please choose the attachment type.": {
    "ur": "براہ کرم منسلکہ کی قسم منتخب کریں۔",
    "bn": "সংযুক্তি প্রকার নির্বাচন করুন.",
    "id": "Silakan pilih jenis lampiran.",
    "ml": "അറ്റാച്ച്മെൻ്റ് തരം തിരഞ്ഞെടുക്കുക.",
    "tl": "Pakipili ang uri ng attachment."
  },
  "Please choose the summary confirmation status.": {
    "ur": "براہ کرم خلاصہ کی تصدیق کی حیثیت کا انتخاب کریں۔",
    "bn": "সারাংশ নিশ্চিতকরণ স্থিতি চয়ন করুন.",
    "id": "Silakan pilih status konfirmasi ringkasan.",
    "ml": "സംഗ്രഹ സ്ഥിരീകരണ നില തിരഞ്ഞെടുക്കുക.",
    "tl": "Mangyaring piliin ang katayuan ng pagkumpirma ng buod."
  },
  "Please describe the information you want to correct or clarify.": {
    "ur": "براہ کرم اس معلومات کی وضاحت کریں جسے آپ درست یا واضح کرنا چاہتے ہیں۔",
    "bn": "আপনি যে তথ্য সংশোধন বা স্পষ্ট করতে চান তা বর্ণনা করুন।",
    "id": "Silakan jelaskan informasi yang ingin Anda koreksi atau klarifikasi.",
    "ml": "നിങ്ങൾ തിരുത്താനോ വ്യക്തമാക്കാനോ ആഗ്രഹിക്കുന്ന വിവരങ്ങൾ ദയവായി വിവരിക്കുക.",
    "tl": "Pakilarawan ang impormasyong gusto mong itama o linawin."
  },
  "Please enter a valid Saudi mobile number starting with 05.": {
    "ur": "براہ کرم 05 سے شروع ہونے والا ایک درست سعودی موبائل نمبر درج کریں۔",
    "bn": "05 দিয়ে শুরু হওয়া একটি বৈধ সৌদি মোবাইল নম্বর লিখুন।",
    "id": "Silakan masukkan nomor ponsel Saudi yang valid dimulai dengan 05.",
    "ml": "05-ൽ ആരംഭിക്കുന്ന സാധുവായ സൗദി മൊബൈൽ നമ്പർ നൽകുക.",
    "tl": "Mangyaring magpasok ng wastong numero ng mobile sa Saudi na nagsisimula sa 05."
  },
  "Please enter at least one commission with its description, entitlement period, and amount.": {
    "ur": "براہ کرم اس کی تفصیل، استحقاق کی مدت اور رقم کے ساتھ کم از کم ایک کمیشن درج کریں۔",
    "bn": "অনুগ্রহ করে তার বিবরণ, এনটাইটেলমেন্ট সময়কাল এবং পরিমাণ সহ অন্তত একটি কমিশন লিখুন।",
    "id": "Silakan masukkan setidaknya satu komisi dengan deskripsi, periode hak, dan jumlahnya.",
    "ml": "ഒരു കമ്മീഷനെങ്കിലും അതിൻ്റെ വിവരണം, അവകാശ കാലയളവ്, തുക എന്നിവ നൽകുക.",
    "tl": "Mangyaring magpasok ng hindi bababa sa isang komisyon kasama ang paglalarawan nito, panahon ng karapatan, at halaga."
  },
  "Please enter at least one delayed wage period with its wage value.": {
    "ur": "براہ کرم کم از کم ایک تاخیری اجرت کی مدت اس کی اجرت کی قیمت کے ساتھ درج کریں۔",
    "bn": "অনুগ্রহ করে কমপক্ষে একটি বিলম্বিত মজুরি সময়কাল তার মজুরি মূল্য সহ লিখুন।",
    "id": "Silakan masukkan setidaknya satu periode upah tertunda dengan nilai upahnya.",
    "ml": "ദയവായി ഒരു വൈകിയ വേതന കാലയളവെങ്കിലും അതിൻ്റെ വേതന മൂല്യത്തോടൊപ്പം നൽകുക.",
    "tl": "Mangyaring maglagay ng hindi bababa sa isang naantalang panahon ng sahod kasama ang halaga ng sahod nito."
  },
  "Please enter at least one leave balance with its daily wage.": {
    "ur": "براہ کرم اس کی یومیہ اجرت کے ساتھ کم از کم ایک چھٹی کا بیلنس درج کریں۔",
    "bn": "অনুগ্রহ করে তার দৈনিক মজুরির সাথে অন্তত একটি ছুটির ব্যালেন্স লিখুন।",
    "id": "Silakan masukkan setidaknya satu saldo cuti dengan gaji hariannya.",
    "ml": "അതിൻ്റെ പ്രതിദിന വേതനത്തിനൊപ്പം കുറഞ്ഞത് ഒരു ലീവ് ബാലൻസെങ്കിലും നൽകുക.",
    "tl": "Mangyaring magpasok ng hindi bababa sa isang balanse sa leave kasama ang pang-araw-araw na sahod nito."
  },
  "Please enter the number.": {
    "ur": "براہ کرم نمبر درج کریں۔",
    "bn": "নম্বর লিখুন.",
    "id": "Silakan masukkan nomornya.",
    "ml": "ദയവായി നമ്പർ നൽകുക.",
    "tl": "Pakilagay ang numero."
  },
  "Please explain how the employer failed to comply with the contract.": {
    "ur": "براہ کرم وضاحت کریں کہ آجر معاہدے کی تعمیل کرنے میں کیسے ناکام رہا۔",
    "bn": "অনুগ্রহ করে ব্যাখ্যা করুন কিভাবে নিয়োগকর্তা চুক্তি মেনে চলতে ব্যর্থ হন।",
    "id": "Tolong jelaskan bagaimana majikan gagal mematuhi kontrak.",
    "ml": "തൊഴിൽ ദാതാവ് കരാർ പാലിക്കുന്നതിൽ പരാജയപ്പെട്ടത് എങ്ങനെയെന്ന് വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag kung paano nabigo ang employer na sumunod sa kontrata."
  },
  "Please explain the actual duties.": {
    "ur": "براہ کرم اصل فرائض کی وضاحت کریں۔",
    "bn": "প্রকৃত কর্তব্য ব্যাখ্যা করুন.",
    "id": "Tolong jelaskan tugas sebenarnya.",
    "ml": "യഥാർത്ഥ ചുമതലകൾ ദയവായി വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag ang mga aktwal na tungkulin."
  },
  "Please explain the additional assignments.": {
    "ur": "براہ کرم اضافی اسائنمنٹس کی وضاحت کریں۔",
    "bn": "অতিরিক্ত অ্যাসাইনমেন্ট ব্যাখ্যা করুন.",
    "id": "Tolong jelaskan tugas tambahannya.",
    "ml": "അധിക അസൈൻമെൻ്റുകൾ വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag ang mga karagdagang takdang-aralin."
  },
  "Please explain the difference between the actual wage and the wage registered in GOSI.": {
    "ur": "براہ کرم اصل اجرت اور GOSI میں رجسٹرڈ اجرت کے درمیان فرق کی وضاحت کریں۔",
    "bn": "অনুগ্রহ করে প্রকৃত মজুরি এবং GOSI-তে নিবন্ধিত মজুরির মধ্যে পার্থক্য ব্যাখ্যা করুন।",
    "id": "Mohon penjelasan perbedaan antara upah sebenarnya dan upah yang terdaftar di GOSI.",
    "ml": "യഥാർത്ഥ വേതനവും GOSI-ൽ രജിസ്റ്റർ ചെയ്തിരിക്കുന്ന വേതനവും തമ്മിലുള്ള വ്യത്യാസം ദയവായി വിശദീകരിക്കുക.",
    "tl": "Mangyaring ipaliwanag ang pagkakaiba sa pagitan ng aktwal na sahod at sahod na nakarehistro sa GOSI."
  },
  "Please explain the difference between the actual wage and the wage stated in the contract.": {
    "ur": "براہ کرم اصل اجرت اور معاہدے میں بیان کردہ اجرت کے درمیان فرق کی وضاحت کریں۔",
    "bn": "অনুগ্রহ করে প্রকৃত মজুরি এবং চুক্তিতে বর্ণিত মজুরির মধ্যে পার্থক্য ব্যাখ্যা করুন৷",
    "id": "Tolong jelaskan perbedaan antara upah sebenarnya dan upah yang tercantum dalam kontrak.",
    "ml": "യഥാർത്ഥ വേതനവും കരാറിൽ പറഞ്ഞിരിക്കുന്ന വേതനവും തമ്മിലുള്ള വ്യത്യാസം ദയവായി വിശദീകരിക്കുക.",
    "tl": "Mangyaring ipaliwanag ang pagkakaiba sa pagitan ng aktwal na sahod at sahod na nakasaad sa kontrata."
  },
  "Please explain the threat or pressure incident.": {
    "ur": "براہ کرم دھمکی یا دباؤ والے واقعے کی وضاحت کریں۔",
    "bn": "হুমকি বা চাপ ঘটনা ব্যাখ্যা করুন.",
    "id": "Mohon penjelasan mengenai kejadian ancaman atau tekanan tersebut.",
    "ml": "ഭീഷണിയോ സമ്മർദമോ ആയ സംഭവം വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag ang insidente ng pagbabanta o panggigipit."
  },
  "Please explain the unpaid commissions, incentives, or allowances.": {
    "ur": "براہ کرم بلا معاوضہ کمیشن، مراعات، یا الاؤنسز کی وضاحت کریں۔",
    "bn": "অনুগ্রহ করে অবৈতনিক কমিশন, প্রণোদনা বা ভাতা ব্যাখ্যা করুন।",
    "id": "Mohon jelaskan komisi, insentif, atau tunjangan yang belum dibayar.",
    "ml": "അടയ്ക്കാത്ത കമ്മീഷനുകൾ, ഇൻസെൻ്റീവുകൾ അല്ലെങ്കിൽ അലവൻസുകൾ എന്നിവ വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag ang mga hindi nabayarang komisyon, insentibo, o allowance."
  },
  "Please explain the work pattern.": {
    "ur": "براہ کرم کام کے انداز کی وضاحت کریں۔",
    "bn": "কাজের প্যাটার্ন ব্যাখ্যা করুন.",
    "id": "Tolong jelaskan pola kerjanya.",
    "ml": "വർക്ക് പാറ്റേൺ വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag ang pattern ng trabaho."
  },
  "Please explain which documents you were asked to sign without receiving a copy.": {
    "ur": "براہ کرم وضاحت کریں کہ آپ سے کن دستاویزات پر کاپی حاصل کیے بغیر دستخط کرنے کو کہا گیا تھا۔",
    "bn": "অনুগ্রহ করে ব্যাখ্যা করুন যে কোন নথিতে আপনাকে একটি অনুলিপি না পেয়ে স্বাক্ষর করতে বলা হয়েছে৷",
    "id": "Tolong jelaskan dokumen mana yang diminta untuk Anda tanda tangani tanpa menerima salinannya.",
    "ml": "ഒരു പകർപ്പ് ലഭിക്കാതെ ഏതൊക്കെ രേഖകളിലാണ് ഒപ്പിടാൻ നിങ്ങളോട് ആവശ്യപ്പെട്ടതെന്ന് ദയവായി വിശദീകരിക്കുക.",
    "tl": "Pakipaliwanag kung aling mga dokumento ang hiniling sa iyo na lagdaan nang hindi nakakatanggap ng kopya."
  },
  "Please keep this link private and do not share it except with the request owner. It opens the client tracking page and displays only the request status without any internal notes.": {
    "ur": "براہ کرم اس لنک کو نجی رکھیں اور درخواست کے مالک کے علاوہ اس کا اشتراک نہ کریں۔ یہ کلائنٹ سے باخبر رہنے کا صفحہ کھولتا ہے اور بغیر کسی اندرونی نوٹس کے صرف درخواست کی حیثیت دکھاتا ہے۔",
    "bn": "অনুগ্রহ করে এই লিঙ্কটি ব্যক্তিগত রাখুন এবং অনুরোধের মালিক ছাড়া এটি শেয়ার করবেন না। এটি ক্লায়েন্ট ট্র্যাকিং পৃষ্ঠাটি খোলে এবং কোনও অভ্যন্তরীণ নোট ছাড়াই শুধুমাত্র অনুরোধের স্থিতি প্রদর্শন করে।",
    "id": "Harap jaga kerahasiaan tautan ini dan jangan membagikannya kecuali kepada pemilik permintaan. Ini membuka halaman pelacakan klien dan hanya menampilkan status permintaan tanpa catatan internal apa pun.",
    "ml": "ദയവായി ഈ ലിങ്ക് സ്വകാര്യമായി സൂക്ഷിക്കുക, അഭ്യർത്ഥന ഉടമയുമായി അല്ലാതെ ഇത് പങ്കിടരുത്. ഇത് ക്ലയൻ്റ് ട്രാക്കിംഗ് പേജ് തുറക്കുകയും ആന്തരിക കുറിപ്പുകളില്ലാതെ അഭ്യർത്ഥന നില മാത്രം പ്രദർശിപ്പിക്കുകയും ചെയ്യുന്നു.",
    "tl": "Mangyaring panatilihing pribado ang link na ito at huwag itong ibahagi maliban sa may-ari ng kahilingan. Binubuksan nito ang pahina ng pagsubaybay sa kliyente at ipinapakita lamang ang status ng kahilingan nang walang anumang panloob na tala."
  },
  "Please specify": {
    "ur": "براہ کرم وضاحت کریں۔",
    "bn": "উল্লেখ করুন",
    "id": "Silakan tentukan",
    "ml": "ദയവായി വ്യക്തമാക്കുക",
    "tl": "Mangyaring tukuyin"
  },
  "Please specify and describe the damage.": {
    "ur": "براہ کرم نقصان کی وضاحت اور وضاحت کریں۔",
    "bn": "উল্লেখ করুন এবং ক্ষতি বর্ণনা করুন.",
    "id": "Silakan tentukan dan jelaskan kerusakannya.",
    "ml": "കേടുപാടുകൾ വ്യക്തമാക്കുകയും വിവരിക്കുകയും ചെയ്യുക.",
    "tl": "Mangyaring tukuyin at ilarawan ang pinsala."
  },
  "Please specify how the notice was delivered.": {
    "ur": "براہ کرم وضاحت کریں کہ نوٹس کیسے پہنچایا گیا۔",
    "bn": "নোটিশ কিভাবে বিতরণ করা হয়েছে দয়া করে উল্লেখ করুন.",
    "id": "Silakan tentukan bagaimana pemberitahuan itu disampaikan.",
    "ml": "അറിയിപ്പ് എങ്ങനെയാണ് കൈമാറിയതെന്ന് വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin kung paano inihatid ang paunawa."
  },
  "Please specify the establishment type.": {
    "ur": "براہ کرم اسٹیبلشمنٹ کی قسم کی وضاحت کریں۔",
    "bn": "অনুগ্রহ করে প্রতিষ্ঠানের ধরন উল্লেখ করুন।",
    "id": "Silakan tentukan jenis pendiriannya.",
    "ml": "സ്ഥാപനത്തിൻ്റെ തരം വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang uri ng pagtatatag."
  },
  "Please specify the identity type.": {
    "ur": "براہ کرم شناخت کی قسم کی وضاحت کریں۔",
    "bn": "অনুগ্রহ করে পরিচয়ের ধরনটি উল্লেখ করুন।",
    "id": "Silakan tentukan jenis identitas.",
    "ml": "ഐഡൻ്റിറ്റി തരം വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang uri ng pagkakakilanlan."
  },
  "Please specify the other change.": {
    "ur": "براہ کرم دوسری تبدیلی کی وضاحت کریں۔",
    "bn": "অন্য পরিবর্তন উল্লেখ করুন.",
    "id": "Silakan tentukan perubahan lainnya.",
    "ml": "മറ്റ് മാറ്റം വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang iba pang pagbabago."
  },
  "Please specify the other evidence type.": {
    "ur": "براہ کرم ثبوت کی دوسری قسم کی وضاحت کریں۔",
    "bn": "অন্য প্রমাণ প্রকার উল্লেখ করুন.",
    "id": "Silakan tentukan jenis bukti lainnya.",
    "ml": "മറ്റ് തെളിവുകളുടെ തരം ദയവായി വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang iba pang uri ng ebidensya."
  },
  "Please specify the reason for ending the relationship.": {
    "ur": "رشتہ ختم کرنے کی وجہ بتائیں۔",
    "bn": "সম্পর্ক শেষ করার কারণ উল্লেখ করুন.",
    "id": "Silakan tentukan alasan untuk mengakhiri hubungan.",
    "ml": "ബന്ധം അവസാനിപ്പിക്കുന്നതിനുള്ള കാരണം വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang dahilan ng pagtatapos ng relasyon."
  },
  "Please specify the relationship or agreement type.": {
    "ur": "براہ کرم رشتہ یا معاہدے کی قسم کی وضاحت کریں۔",
    "bn": "সম্পর্ক বা চুক্তির ধরন উল্লেখ করুন.",
    "id": "Silakan tentukan jenis hubungan atau perjanjian.",
    "ml": "ബന്ധമോ കരാറിൻ്റെ തരമോ ദയവായി വ്യക്തമാക്കുക.",
    "tl": "Pakitukoy ang uri ng relasyon o kasunduan."
  },
  "Please specify the release format.": {
    "ur": "براہ کرم ریلیز فارمیٹ کی وضاحت کریں۔",
    "bn": "রিলিজ বিন্যাস উল্লেখ করুন.",
    "id": "Silakan tentukan format rilis.",
    "ml": "റിലീസ് ഫോർമാറ്റ് വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang format ng paglabas."
  },
  "Please specify the sector.": {
    "ur": "براہ کرم سیکٹر کی وضاحت کریں۔",
    "bn": "সেক্টর উল্লেখ করুন.",
    "id": "Silakan tentukan sektornya.",
    "ml": "സെക്ടർ വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang sektor."
  },
  "Please specify the submission method.": {
    "ur": "براہ کرم جمع کرانے کا طریقہ بتائیں۔",
    "bn": "দাখিল পদ্ধতি উল্লেখ করুন.",
    "id": "Silakan tentukan metode pengiriman.",
    "ml": "സമർപ്പിക്കൽ രീതി വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin ang paraan ng pagsusumite."
  },
  "Please specify what changed in the relationship.": {
    "ur": "براہ کرم وضاحت کریں کہ تعلقات میں کیا تبدیلی آئی ہے۔",
    "bn": "সম্পর্কের কি পরিবর্তন হয়েছে তা উল্লেখ করুন।",
    "id": "Silakan tentukan apa yang berubah dalam hubungan tersebut.",
    "ml": "ബന്ധത്തിൽ എന്ത് മാറ്റമുണ്ടായെന്ന് ദയവായി വ്യക്തമാക്കുക.",
    "tl": "Pakitukoy kung ano ang nagbago sa relasyon."
  },
  "Please specify when the release was signed.": {
    "ur": "براہ کرم وضاحت کریں کہ ریلیز پر کب دستخط کیے گئے تھے۔",
    "bn": "যখন রিলিজ স্বাক্ষরিত হয়েছিল দয়া করে উল্লেখ করুন.",
    "id": "Silakan tentukan kapan rilis tersebut ditandatangani.",
    "ml": "റിലീസ് എപ്പോഴാണ് ഒപ്പിട്ടതെന്ന് വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin kung kailan nilagdaan ang paglabas."
  },
  "Please specify whether you have a copy of the employer response.": {
    "ur": "براہ کرم واضح کریں کہ آیا آپ کے پاس آجر کے جواب کی کاپی ہے۔",
    "bn": "আপনার কাছে নিয়োগকর্তার প্রতিক্রিয়ার একটি অনুলিপি আছে কিনা তা উল্লেখ করুন।",
    "id": "Harap tentukan apakah Anda memiliki salinan tanggapan perusahaan.",
    "ml": "തൊഴിലുടമയുടെ പ്രതികരണത്തിൻ്റെ പകർപ്പ് നിങ്ങളുടെ പക്കലുണ്ടോയെന്ന് വ്യക്തമാക്കുക.",
    "tl": "Mangyaring tukuyin kung mayroon kang kopya ng tugon ng employer."
  },
  "Postal code": {
    "ur": "پوسٹل کوڈ",
    "bn": "পোস্টাল কোড",
    "id": "kode Pos",
    "ml": "തപാൽ കോഡ്",
    "tl": "Postal code"
  },
  "Potential claims": {
    "ur": "ممکنہ دعوے",
    "bn": "সম্ভাব্য দাবি",
    "id": "Klaim potensial",
    "ml": "സാധ്യതയുള്ള ക്ലെയിമുകൾ",
    "tl": "Mga potensyal na claim"
  },
  "Preferably describe the facts in chronological order and explain the issue briefly and clearly.": {
    "ur": "ترجیحی طور پر حقائق کو تاریخ کی ترتیب میں بیان کریں اور مسئلہ کو مختصر اور واضح طور پر بیان کریں۔",
    "bn": "ঘটনাগুলি কালানুক্রমিকভাবে বর্ণনা করুন এবং সমস্যাটি সংক্ষিপ্ত এবং স্পষ্টভাবে ব্যাখ্যা করুন।",
    "id": "Sebaiknya jelaskan fakta dalam urutan kronologis dan jelaskan masalahnya secara singkat dan jelas.",
    "ml": "വസ്‌തുതകൾ കാലക്രമത്തിൽ വിവരിക്കുകയും പ്രശ്‌നം ഹ്രസ്വമായും വ്യക്തമായും വിശദീകരിക്കുകയും ചെയ്യുന്നത് അഭികാമ്യമാണ്.",
    "tl": "Mas mainam na ilarawan ang mga katotohanan sa magkakasunod na pagkakasunud-sunod at ipaliwanag ang isyu nang maikli at malinaw."
  },
  "Preview": {
    "ur": "پیش نظارہ",
    "bn": "পূর্বরূপ",
    "id": "Pratinjau",
    "ml": "പ്രിവ്യൂ",
    "tl": "Silipin"
  },
  "Previous": {
    "ur": "پچھلا",
    "bn": "আগের",
    "id": "Sebelumnya",
    "ml": "മുമ്പത്തെ",
    "tl": "Nakaraang"
  },
  "Private Tracking Link": {
    "ur": "پرائیویٹ ٹریکنگ لنک",
    "bn": "ব্যক্তিগত ট্র্যাকিং লিঙ্ক",
    "id": "Tautan Pelacakan Pribadi",
    "ml": "സ്വകാര്യ ട്രാക്കിംഗ് ലിങ്ക്",
    "tl": "Pribadong Link sa Pagsubaybay"
  },
  "Probation period length": {
    "ur": "پروبیشن مدت کی لمبائی",
    "bn": "প্রবেশনকালের দৈর্ঘ্য",
    "id": "Lamanya masa percobaan",
    "ml": "പ്രൊബേഷൻ കാലയളവിൻ്റെ ദൈർഘ്യം",
    "tl": "Haba ng panahon ng pagsubok"
  },
  "Progress is saved automatically during completion so the request can be resumed later.": {
    "ur": "تکمیل کے دوران پیش رفت خود بخود محفوظ ہو جاتی ہے تاکہ درخواست کو بعد میں دوبارہ شروع کیا جا سکے۔",
    "bn": "সম্পূর্ণ হওয়ার সময় অগ্রগতি স্বয়ংক্রিয়ভাবে সংরক্ষিত হয় যাতে অনুরোধটি পরে আবার শুরু করা যায়।",
    "id": "Kemajuan disimpan secara otomatis selama penyelesaian sehingga permintaan dapat dilanjutkan nanti.",
    "ml": "പൂർത്തിയാകുമ്പോൾ പുരോഗതി സ്വയമേവ സംരക്ഷിക്കപ്പെടുന്നതിനാൽ അഭ്യർത്ഥന പിന്നീട് പുനരാരംഭിക്കാനാകും.",
    "tl": "Awtomatikong nai-save ang pag-unlad habang nakumpleto upang maipagpatuloy ang kahilingan sa ibang pagkakataon."
  },
  "Provide the final declaration of accuracy and approve submission to the Wazin team.": {
    "ur": "درستگی کا حتمی اعلان فراہم کریں اور وازین ٹیم کو جمع کرانے کی منظوری دیں۔",
    "bn": "সঠিকতার চূড়ান্ত ঘোষণা প্রদান করুন এবং ওয়াজিন দলকে জমা দেওয়ার অনুমোদন দিন।",
    "id": "Berikan pernyataan keakuratan akhir dan setujui penyerahannya kepada tim Wazin.",
    "ml": "കൃത്യതയുടെ അന്തിമ പ്രഖ്യാപനം നൽകുകയും വസിൻ ടീമിന് സമർപ്പിക്കൽ അംഗീകരിക്കുകയും ചെയ്യുക.",
    "tl": "Ibigay ang huling deklarasyon ng katumpakan at aprubahan ang pagsusumite sa Wazin team."
  },
  "Purpose of custody": {
    "ur": "حراست کا مقصد",
    "bn": "হেফাজতের উদ্দেশ্য",
    "id": "Tujuan penitipan",
    "ml": "കസ്റ്റഡിയുടെ ഉദ്ദേശ്യം",
    "tl": "Layunin ng pag-iingat"
  },
  "Ready to save": {
    "ur": "بچانے کے لیے تیار ہیں۔",
    "bn": "সংরক্ষণ করতে প্রস্তুত",
    "id": "Siap untuk menabung",
    "ml": "സംരക്ഷിക്കാൻ തയ്യാറാണ്",
    "tl": "Handa nang magtipid"
  },
  "Reason for ending the relationship": {
    "ur": "رشتہ ختم کرنے کی وجہ",
    "bn": "সম্পর্ক শেষ করার কারণ",
    "id": "Alasan untuk mengakhiri hubungan",
    "ml": "ബന്ധം അവസാനിപ്പിക്കാനുള്ള കാരണം",
    "tl": "Dahilan para tapusin ang relasyon"
  },
  "Reason for termination is required.": {
    "ur": "ختم کرنے کی وجہ درکار ہے۔",
    "bn": "অবসানের কারণ প্রয়োজন।",
    "id": "Alasan penghentian diperlukan.",
    "ml": "അവസാനിപ്പിക്കുന്നതിനുള്ള കാരണം ആവശ്യമാണ്.",
    "tl": "Ang dahilan para sa pagwawakas ay kinakailangan."
  },
  "Receipt date": {
    "ur": "رسید کی تاریخ",
    "bn": "প্রাপ্তির তারিখ",
    "id": "Tanggal penerimaan",
    "ml": "രസീത് തീയതി",
    "tl": "Petsa ng pagtanggap"
  },
  "Receipt method": {
    "ur": "رسید کا طریقہ",
    "bn": "প্রাপ্তি পদ্ধতি",
    "id": "Metode penerimaan",
    "ml": "രസീത് രീതി",
    "tl": "Paraan ng pagtanggap"
  },
  "Receipt record available?": {
    "ur": "کیا رسید کا ریکارڈ دستیاب ہے؟",
    "bn": "রসিদ রেকর্ড পাওয়া যায়?",
    "id": "Catatan tanda terima tersedia?",
    "ml": "രസീത് രേഖ ലഭ്യമാണോ?",
    "tl": "Available ang record ng resibo?"
  },
  "Receiver name": {
    "ur": "وصول کنندہ کا نام",
    "bn": "প্রাপকের নাম",
    "id": "Nama penerima",
    "ml": "സ്വീകർത്താവിൻ്റെ പേര്",
    "tl": "Pangalan ng tatanggap"
  },
  "Receiver position": {
    "ur": "وصول کنندہ کی پوزیشن",
    "bn": "রিসিভার অবস্থান",
    "id": "Posisi penerima",
    "ml": "റിസീവർ സ്ഥാനം",
    "tl": "Posisyon ng receiver"
  },
  "Record number (optional)": {
    "ur": "ریکارڈ نمبر (اختیاری)",
    "bn": "রেকর্ড নম্বর (ঐচ্ছিক)",
    "id": "Nomor rekaman (opsional)",
    "ml": "റെക്കോർഡ് നമ്പർ (ഓപ്ഷണൽ)",
    "tl": "Record number (opsyonal)"
  },
  "Reference Number": {
    "ur": "حوالہ نمبر",
    "bn": "রেফারেন্স নম্বর",
    "id": "Nomor Referensi",
    "ml": "റഫറൻസ് നമ്പർ",
    "tl": "Numero ng Sanggunian"
  },
  "Release signing date": {
    "ur": "ریلیز پر دستخط کرنے کی تاریخ",
    "bn": "রিলিজ স্বাক্ষর তারিখ",
    "id": "Tanggal penandatanganan rilis",
    "ml": "റിലീസ് സൈൻ ചെയ്യുന്ന തീയതി",
    "tl": "Petsa ng pagpirma ng release"
  },
  "Release signing date is required.": {
    "ur": "ریلیز پر دستخط کرنے کی تاریخ درکار ہے۔",
    "bn": "রিলিজ সাইনিং তারিখ প্রয়োজন.",
    "id": "Tanggal penandatanganan rilis wajib diisi.",
    "ml": "റിലീസ് സൈൻ ചെയ്യുന്ന തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng pagpirma ng release."
  },
  "Remaining amount": {
    "ur": "باقی رقم",
    "bn": "অবশিষ্ট পরিমাণ",
    "id": "Jumlah yang tersisa",
    "ml": "ബാക്കി തുക",
    "tl": "Natitirang halaga"
  },
  "Remove": {
    "ur": "ہٹا دیں۔",
    "bn": "সরান",
    "id": "Menghapus",
    "ml": "നീക്കം ചെയ്യുക",
    "tl": "Alisin"
  },
  "Repayment date": {
    "ur": "ادائیگی کی تاریخ",
    "bn": "পরিশোধের তারিখ",
    "id": "Tanggal pembayaran kembali",
    "ml": "തിരിച്ചടവ് തീയതി",
    "tl": "Petsa ng pagbabayad"
  },
  "Repayment method": {
    "ur": "ادائیگی کا طریقہ",
    "bn": "পরিশোধের পদ্ধতি",
    "id": "Metode pembayaran",
    "ml": "തിരിച്ചടവ് രീതി",
    "tl": "Paraan ng pagbabayad"
  },
  "Repayment status": {
    "ur": "ادائیگی کی حیثیت",
    "bn": "পরিশোধের অবস্থা",
    "id": "Status pembayaran kembali",
    "ml": "തിരിച്ചടവ് നില",
    "tl": "Katayuan ng pagbabayad"
  },
  "Request Form Stage": {
    "ur": "فارم اسٹیج کی درخواست کریں۔",
    "bn": "অনুরোধ ফর্ম পর্যায়",
    "id": "Tahap Formulir Permintaan",
    "ml": "അഭ്യർത്ഥന ഫോം ഘട്ടം",
    "tl": "Yugto ng Form ng Kahilingan"
  },
  "Request Workflow": {
    "ur": "ورک فلو کی درخواست کریں۔",
    "bn": "কর্মপ্রবাহের অনুরোধ করুন",
    "id": "Permintaan Alur Kerja",
    "ml": "വർക്ക്ഫ്ലോ അഭ്യർത്ഥിക്കുക",
    "tl": "Humiling ng Daloy ng Trabaho"
  },
  "Request completion status": {
    "ur": "تکمیل کی حیثیت کی درخواست کریں۔",
    "bn": "সমাপ্তির স্থিতির অনুরোধ করুন",
    "id": "Status penyelesaian permintaan",
    "ml": "പൂർത്തീകരണ നില അഭ്യർത്ഥിക്കുക",
    "tl": "Status ng pagkumpleto ng kahilingan"
  },
  "Resume Draft": {
    "ur": "ڈرافٹ دوبارہ شروع کریں۔",
    "bn": "খসড়া পুনরায় শুরু করুন",
    "id": "Lanjutkan Draf",
    "ml": "ഡ്രാഫ്റ്റ് പുനരാരംഭിക്കുക",
    "tl": "Ipagpatuloy ang Draft"
  },
  "Resume Request": {
    "ur": "دوبارہ شروع کرنے کی درخواست",
    "bn": "রিজিউম রিকোয়েস্ট",
    "id": "Lanjutkan Permintaan",
    "ml": "അഭ്യർത്ഥന പുനരാരംഭിക്കുക",
    "tl": "Ipagpatuloy ang Kahilingan"
  },
  "Resume a Saved Request": {
    "ur": "محفوظ کردہ درخواست دوبارہ شروع کریں۔",
    "bn": "একটি সংরক্ষিত অনুরোধ পুনরায় শুরু করুন",
    "id": "Lanjutkan Permintaan Tersimpan",
    "ml": "സംരക്ഷിച്ച ഒരു അഭ്യർത്ഥന പുനരാരംഭിക്കുക",
    "tl": "Ipagpatuloy ang Naka-save na Kahilingan"
  },
  "Return date": {
    "ur": "واپسی کی تاریخ",
    "bn": "ফেরার তারিখ",
    "id": "Tanggal kembali",
    "ml": "മടങ്ങിവരുന്ന തീയതി",
    "tl": "Petsa ng pagbabalik"
  },
  "Return record available?": {
    "ur": "واپسی کا ریکارڈ دستیاب ہے؟",
    "bn": "রিটার্ন রেকর্ড পাওয়া যায়?",
    "id": "Catatan pengembalian tersedia?",
    "ml": "റിട്ടേൺ റെക്കോർഡ് ലഭ്യമാണോ?",
    "tl": "Available ang rekord ng pagbabalik?"
  },
  "Review the summary of data and facts and confirm it before moving to attachments.": {
    "ur": "ڈیٹا اور حقائق کے خلاصے کا جائزہ لیں اور منسلکات پر جانے سے پہلے اس کی تصدیق کریں۔",
    "bn": "ডেটা এবং তথ্যের সারাংশ পর্যালোচনা করুন এবং সংযুক্তিতে যাওয়ার আগে এটি নিশ্চিত করুন।",
    "id": "Tinjau ringkasan data dan fakta dan konfirmasikan sebelum melanjutkan ke lampiran.",
    "ml": "ഡാറ്റയുടെയും വസ്തുതകളുടെയും സംഗ്രഹം അവലോകനം ചെയ്‌ത് അറ്റാച്ച്‌മെൻ്റുകളിലേക്ക് നീങ്ങുന്നതിന് മുമ്പ് അത് സ്ഥിരീകരിക്കുക.",
    "tl": "Suriin ang buod ng data at katotohanan at kumpirmahin ito bago lumipat sa mga attachment."
  },
  "Salary changed": {
    "ur": "تنخواہ بدل گئی۔",
    "bn": "বেতন পরিবর্তন হয়েছে",
    "id": "Gaji berubah",
    "ml": "ശമ്പളം മാറി",
    "tl": "Nagbago ang suweldo"
  },
  "Save Attachment": {
    "ur": "اٹیچمنٹ کو محفوظ کریں۔",
    "bn": "সংযুক্তি সংরক্ষণ করুন",
    "id": "Simpan Lampiran",
    "ml": "അറ്റാച്ച്മെൻ്റ് സംരക്ഷിക്കുക",
    "tl": "I-save ang Attachment"
  },
  "Save as Draft": {
    "ur": "ڈرافٹ کے طور پر محفوظ کریں۔",
    "bn": "খসড়া হিসাবে সংরক্ষণ করুন",
    "id": "Simpan sebagai Draf",
    "ml": "ഡ്രാഫ്റ്റായി സംരക്ഷിക്കുക",
    "tl": "I-save bilang Draft"
  },
  "Sector": {
    "ur": "سیکٹر",
    "bn": "সেক্টর",
    "id": "Sektor",
    "ml": "സെക്ടർ",
    "tl": "Sektor"
  },
  "Select attachment type": {
    "ur": "منسلکہ کی قسم منتخب کریں۔",
    "bn": "সংযুক্তির ধরন নির্বাচন করুন",
    "id": "Pilih jenis lampiran",
    "ml": "അറ്റാച്ച്മെൻ്റ് തരം തിരഞ്ഞെടുക്കുക",
    "tl": "Piliin ang uri ng attachment"
  },
  "Select client portal language": {
    "ur": "کلائنٹ پورٹل کی زبان منتخب کریں۔",
    "bn": "ক্লায়েন্ট পোর্টাল ভাষা নির্বাচন করুন",
    "id": "Pilih bahasa portal klien",
    "ml": "ക്ലയൻ്റ് പോർട്ടൽ ഭാഷ തിരഞ്ഞെടുക്കുക",
    "tl": "Piliin ang wika ng portal ng kliyente"
  },
  "Select custody type": {
    "ur": "تحویل کی قسم منتخب کریں۔",
    "bn": "হেফাজতের ধরন নির্বাচন করুন",
    "id": "Pilih jenis hak asuh",
    "ml": "കസ്റ്റഡി തരം തിരഞ്ഞെടുക്കുക",
    "tl": "Piliin ang uri ng pangangalaga"
  },
  "Select receipt method": {
    "ur": "رسید کا طریقہ منتخب کریں۔",
    "bn": "রসিদ পদ্ধতি নির্বাচন করুন",
    "id": "Pilih metode penerimaan",
    "ml": "രസീത് രീതി തിരഞ്ഞെടുക്കുക",
    "tl": "Piliin ang paraan ng pagtanggap"
  },
  "Select repayment method": {
    "ur": "ادائیگی کا طریقہ منتخب کریں۔",
    "bn": "পরিশোধের পদ্ধতি নির্বাচন করুন",
    "id": "Pilih metode pembayaran",
    "ml": "തിരിച്ചടവ് രീതി തിരഞ്ഞെടുക്കുക",
    "tl": "Piliin ang paraan ng pagbabayad"
  },
  "Select size if relevant": {
    "ur": "اگر متعلقہ ہو تو سائز منتخب کریں۔",
    "bn": "প্রাসঙ্গিক হলে আকার নির্বাচন করুন",
    "id": "Pilih ukuran jika relevan",
    "ml": "പ്രസക്തമാണെങ്കിൽ വലുപ്പം തിരഞ്ഞെടുക്കുക",
    "tl": "Piliin ang laki kung may kaugnayan"
  },
  "Select the official data type available to you, then enter the related number.": {
    "ur": "آپ کے لیے دستیاب سرکاری ڈیٹا کی قسم کو منتخب کریں، پھر متعلقہ نمبر درج کریں۔",
    "bn": "আপনার কাছে উপলব্ধ অফিসিয়াল ডেটা টাইপ নির্বাচন করুন, তারপরে সংশ্লিষ্ট নম্বর লিখুন।",
    "id": "Pilih tipe data resmi yang tersedia untuk Anda, lalu masukkan nomor terkait.",
    "ml": "നിങ്ങൾക്ക് ലഭ്യമായ ഔദ്യോഗിക ഡാറ്റ തരം തിരഞ്ഞെടുക്കുക, തുടർന്ന് ബന്ധപ്പെട്ട നമ്പർ നൽകുക.",
    "tl": "Piliin ang opisyal na uri ng data na magagamit mo, pagkatapos ay ilagay ang nauugnay na numero."
  },
  "Select type": {
    "ur": "قسم منتخب کریں۔",
    "bn": "প্রকার নির্বাচন করুন",
    "id": "Pilih jenis",
    "ml": "തരം തിരഞ്ഞെടുക്കുക",
    "tl": "Pumili ng uri"
  },
  "Service certificate receipt date": {
    "ur": "سروس سرٹیفکیٹ کی رسید کی تاریخ",
    "bn": "পরিষেবা শংসাপত্র প্রাপ্তির তারিখ",
    "id": "Tanggal penerimaan sertifikat layanan",
    "ml": "സേവന സർട്ടിഫിക്കറ്റ് രസീത് തീയതി",
    "tl": "Petsa ng pagtanggap ng sertipiko ng serbisyo"
  },
  "Service certificate receipt date is required.": {
    "ur": "سروس سرٹیفکیٹ کی رسید کی تاریخ درکار ہے۔",
    "bn": "পরিষেবা সার্টিফিকেট প্রাপ্তির তারিখ প্রয়োজন.",
    "id": "Tanggal penerimaan sertifikat layanan wajib diisi.",
    "ml": "സേവന സർട്ടിഫിക്കറ്റ് രസീത് തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng pagtanggap ng sertipiko ng serbisyo."
  },
  "Specify the other type of evidence": {
    "ur": "ثبوت کی دوسری قسم کی وضاحت کریں۔",
    "bn": "অন্য ধরনের প্রমাণ উল্লেখ করুন",
    "id": "Tentukan jenis bukti lainnya",
    "ml": "മറ്റ് തരത്തിലുള്ള തെളിവുകൾ വ്യക്തമാക്കുക",
    "tl": "Tukuyin ang iba pang uri ng ebidensya"
  },
  "Specify the reason for ending the relationship": {
    "ur": "رشتہ ختم کرنے کی وجہ بتائیں",
    "bn": "সম্পর্ক শেষ করার কারণ উল্লেখ করুন",
    "id": "Tentukan alasan untuk mengakhiri hubungan",
    "ml": "ബന്ധം അവസാനിപ്പിക്കുന്നതിനുള്ള കാരണം വ്യക്തമാക്കുക",
    "tl": "Tukuyin ang dahilan ng pagtatapos ng relasyon"
  },
  "Start New Request": {
    "ur": "نئی درخواست شروع کریں۔",
    "bn": "নতুন অনুরোধ শুরু করুন",
    "id": "Mulai Permintaan Baru",
    "ml": "പുതിയ അഭ്യർത്ഥന ആരംഭിക്കുക",
    "tl": "Magsimula ng Bagong Kahilingan"
  },
  "Stated notice period": {
    "ur": "بیان کردہ نوٹس کی مدت",
    "bn": "উল্লেখিত নোটিশ সময়কাল",
    "id": "Periode pemberitahuan yang disebutkan",
    "ml": "പ്രസ്താവിച്ച അറിയിപ്പ് കാലയളവ്",
    "tl": "Nakasaad na panahon ng paunawa"
  },
  "Step": {
    "ur": "قدم",
    "bn": "ধাপ",
    "id": "Melangkah",
    "ml": "ഘട്ടം",
    "tl": "Hakbang"
  },
  "Street": {
    "ur": "گلی",
    "bn": "রাস্তা",
    "id": "Jalan",
    "ml": "തെരുവ്",
    "tl": "kalye"
  },
  "Submission method": {
    "ur": "جمع کرانے کا طریقہ",
    "bn": "জমা দেওয়ার পদ্ধতি",
    "id": "Metode penyerahan",
    "ml": "സമർപ്പിക്കൽ രീതി",
    "tl": "Paraan ng pagsusumite"
  },
  "Submit Request": {
    "ur": "درخواست جمع کروائیں۔",
    "bn": "অনুরোধ জমা দিন",
    "id": "Kirim Permintaan",
    "ml": "അഭ്യർത്ഥന സമർപ്പിക്കുക",
    "tl": "Isumite ang Kahilingan"
  },
  "Submitting...": {
    "ur": "جمع کر رہا ہے...",
    "bn": "জমা দেওয়া হচ্ছে...",
    "id": "Mengirimkan...",
    "ml": "സമർപ്പിക്കുന്നു...",
    "tl": "Isinusumite..."
  },
  "Suggested attachments based on your current answers": {
    "ur": "آپ کے موجودہ جوابات کی بنیاد پر تجویز کردہ منسلکات",
    "bn": "আপনার বর্তমান উত্তরের উপর ভিত্তি করে প্রস্তাবিত সংযুক্তি",
    "id": "Lampiran yang disarankan berdasarkan jawaban Anda saat ini",
    "ml": "നിങ്ങളുടെ നിലവിലെ ഉത്തരങ്ങളെ അടിസ്ഥാനമാക്കി നിർദ്ദേശിച്ച അറ്റാച്ചുമെൻ്റുകൾ",
    "tl": "Mga iminungkahing attachment batay sa iyong mga kasalukuyang sagot"
  },
  "Suggested claims based on your answers": {
    "ur": "آپ کے جوابات کی بنیاد پر تجویز کردہ دعوے",
    "bn": "আপনার উত্তরের উপর ভিত্তি করে প্রস্তাবিত দাবি",
    "id": "Klaim yang disarankan berdasarkan jawaban Anda",
    "ml": "നിങ്ങളുടെ ഉത്തരങ്ങളെ അടിസ്ഥാനമാക്കി നിർദ്ദേശിച്ച ക്ലെയിമുകൾ",
    "tl": "Mga iminungkahing claim batay sa iyong mga sagot"
  },
  "Summary of Data and Facts": {
    "ur": "ڈیٹا اور حقائق کا خلاصہ",
    "bn": "তথ্য ও তথ্যের সারাংশ",
    "id": "Ringkasan Data dan Fakta",
    "ml": "ഡാറ്റയുടെയും വസ്തുതകളുടെയും സംഗ്രഹം",
    "tl": "Buod ng Data at Katotohanan"
  },
  "The file exceeds the 10 MB size limit.": {
    "ur": "فائل 10 MB سائز کی حد سے زیادہ ہے۔",
    "bn": "ফাইলটি 10 ​​MB আকারের সীমা অতিক্রম করেছে৷",
    "id": "File melebihi batas ukuran 10 MB.",
    "ml": "ഫയൽ 10 MB വലുപ്പ പരിധി കവിഞ്ഞു.",
    "tl": "Ang file ay lumampas sa 10 MB na limitasyon sa laki."
  },
  "The objection or claim date is required.": {
    "ur": "اعتراض یا دعویٰ کی تاریخ درکار ہے۔",
    "bn": "আপত্তি বা দাবি তারিখ প্রয়োজন.",
    "id": "Tanggal keberatan atau klaim diperlukan.",
    "ml": "എതിർപ്പ് അല്ലെങ്കിൽ ക്ലെയിം തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng pagtutol o paghahabol."
  },
  "The relationship is marked as active based on the client details step.": {
    "ur": "کلائنٹ کی تفصیلات کے مرحلے کی بنیاد پر رشتہ کو فعال کے طور پر نشان زد کیا گیا ہے۔",
    "bn": "ক্লায়েন্টের বিবরণের ধাপের উপর ভিত্তি করে সম্পর্কটিকে সক্রিয় হিসেবে চিহ্নিত করা হয়েছে।",
    "id": "Hubungan tersebut ditandai sebagai aktif berdasarkan langkah detail klien.",
    "ml": "ക്ലയൻ്റ് വിശദാംശങ്ങളുടെ ഘട്ടത്തെ അടിസ്ഥാനമാക്കി ബന്ധം സജീവമായി അടയാളപ്പെടുത്തിയിരിക്കുന്നു.",
    "tl": "Ang relasyon ay minarkahan bilang aktibo batay sa hakbang ng mga detalye ng kliyente."
  },
  "The request cannot be submitted without confirming the summary of data and facts. If you face an issue with the data or summary display, please contact support at labor.support@wazn.sa.": {
    "ur": "ڈیٹا اور حقائق کے خلاصے کی تصدیق کیے بغیر درخواست جمع نہیں کی جا سکتی۔ اگر آپ کو ڈیٹا یا سمری ڈسپلے میں کوئی مسئلہ درپیش ہے، تو براہ کرم labour.support@wazn.sa پر سپورٹ سے رابطہ کریں۔",
    "bn": "তথ্য এবং তথ্যের সারাংশ নিশ্চিত না করে অনুরোধ জমা দেওয়া যাবে না। আপনি যদি ডেটা বা সারাংশ প্রদর্শনের সাথে কোনও সমস্যার সম্মুখীন হন, অনুগ্রহ করে labour.support@wazn.sa-এ সহায়তার সাথে যোগাযোগ করুন।",
    "id": "Permohonan tidak dapat diajukan tanpa konfirmasi ringkasan data dan fakta. Jika Anda menghadapi masalah dengan tampilan data atau ringkasan, silakan hubungi dukungan di labor.support@wazn.sa.",
    "ml": "ഡാറ്റയുടെയും വസ്തുതകളുടെയും സംഗ്രഹം സ്ഥിരീകരിക്കാതെ അഭ്യർത്ഥന സമർപ്പിക്കാൻ കഴിയില്ല. ഡാറ്റയിലോ സംഗ്രഹ പ്രദർശനത്തിലോ നിങ്ങൾക്ക് ഒരു പ്രശ്നം നേരിടുകയാണെങ്കിൽ, support.support@wazn.sa എന്ന വിലാസത്തിൽ ബന്ധപ്പെടുക.",
    "tl": "Ang kahilingan ay hindi maaaring isumite nang hindi kinukumpirma ang buod ng data at katotohanan. Kung nahaharap ka sa isang isyu sa display ng data o buod, mangyaring makipag-ugnayan sa suporta sa labor.support@wazn.sa."
  },
  "The request cannot be submitted without confirming the summary of data and facts. If you face an issue with the data or summary display, please contact support at: ": {
    "ur": "ڈیٹا اور حقائق کے خلاصے کی تصدیق کیے بغیر درخواست جمع نہیں کی جا سکتی۔ اگر آپ کو ڈیٹا یا سمری ڈسپلے میں کوئی مسئلہ درپیش ہے، تو براہ کرم سپورٹ سے رابطہ کریں:",
    "bn": "তথ্য এবং তথ্যের সারাংশ নিশ্চিত না করে অনুরোধ জমা দেওয়া যাবে না। আপনি যদি ডেটা বা সারাংশ প্রদর্শনের সাথে কোনও সমস্যার সম্মুখীন হন তবে অনুগ্রহ করে এখানে সহায়তার সাথে যোগাযোগ করুন:",
    "id": "Permohonan tidak dapat diajukan tanpa konfirmasi ringkasan data dan fakta. Jika Anda menghadapi masalah dengan tampilan data atau ringkasan, silakan hubungi dukungan di:",
    "ml": "ഡാറ്റയുടെയും വസ്തുതകളുടെയും സംഗ്രഹം സ്ഥിരീകരിക്കാതെ അഭ്യർത്ഥന സമർപ്പിക്കാൻ കഴിയില്ല. ഡാറ്റയിലോ സംഗ്രഹ പ്രദർശനത്തിലോ നിങ്ങൾക്ക് ഒരു പ്രശ്നം നേരിടുകയാണെങ്കിൽ, ദയവായി പിന്തുണയുമായി ബന്ധപ്പെടുക:",
    "tl": "Ang kahilingan ay hindi maaaring isumite nang hindi kinukumpirma ang buod ng data at katotohanan. Kung nahaharap ka sa isang isyu sa display ng data o buod, mangyaring makipag-ugnayan sa suporta sa:"
  },
  "The request could not be submitted. Please try again.": {
    "ur": "درخواست جمع نہیں ہو سکی۔ براہ کرم دوبارہ کوشش کریں۔",
    "bn": "অনুরোধ জমা দেওয়া যায়নি. আবার চেষ্টা করুন.",
    "id": "Permintaan tidak dapat diajukan. Silakan coba lagi.",
    "ml": "അപേക്ഷ സമർപ്പിക്കാൻ കഴിഞ്ഞില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    "tl": "Hindi maisumite ang kahilingan. Pakisubukang muli."
  },
  "The request was created through the labor intake portal. You can now keep the reference number and private tracking link to review the status and upload additional documents later.": {
    "ur": "درخواست لیبر انٹیک پورٹل کے ذریعے بنائی گئی تھی۔ اب آپ اسٹیٹس کا جائزہ لینے اور بعد میں اضافی دستاویزات اپ لوڈ کرنے کے لیے حوالہ نمبر اور نجی ٹریکنگ لنک رکھ سکتے ہیں۔",
    "bn": "লেবার ইনটেক পোর্টালের মাধ্যমে অনুরোধটি তৈরি করা হয়েছে। আপনি এখন স্থিতি পর্যালোচনা করতে এবং পরে অতিরিক্ত নথি আপলোড করতে রেফারেন্স নম্বর এবং ব্যক্তিগত ট্র্যাকিং লিঙ্ক রাখতে পারেন।",
    "id": "Permintaan tersebut dibuat melalui portal penerimaan tenaga kerja. Anda sekarang dapat menyimpan nomor referensi dan tautan pelacakan pribadi untuk meninjau status dan mengunggah dokumen tambahan nanti.",
    "ml": "ലേബർ ഇൻടേക്ക് പോർട്ടൽ വഴിയാണ് അഭ്യർത്ഥന സൃഷ്ടിച്ചത്. സ്റ്റാറ്റസ് അവലോകനം ചെയ്യാനും പിന്നീട് അധിക ഡോക്യുമെൻ്റുകൾ അപ്‌ലോഡ് ചെയ്യാനും നിങ്ങൾക്ക് ഇപ്പോൾ റഫറൻസ് നമ്പറും സ്വകാര്യ ട്രാക്കിംഗ് ലിങ്കും സൂക്ഷിക്കാം.",
    "tl": "Ang kahilingan ay ginawa sa pamamagitan ng labor intake portal. Maaari mo na ngayong panatilihin ang reference number at pribadong link sa pagsubaybay upang suriin ang status at mag-upload ng mga karagdagang dokumento sa ibang pagkakataon."
  },
  "The tracking page only shows the current request status and allows additional uploads without displaying any internal notes.": {
    "ur": "ٹریکنگ صفحہ صرف موجودہ درخواست کی حیثیت کو ظاہر کرتا ہے اور بغیر کسی اندرونی نوٹس کو ظاہر کیے اضافی اپ لوڈز کی اجازت دیتا ہے۔",
    "bn": "ট্র্যাকিং পৃষ্ঠাটি শুধুমাত্র বর্তমান অনুরোধের অবস্থা দেখায় এবং কোনো অভ্যন্তরীণ নোট প্রদর্শন না করেই অতিরিক্ত আপলোডের অনুমতি দেয়।",
    "id": "Halaman pelacakan hanya menampilkan status permintaan saat ini dan memungkinkan unggahan tambahan tanpa menampilkan catatan internal apa pun.",
    "ml": "ട്രാക്കിംഗ് പേജ് നിലവിലെ അഭ്യർത്ഥന നില കാണിക്കുകയും ആന്തരിക കുറിപ്പുകളൊന്നും പ്രദർശിപ്പിക്കാതെ തന്നെ അധിക അപ്‌ലോഡുകൾ അനുവദിക്കുകയും ചെയ്യുന്നു.",
    "tl": "Ipinapakita lamang ng page sa pagsubaybay ang kasalukuyang status ng kahilingan at pinapayagan ang mga karagdagang pag-upload nang hindi nagpapakita ng anumang panloob na tala."
  },
  "This indicator reflects only the completeness of the data and documents and does not constitute legal assessment or prediction of the case outcome.": {
    "ur": "یہ اشارے صرف اعداد و شمار اور دستاویزات کی مکملیت کی عکاسی کرتا ہے اور قانونی تشخیص یا کیس کے نتائج کی پیشین گوئی نہیں کرتا ہے۔",
    "bn": "এই সূচকটি শুধুমাত্র তথ্য এবং নথির সম্পূর্ণতা প্রতিফলিত করে এবং মামলার ফলাফলের আইনি মূল্যায়ন বা ভবিষ্যদ্বাণী গঠন করে না।",
    "id": "Indikator ini hanya mencerminkan kelengkapan data dan dokumen dan bukan merupakan penilaian hukum atau prediksi hasil perkara.",
    "ml": "ഈ സൂചകം ഡാറ്റയുടെയും ഡോക്യുമെൻ്റുകളുടെയും പൂർണ്ണതയെ മാത്രം പ്രതിഫലിപ്പിക്കുന്നു, കൂടാതെ കേസ് ഫലത്തിൻ്റെ നിയമപരമായ വിലയിരുത്തലോ പ്രവചനമോ ഉൾക്കൊള്ളുന്നില്ല.",
    "tl": "Ang indicator na ito ay sumasalamin lamang sa pagkakumpleto ng data at mga dokumento at hindi bumubuo ng legal na pagtatasa o hula ng resulta ng kaso."
  },
  "This section clarifies how the relationship was documented and whether official records match reality or require alternative proof.": {
    "ur": "یہ سیکشن واضح کرتا ہے کہ رشتہ کیسے دستاویزی کیا گیا اور آیا سرکاری ریکارڈ حقیقت سے میل کھاتا ہے یا متبادل ثبوت کی ضرورت ہے۔",
    "bn": "এই বিভাগটি স্পষ্ট করে যে সম্পর্কটি কীভাবে নথিভুক্ত করা হয়েছিল এবং অফিসিয়াল রেকর্ডগুলি বাস্তবতার সাথে মেলে নাকি বিকল্প প্রমাণের প্রয়োজন হয়।",
    "id": "Bagian ini menjelaskan bagaimana hubungan tersebut didokumentasikan dan apakah catatan resmi sesuai dengan kenyataan atau memerlukan bukti alternatif.",
    "ml": "ബന്ധം എങ്ങനെ രേഖപ്പെടുത്തപ്പെട്ടുവെന്നും ഔദ്യോഗിക രേഖകൾ യാഥാർത്ഥ്യവുമായി പൊരുത്തപ്പെടുന്നുണ്ടോ അതോ ഇതര തെളിവ് ആവശ്യമാണോ എന്നും ഈ വിഭാഗം വ്യക്തമാക്കുന്നു.",
    "tl": "Nililinaw ng seksyong ito kung paano naidokumento ang relasyon at kung ang mga opisyal na tala ay tumutugma sa katotohanan o nangangailangan ng alternatibong patunay."
  },
  "This section clarifies whether the actual wage matched what was recorded in the contract or in social insurance records, without providing any legal analysis inside the portal.": {
    "ur": "یہ سیکشن واضح کرتا ہے کہ آیا پورٹل کے اندر کوئی قانونی تجزیہ فراہم کیے بغیر، اصل اجرت معاہدے یا سماجی بیمہ کے ریکارڈ میں درج کی گئی رقم سے مماثل ہے۔",
    "bn": "এই বিভাগটি স্পষ্ট করে যে প্রকৃত মজুরি পোর্টালের অভ্যন্তরে কোনো আইনি বিশ্লেষণ প্রদান না করেই চুক্তিতে বা সামাজিক বীমা রেকর্ডে যা রেকর্ড করা হয়েছে তার সাথে মিলেছে কিনা।",
    "id": "Bagian ini mengklarifikasi apakah gaji sebenarnya sesuai dengan yang tercatat dalam kontrak atau catatan asuransi sosial, tanpa memberikan analisis hukum apa pun di dalam portal.",
    "ml": "പോർട്ടലിനുള്ളിൽ യാതൊരു നിയമപരമായ വിശകലനവും നൽകാതെ, കരാറിലോ സോഷ്യൽ ഇൻഷുറൻസ് രേഖകളിലോ രേഖപ്പെടുത്തിയിരിക്കുന്ന യഥാർത്ഥ വേതനം പൊരുത്തപ്പെടുന്നുണ്ടോ എന്ന് ഈ വിഭാഗം വ്യക്തമാക്കുന്നു.",
    "tl": "Nililinaw ng seksyong ito kung ang aktwal na sahod ay tumugma sa naitala sa kontrata o sa mga talaan ng social insurance, nang hindi nagbibigay ng anumang legal na pagsusuri sa loob ng portal."
  },
  "This section explains how the relationship started, the type of contract or agreement, and how the work was structured from the outset.": {
    "ur": "یہ سیکشن وضاحت کرتا ہے کہ رشتہ کیسے شروع ہوا، معاہدے یا معاہدے کی قسم، اور کام کو شروع سے کیسے ترتیب دیا گیا۔",
    "bn": "এই বিভাগটি ব্যাখ্যা করে কিভাবে সম্পর্ক শুরু হয়েছিল, চুক্তি বা চুক্তির ধরন এবং কিভাবে কাজটি শুরু থেকে গঠন করা হয়েছিল।",
    "id": "Bagian ini menjelaskan bagaimana hubungan itu dimulai, jenis kontrak atau perjanjian, dan bagaimana pekerjaan itu disusun sejak awal.",
    "ml": "ബന്ധം എങ്ങനെയാണ് ആരംഭിച്ചത്, കരാർ അല്ലെങ്കിൽ കരാറിൻ്റെ തരം, തുടക്കം മുതൽ ജോലി എങ്ങനെ ക്രമീകരിച്ചു എന്നിവ ഈ വിഭാഗം വിശദീകരിക്കുന്നു.",
    "tl": "Ipinapaliwanag ng seksyong ito kung paano nagsimula ang relasyon, ang uri ng kontrata o kasunduan, at kung paano itinayo ang trabaho mula sa simula."
  },
  "This section focuses on how work was actually carried out and whether there were violations or important facts that help assess the dispute and its strength.": {
    "ur": "یہ سیکشن اس بات پر توجہ مرکوز کرتا ہے کہ کام اصل میں کیسے کیا گیا اور آیا اس میں خلاف ورزیاں ہوئیں یا اہم حقائق جو تنازعہ اور اس کی طاقت کا اندازہ لگانے میں مدد کرتے ہیں۔",
    "bn": "এই বিভাগটি কীভাবে কাজটি বাস্তবে সম্পাদিত হয়েছিল এবং সেখানে লঙ্ঘন বা গুরুত্বপূর্ণ তথ্য ছিল কিনা যা বিরোধ এবং এর শক্তির মূল্যায়ন করতে সহায়তা করে তার উপর ফোকাস করে।",
    "id": "Bagian ini berfokus pada bagaimana pekerjaan sebenarnya dilakukan dan apakah terdapat pelanggaran atau fakta penting yang membantu menilai perselisihan dan kekuatannya.",
    "ml": "ഈ വിഭാഗം ജോലി യഥാർത്ഥത്തിൽ എങ്ങനെ നടത്തി എന്നതിനെക്കുറിച്ചും തർക്കവും അതിൻ്റെ ശക്തിയും വിലയിരുത്താൻ സഹായിക്കുന്ന ലംഘനങ്ങളോ പ്രധാനപ്പെട്ട വസ്തുതകളോ ഉണ്ടോ എന്നതിലും ശ്രദ്ധ കേന്ദ്രീകരിക്കുന്നു.",
    "tl": "Nakatuon ang seksyong ito sa kung paano aktwal na isinagawa ang trabaho at kung may mga paglabag o mahahalagang katotohanan na tumutulong sa pagtatasa ng hindi pagkakaunawaan at lakas nito."
  },
  "This section is entirely optional and may be skipped if license details are not available.": {
    "ur": "یہ سیکشن مکمل طور پر اختیاری ہے اور اگر لائسنس کی تفصیلات دستیاب نہ ہوں تو اسے چھوڑا جا سکتا ہے۔",
    "bn": "এই বিভাগটি সম্পূর্ণ ঐচ্ছিক এবং লাইসেন্সের বিশদ উপলব্ধ না হলে এড়িয়ে যেতে পারে।",
    "id": "Bagian ini sepenuhnya opsional dan dapat dilewati jika rincian lisensi tidak tersedia.",
    "ml": "ഈ വിഭാഗം പൂർണ്ണമായും ഓപ്ഷണൽ ആണ്, ലൈസൻസ് വിശദാംശങ്ങൾ ലഭ്യമല്ലെങ്കിൽ ഒഴിവാക്കിയേക്കാം.",
    "tl": "Ang seksyong ito ay ganap na opsyonal at maaaring laktawan kung ang mga detalye ng lisensya ay hindi magagamit."
  },
  "This section is linked to your answer in the client details step and only shows termination details if the relationship has actually ended.": {
    "ur": "یہ سیکشن کلائنٹ کی تفصیلات کے مرحلے میں آپ کے جواب سے منسلک ہے اور صرف اس صورت میں ختم کرنے کی تفصیلات دکھاتا ہے جب رشتہ واقعی ختم ہو گیا ہو۔",
    "bn": "এই বিভাগটি ক্লায়েন্টের বিশদ বিবরণের ধাপে আপনার উত্তরের সাথে লিঙ্ক করা হয়েছে এবং সম্পর্কটি আসলেই শেষ হয়ে গেলে শুধুমাত্র সমাপ্তির বিবরণ দেখায়।",
    "id": "Bagian ini ditautkan ke jawaban Anda di langkah detail klien dan hanya menampilkan detail penghentian jika hubungan benar-benar telah berakhir.",
    "ml": "ക്ലയൻ്റ് വിശദാംശങ്ങളുടെ ഘട്ടത്തിലെ നിങ്ങളുടെ ഉത്തരവുമായി ഈ വിഭാഗം ലിങ്ക് ചെയ്‌തിരിക്കുന്നു, ബന്ധം യഥാർത്ഥത്തിൽ അവസാനിച്ചിട്ടുണ്ടെങ്കിൽ മാത്രമേ അവസാനിപ്പിക്കൽ വിശദാംശങ്ങൾ കാണിക്കൂ.",
    "tl": "Ang seksyong ito ay naka-link sa iyong sagot sa hakbang ng mga detalye ng kliyente at nagpapakita lamang ng mga detalye ng pagwawakas kung ang relasyon ay talagang natapos na."
  },
  "This section provides an organized summary of the data and facts you entered. It is not legal advice or an assessment of the case outcome.": {
    "ur": "یہ سیکشن آپ کے درج کردہ ڈیٹا اور حقائق کا ایک منظم خلاصہ فراہم کرتا ہے۔ یہ قانونی مشورہ یا کیس کے نتائج کا اندازہ نہیں ہے۔",
    "bn": "এই বিভাগটি আপনার প্রবেশ করানো তথ্য এবং তথ্যগুলির একটি সংগঠিত সারাংশ প্রদান করে। এটি আইনি পরামর্শ বা মামলার ফলাফলের মূল্যায়ন নয়।",
    "id": "Bagian ini memberikan ringkasan terorganisir dari data dan fakta yang Anda masukkan. Ini bukan nasihat hukum atau penilaian terhadap hasil kasus.",
    "ml": "നിങ്ങൾ നൽകിയ ഡാറ്റയുടെയും വസ്തുതകളുടെയും ഒരു സംഘടിത സംഗ്രഹം ഈ വിഭാഗം നൽകുന്നു. ഇത് നിയമോപദേശമോ കേസിൻ്റെ ഫലത്തെക്കുറിച്ചുള്ള വിലയിരുത്തലോ അല്ല.",
    "tl": "Ang seksyong ito ay nagbibigay ng isang organisadong buod ng data at katotohanan na iyong inilagay. Hindi ito legal na payo o pagtatasa ng resulta ng kaso."
  },
  "Total wage": {
    "ur": "کل اجرت",
    "bn": "মোট মজুরি",
    "id": "Gaji total",
    "ml": "ആകെ കൂലി",
    "tl": "Kabuuang sahod"
  },
  "Transfer amount": {
    "ur": "منتقلی کی رقم",
    "bn": "স্থানান্তর পরিমাণ",
    "id": "Jumlah transfer",
    "ml": "തുക കൈമാറ്റം ചെയ്യുക",
    "tl": "halaga ng paglipat"
  },
  "Transfer date": {
    "ur": "منتقلی کی تاریخ",
    "bn": "স্থানান্তর তারিখ",
    "id": "Tanggal pemindahan",
    "ml": "കൈമാറ്റ തീയതി",
    "tl": "Petsa ng paglipat"
  },
  "Transport allowance": {
    "ur": "ٹرانسپورٹ الاؤنس",
    "bn": "পরিবহন ভাতা",
    "id": "Tunjangan transportasi",
    "ml": "ഗതാഗത അലവൻസ്",
    "tl": "Allowance sa transportasyon"
  },
  "Trial period length is required.": {
    "ur": "آزمائشی مدت کی لمبائی درکار ہے۔",
    "bn": "ট্রায়াল সময় দৈর্ঘ্য প্রয়োজন.",
    "id": "Panjang masa percobaan diperlukan.",
    "ml": "ട്രയൽ കാലയളവിൻ്റെ ദൈർഘ്യം ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang haba ng panahon ng pagsubok."
  },
  "Unit number": {
    "ur": "یونٹ نمبر",
    "bn": "ইউনিট নম্বর",
    "id": "Nomor satuan",
    "ml": "യൂണിറ്റ് നമ്പർ",
    "tl": "Numero ng unit"
  },
  "Unsupported file format. Allowed formats: PDF / JPG / PNG / DOCX / XLSX / ZIP": {
    "ur": "غیر تعاون یافتہ فائل فارمیٹ۔ اجازت شدہ فارمیٹس: PDF/JPG/PNG/DOCX/XLSX/zip",
    "bn": "অসমর্থিত ফাইল বিন্যাস। অনুমোদিত ফর্ম্যাট: PDF / JPG / PNG / DOCX / XLSX / ZIP",
    "id": "Format file tidak didukung. Format yang diperbolehkan: PDF / JPG / PNG / DOCX / XLSX / ZIP",
    "ml": "പിന്തുണയ്ക്കാത്ത ഫയൽ ഫോർമാറ്റ്. അനുവദനീയമായ ഫോർമാറ്റുകൾ: PDF / JPG / PNG / DOCX / XLSX / ZIP",
    "tl": "Hindi sinusuportahang format ng file. Mga pinapayagang format: PDF / JPG / PNG / DOCX / XLSX / ZIP"
  },
  "Upload Date": {
    "ur": "اپ لوڈ کی تاریخ",
    "bn": "আপলোডের তারিখ",
    "id": "Tanggal Pengunggahan",
    "ml": "അപ്‌ലോഡ് തീയതി",
    "tl": "Petsa ng Pag-upload"
  },
  "Upload File": {
    "ur": "فائل اپ لوڈ کریں۔",
    "bn": "ফাইল আপলোড করুন",
    "id": "Unggah Berkas",
    "ml": "ഫയൽ അപ്‌ലോഡ് ചെയ്യുക",
    "tl": "Mag-upload ng File"
  },
  "Upload Missing or Additional Documents": {
    "ur": "غائب یا اضافی دستاویزات اپ لوڈ کریں۔",
    "bn": "অনুপস্থিত বা অতিরিক্ত নথি আপলোড করুন",
    "id": "Unggah Dokumen yang Hilang atau Tambahan",
    "ml": "നഷ്‌ടമായ അല്ലെങ്കിൽ അധിക പ്രമാണങ്ങൾ അപ്‌ലോഡ് ചെയ്യുക",
    "tl": "Mag-upload ng Nawawala o Mga Karagdagang Dokumento"
  },
  "Upload and organize the available supporting documents in a structured list tied to the request.": {
    "ur": "درخواست سے منسلک ایک ساختی فہرست میں دستیاب معاون دستاویزات کو اپ لوڈ اور منظم کریں۔",
    "bn": "অনুরোধের সাথে সংযুক্ত একটি কাঠামোগত তালিকায় উপলব্ধ সহায়ক নথিগুলি আপলোড এবং সংগঠিত করুন।",
    "id": "Unggah dan atur dokumen pendukung yang tersedia dalam daftar terstruktur yang terkait dengan permintaan.",
    "ml": "അഭ്യർത്ഥനയുമായി ബന്ധിപ്പിച്ചിട്ടുള്ള ഒരു ഘടനാപരമായ ലിസ്റ്റിൽ ലഭ്യമായ സഹായ രേഖകൾ അപ്‌ലോഡ് ചെയ്യുകയും ഓർഗനൈസ് ചെയ്യുകയും ചെയ്യുക.",
    "tl": "I-upload at ayusin ang mga available na sumusuportang dokumento sa isang structured na listahan na nakatali sa kahilingan."
  },
  "Uploading...": {
    "ur": "اپ لوڈ ہو رہا ہے...",
    "bn": "আপলোড হচ্ছে...",
    "id": "Mengunggah...",
    "ml": "അപ്‌ലോഡ് ചെയ്യുന്നു...",
    "tl": "Ina-upload..."
  },
  "Use the \"Add Attachment\" button to upload contracts, evidence, notices, or any supporting documents related to the case.": {
    "ur": "معاہدوں، شواہد، نوٹسز، یا کیس سے متعلق کوئی معاون دستاویزات اپ لوڈ کرنے کے لیے \"منسلک شامل کریں\" بٹن کا استعمال کریں۔",
    "bn": "চুক্তি, প্রমাণ, নোটিশ বা মামলার সাথে সম্পর্কিত যেকোন সহায়ক নথি আপলোড করতে \"সংযুক্তি যোগ করুন\" বোতামটি ব্যবহার করুন৷",
    "id": "Gunakan tombol \"Tambahkan Lampiran\" untuk mengunggah kontrak, bukti, pemberitahuan, atau dokumen pendukung apa pun yang terkait dengan kasus tersebut.",
    "ml": "കരാറുകൾ, തെളിവുകൾ, അറിയിപ്പുകൾ അല്ലെങ്കിൽ കേസുമായി ബന്ധപ്പെട്ട ഏതെങ്കിലും അനുബന്ധ രേഖകൾ അപ്‌ലോഡ് ചെയ്യാൻ \"അറ്റാച്ച്‌മെൻ്റ് ചേർക്കുക\" ബട്ടൺ ഉപയോഗിക്കുക.",
    "tl": "Gamitin ang button na \"Magdagdag ng Attachment\" upang mag-upload ng mga kontrata, ebidensya, abiso, o anumang sumusuportang dokumento na nauugnay sa kaso."
  },
  "Usual weekly rest day": {
    "ur": "عام ہفتہ وار آرام کا دن",
    "bn": "সাধারণ সাপ্তাহিক বিশ্রামের দিন",
    "id": "Hari istirahat mingguan yang biasa",
    "ml": "സാധാരണ പ്രതിവാര വിശ്രമ ദിനം",
    "tl": "Karaniwang lingguhang araw ng pahinga"
  },
  "Visible Gaps in the Request": {
    "ur": "درخواست میں واضح فرق",
    "bn": "অনুরোধে দৃশ্যমান ফাঁক",
    "id": "Kesenjangan yang Terlihat dalam Permintaan",
    "ml": "അഭ്യർത്ഥനയിൽ ദൃശ്യമായ വിടവുകൾ",
    "tl": "Mga Nakikitang Gaps sa Kahilingan"
  },
  "Visible missing attachments": {
    "ur": "مرئی غائب منسلکات",
    "bn": "দৃশ্যমান অনুপস্থিত সংযুক্তি",
    "id": "Lampiran yang hilang terlihat",
    "ml": "കാണാത്ത അറ്റാച്ചുമെൻ്റുകൾ",
    "tl": "Nakikitang nawawalang mga attachment"
  },
  "Wage Matching in Official Documents": {
    "ur": "سرکاری دستاویزات میں اجرت کا ملاپ",
    "bn": "অফিসিয়াল নথিতে মজুরি মিল",
    "id": "Pencocokan Upah dalam Dokumen Resmi",
    "ml": "ഔദ്യോഗിക രേഖകളിൽ വേതനം പൊരുത്തപ്പെടുത്തൽ",
    "tl": "Pagtutugma ng Sahod sa Mga Opisyal na Dokumento"
  },
  "Wage and Financial Benefits": {
    "ur": "اجرت اور مالی فوائد",
    "bn": "মজুরি এবং আর্থিক সুবিধা",
    "id": "Gaji dan Tunjangan Finansial",
    "ml": "വേതനവും സാമ്പത്തിക ആനുകൂല്യങ്ങളും",
    "tl": "Mga Benepisyo sa Sahod at Pinansyal"
  },
  "Wage payment date": {
    "ur": "اجرت کی ادائیگی کی تاریخ",
    "bn": "মজুরি প্রদানের তারিখ",
    "id": "Tanggal pembayaran gaji",
    "ml": "വേതനം നൽകുന്ന തീയതി",
    "tl": "Petsa ng pagbabayad ng sahod"
  },
  "Wage payment method": {
    "ur": "اجرت کی ادائیگی کا طریقہ",
    "bn": "মজুরি প্রদানের পদ্ধতি",
    "id": "Metode pembayaran upah",
    "ml": "വേതനം നൽകുന്ന രീതി",
    "tl": "Paraan ng pagbabayad ng sahod"
  },
  "Wage type": {
    "ur": "اجرت کی قسم",
    "bn": "মজুরির ধরন",
    "id": "Jenis upah",
    "ml": "കൂലി തരം",
    "tl": "Uri ng sahod"
  },
  "Was a clearance completed?": {
    "ur": "کیا کلیئرنس مکمل ہوئی؟",
    "bn": "একটি ছাড়পত্র সম্পন্ন হয়েছে?",
    "id": "Apakah izin sudah selesai?",
    "ml": "ഒരു ക്ലിയറൻസ് പൂർത്തിയായോ?",
    "tl": "Nakumpleto ba ang isang clearance?"
  },
  "Was a receipt or voucher received?": {
    "ur": "کیا رسید یا واؤچر موصول ہوا؟",
    "bn": "একটি রসিদ বা ভাউচার গৃহীত হয়েছিল?",
    "id": "Apakah tanda terima atau voucher sudah diterima?",
    "ml": "ഒരു രസീതോ വൗച്ചറോ ലഭിച്ചോ?",
    "tl": "Natanggap ba ang isang resibo o voucher?"
  },
  "Was an acknowledgement, release, or receipt signed?": {
    "ur": "کیا ایک اعتراف، رہائی، یا رسید پر دستخط کیے گئے تھے؟",
    "bn": "একটি স্বীকৃতি, মুক্তি, বা রসিদ স্বাক্ষরিত ছিল?",
    "id": "Apakah pengakuan, pelepasan, atau tanda terima ditandatangani?",
    "ml": "ഒരു അംഗീകാരം, റിലീസ്, അല്ലെങ്കിൽ രസീത് ഒപ്പിട്ടിരുന്നോ?",
    "tl": "Napirmahan ba ang isang pagkilala, paglabas, o resibo?"
  },
  "Was an advance receipt signed?": {
    "ur": "کیا پیشگی رسید پر دستخط کیے گئے تھے؟",
    "bn": "একটি অগ্রিম রসিদ স্বাক্ষরিত ছিল?",
    "id": "Apakah tanda terima di muka telah ditandatangani?",
    "ml": "മുൻകൂർ രസീതിൽ ഒപ്പിട്ടിരുന്നോ?",
    "tl": "Napirmahan ba ang isang paunang resibo?"
  },
  "Was it calculated or compensated?": {
    "ur": "کیا اس کا حساب لیا گیا یا معاوضہ؟",
    "bn": "এটা গণনা বা ক্ষতিপূরণ ছিল?",
    "id": "Apakah itu dihitung atau diberi kompensasi?",
    "ml": "ഇത് കണക്കാക്കിയതോ നഷ്ടപരിഹാരം നൽകിയതോ?",
    "tl": "Nakalkula ba ito o nabayaran?"
  },
  "Was it compensated separately?": {
    "ur": "کیا اسے الگ سے معاوضہ دیا گیا؟",
    "bn": "এটা কি আলাদাভাবে ক্ষতিপূরণ দেওয়া হয়েছিল?",
    "id": "Apakah kompensasinya diberikan secara terpisah?",
    "ml": "പ്രത്യേകമായി നഷ്ടപരിഹാരം നൽകിയോ?",
    "tl": "Nabayaran ba ito nang hiwalay?"
  },
  "Was it extended?": {
    "ur": "کیا اس میں توسیع کی گئی؟",
    "bn": "এটা কি বাড়ানো হয়েছিল?",
    "id": "Apakah sudah diperpanjang?",
    "ml": "അത് നീട്ടിയിരുന്നോ?",
    "tl": "Extended ba?"
  },
  "Was it signed before or after receiving the dues?": {
    "ur": "کیا واجبات وصول کرنے سے پہلے یا بعد میں دستخط کیے گئے؟",
    "bn": "বকেয়া পাওয়ার আগে নাকি পরে স্বাক্ষর করা হয়েছিল?",
    "id": "Apakah ditandatangani sebelum atau sesudah menerima iuran?",
    "ml": "കുടിശ്ശിക ലഭിക്കുന്നതിന് മുമ്പോ ശേഷമോ ഒപ്പിട്ടതാണോ?",
    "tl": "Napirmahan ba ito bago o pagkatapos matanggap ang mga dues?"
  },
  "Was it signed with your full consent?": {
    "ur": "کیا اس پر آپ کی مکمل رضامندی سے دستخط کیے گئے تھے؟",
    "bn": "এটি কি আপনার সম্পূর্ণ সম্মতিতে স্বাক্ষরিত হয়েছিল?",
    "id": "Apakah itu ditandatangani dengan persetujuan penuh Anda?",
    "ml": "നിങ്ങളുടെ പൂർണ സമ്മതത്തോടെയാണോ ഒപ്പിട്ടത്?",
    "tl": "Nilagdaan ba ito nang buong pahintulot mo?"
  },
  "Was it stopped during the relationship?": {
    "ur": "کیا رشتے کے دوران اسے روکا گیا تھا؟",
    "bn": "এটা কি সম্পর্কের সময় বন্ধ ছিল?",
    "id": "Apakah itu dihentikan selama hubungan?",
    "ml": "ബന്ധത്തിനിടയിൽ നിർത്തിയിരുന്നോ?",
    "tl": "Natigil ba ito sa panahon ng relasyon?"
  },
  "Was leave officially approved?": {
    "ur": "کیا چھٹی سرکاری طور پر منظور کی گئی تھی؟",
    "bn": "ছুটি কি আনুষ্ঠানিকভাবে অনুমোদিত হয়েছিল?",
    "id": "Apakah cuti secara resmi disetujui?",
    "ml": "അവധി ഔദ്യോഗികമായി അംഗീകരിച്ചിട്ടുണ്ടോ?",
    "tl": "Opisyal na naaprubahan ba ang leave?"
  },
  "Was the advance fully repaid?": {
    "ur": "کیا ایڈوانس مکمل طور پر ادا کر دیا گیا تھا؟",
    "bn": "অগ্রিম কি সম্পূর্ণরূপে পরিশোধ করা হয়েছিল?",
    "id": "Apakah uang muka telah dilunasi seluruhnya?",
    "ml": "അഡ്വാൻസ് പൂർണമായും തിരിച്ചടച്ചോ?",
    "tl": "Buong bayad ba ang advance?"
  },
  "Was the amount returned to the employer?": {
    "ur": "کیا رقم آجر کو واپس کر دی گئی تھی؟",
    "bn": "টাকা কি নিয়োগকর্তাকে ফেরত দেওয়া হয়েছিল?",
    "id": "Apakah jumlah tersebut dikembalikan kepada pemberi kerja?",
    "ml": "തുക തൊഴിലുടമയ്ക്ക് തിരികെ ലഭിച്ചോ?",
    "tl": "Ibinalik ba ang halaga sa employer?"
  },
  "Was the change documented in writing?": {
    "ur": "کیا تبدیلی کو تحریری طور پر درج کیا گیا تھا؟",
    "bn": "পরিবর্তন কি লিখিতভাবে নথিভুক্ত ছিল?",
    "id": "Apakah perubahan tersebut didokumentasikan secara tertulis?",
    "ml": "മാറ്റം രേഖാമൂലം രേഖപ്പെടുത്തിയിരുന്നോ?",
    "tl": "Nakadokumento ba ang pagbabago sa pamamagitan ng pagsulat?"
  },
  "Was the contract ever amended or renewed?": {
    "ur": "کیا معاہدے میں کبھی ترمیم یا تجدید کی گئی تھی؟",
    "bn": "চুক্তি কি কখনো সংশোধন বা নবায়ন করা হয়েছিল?",
    "id": "Apakah kontrak tersebut pernah diubah atau diperbarui?",
    "ml": "കരാർ എപ്പോഴെങ്കിലും ഭേദഗതി ചെയ്യുകയോ പുതുക്കുകയോ ചെയ്തിട്ടുണ്ടോ?",
    "tl": "Nabago ba o na-renew ang kontrata?"
  },
  "Was the custody returned at the end?": {
    "ur": "کیا حراست آخر میں واپس کر دی گئی؟",
    "bn": "শেষ পর্যন্ত হেফাজত কি ফেরত?",
    "id": "Apakah hak asuh dikembalikan pada akhirnya?",
    "ml": "അവസാനം കസ്റ്റഡി തിരിച്ചു കിട്ടിയോ?",
    "tl": "Ibinalik ba ang kustodiya sa dulo?"
  },
  "Was the reason for the deduction explained?": {
    "ur": "کیا کٹوتی کی وجہ بتائی گئی؟",
    "bn": "কর্তনের কারণ ব্যাখ্যা করা হয়েছিল?",
    "id": "Apakah alasan pemotongan tersebut dijelaskan?",
    "ml": "കിഴിവിൻ്റെ കാരണം വിശദമാക്കിയിട്ടുണ്ടോ?",
    "tl": "Ipinaliwanag ba ang dahilan ng pagbabawas?"
  },
  "Was the receipt regular on a monthly basis?": {
    "ur": "کیا رسید ماہانہ بنیاد پر باقاعدہ تھی؟",
    "bn": "মাসিক ভিত্তিতে রসিদ নিয়মিত ছিল?",
    "id": "Apakah penerimaannya rutin setiap bulan?",
    "ml": "മാസാടിസ്ഥാനത്തിൽ രസീത് പതിവായിരുന്നോ?",
    "tl": "Regular ba ang resibo sa buwanang batayan?"
  },
  "Was the release paper-based or electronic?": {
    "ur": "کیا رہائی کاغذ پر مبنی تھی یا الیکٹرانک؟",
    "bn": "রিলিজ পেপার ভিত্তিক বা ইলেকট্রনিক ছিল?",
    "id": "Apakah rilisnya berbasis kertas atau elektronik?",
    "ml": "റിലീസ് പേപ്പർ അധിഷ്ഠിതമാണോ അതോ ഇലക്ട്രോണിക് ആണോ?",
    "tl": "Nakabatay ba sa papel o electronic ang release?"
  },
  "Was the signing electronic or paper-based?": {
    "ur": "کیا دستخط الیکٹرانک یا کاغذ پر مبنی تھے؟",
    "bn": "স্বাক্ষর ইলেকট্রনিক বা কাগজ ভিত্তিক ছিল?",
    "id": "Apakah penandatanganannya dilakukan secara elektronik atau berbasis kertas?",
    "ml": "ഒപ്പിടുന്നത് ഇലക്‌ട്രോണിക് അല്ലെങ്കിൽ പേപ്പർ അധിഷ്‌ഠിതമായിരുന്നോ?",
    "tl": "Ang pagpirma ba ay electronic o paper-based?"
  },
  "Was the wage fixed?": {
    "ur": "کیا اجرت مقرر تھی؟",
    "bn": "মজুরি কি নির্ধারিত ছিল?",
    "id": "Apakah upahnya tetap?",
    "ml": "കൂലി നിശ്ചയിച്ചിരുന്നോ?",
    "tl": "Naayos ba ang sahod?"
  },
  "Was there WhatsApp or email communication related to work?": {
    "ur": "کیا کام سے متعلق واٹس ایپ یا ای میل کمیونیکیشن تھی؟",
    "bn": "কাজের সাথে সম্পর্কিত হোয়াটসঅ্যাপ বা ইমেল যোগাযোগ ছিল?",
    "id": "Apakah ada komunikasi WhatsApp atau email terkait pekerjaan?",
    "ml": "ജോലിയുമായി ബന്ധപ്പെട്ട വാട്ട്‌സ്ആപ്പ് അല്ലെങ്കിൽ ഇമെയിൽ ആശയവിനിമയം ഉണ്ടായിരുന്നോ?",
    "tl": "Mayroon bang pakikipag-ugnayan sa WhatsApp o email na nauugnay sa trabaho?"
  },
  "Was there a probation period?": {
    "ur": "کیا پروبیشن کی مدت تھی؟",
    "bn": "একটি প্রবেশন সময় ছিল?",
    "id": "Apakah ada masa percobaan?",
    "ml": "പ്രൊബേഷൻ കാലയളവ് ഉണ്ടായിരുന്നോ?",
    "tl": "Nagkaroon ba ng probation period?"
  },
  "Was there repeated delay in paying salaries?": {
    "ur": "کیا تنخواہوں کی ادائیگی میں بار بار تاخیر ہوئی؟",
    "bn": "বেতন দিতে কি বারবার বিলম্ব হয়েছিল?",
    "id": "Apakah ada penundaan berulang kali dalam pembayaran gaji?",
    "ml": "ശമ്പളം നൽകുന്നതിൽ ആവർത്തിച്ചുള്ള കാലതാമസം ഉണ്ടായിട്ടുണ്ടോ?",
    "tl": "Nagkaroon ba ng paulit-ulit na pagkaantala sa pagbabayad ng suweldo?"
  },
  "Wazin Labor Portal": {
    "ur": "وازین لیبر پورٹل",
    "bn": "ওয়াজিন লেবার পোর্টাল",
    "id": "Portal Tenaga Kerja Wazin",
    "ml": "വസിൻ ലേബർ പോർട്ടൽ",
    "tl": "Wazin Labor Portal"
  },
  "Wazin platform is being launched gradually.": {
    "ur": "وازین پلیٹ فارم بتدریج شروع کیا جا رہا ہے۔",
    "bn": "ধীরে ধীরে চালু হচ্ছে ওয়াজিন প্লাটফর্ম।",
    "id": "Platform Wazin diluncurkan secara bertahap.",
    "ml": "Wazin പ്ലാറ്റ്ഫോം ക്രമേണ സമാരംഭിക്കുന്നു.",
    "tl": "Ang platform ng Wazin ay unti-unting inilunsad."
  },
  "Website": {
    "ur": "ویب سائٹ",
    "bn": "ওয়েবসাইট",
    "id": "Situs web",
    "ml": "വെബ്സൈറ്റ്",
    "tl": "Website"
  },
  "Were all your dues paid?": {
    "ur": "کیا آپ کے تمام واجبات ادا کر دیے گئے؟",
    "bn": "আপনার সমস্ত বকেয়া পরিশোধ করা হয়েছে?",
    "id": "Apakah semua iuran Anda telah dibayar?",
    "ml": "നിങ്ങളുടെ എല്ലാ കുടിശ്ശികയും അടച്ചിരുന്നോ?",
    "tl": "Nabayaran ba ang lahat ng iyong mga dapat bayaran?"
  },
  "Were deductions ever made from your salary?": {
    "ur": "کیا کبھی آپ کی تنخواہ سے کٹوتی کی گئی تھی؟",
    "bn": "আপনার বেতন থেকে কি কখনো কর্তন করা হয়েছে?",
    "id": "Apakah gaji Anda pernah dipotong?",
    "ml": "നിങ്ങളുടെ ശമ്പളത്തിൽ നിന്ന് എപ്പോഴെങ്കിലും കിഴിവ് വരുത്തിയിട്ടുണ്ടോ?",
    "tl": "Nagawa na ba ang mga bawas sa iyong suweldo?"
  },
  "Were the cheques issued in your name?": {
    "ur": "کیا آپ کے نام پر چیک جاری کیے گئے تھے؟",
    "bn": "আপনার নামে চেক ইস্যু করা হয়েছিল?",
    "id": "Apakah cek tersebut diterbitkan atas nama Anda?",
    "ml": "ചെക്കുകൾ നിങ്ങളുടെ പേരിൽ നൽകിയിരുന്നോ?",
    "tl": "Ang mga tseke ba ay ibinigay sa iyong pangalan?"
  },
  "Were there commissions, incentives, or allowances that were not paid?": {
    "ur": "کیا کمیشن، مراعات یا الاؤنسز تھے جو ادا نہیں کیے گئے؟",
    "bn": "সেখানে কি কমিশন, প্রণোদনা বা ভাতা ছিল যা প্রদান করা হয়নি?",
    "id": "Apakah ada komisi, insentif atau tunjangan yang belum dibayarkan?",
    "ml": "നൽകാത്ത കമ്മീഷനുകളോ ഇൻസെൻ്റീവോ അലവൻസുകളോ ഉണ്ടായിരുന്നോ?",
    "tl": "Mayroon bang mga komisyon, insentibo, o allowance na hindi binayaran?"
  },
  "Were there recurring deductions?": {
    "ur": "کیا بار بار کٹوتیاں تھیں؟",
    "bn": "পুনরাবৃত্ত কাটছাঁট ছিল?",
    "id": "Apakah ada potongan yang berulang?",
    "ml": "ആവർത്തിച്ചുള്ള കിഴിവുകൾ ഉണ്ടായിരുന്നോ?",
    "tl": "Nagkaroon ba ng mga umuulit na pagbabawas?"
  },
  "Were they fully cashed?": {
    "ur": "کیا وہ مکمل طور پر کیش ہوئے تھے؟",
    "bn": "তারা কি সম্পূর্ণরূপে নগদ ছিল?",
    "id": "Apakah uangnya sudah diuangkan sepenuhnya?",
    "ml": "അവ പൂർണമായും പണമാക്കിയോ?",
    "tl": "Ganap ba silang na-cash?"
  },
  "Were they paid?": {
    "ur": "کیا انہیں ادائیگی کی گئی؟",
    "bn": "তাদের কি বেতন দেওয়া হয়েছিল?",
    "id": "Apakah mereka dibayar?",
    "ml": "അവർക്ക് ശമ്പളം ലഭിച്ചോ?",
    "tl": "Binayaran ba sila?"
  },
  "Were you asked to sign documents?": {
    "ur": "کیا آپ سے دستاویزات پر دستخط کرنے کو کہا گیا تھا؟",
    "bn": "আপনাকে কি নথিতে স্বাক্ষর করতে বলা হয়েছিল?",
    "id": "Apakah Anda diminta menandatangani dokumen?",
    "ml": "രേഖകളിൽ ഒപ്പിടാൻ നിങ്ങളോട് ആവശ്യപ്പെട്ടോ?",
    "tl": "Hinilingan ka bang pumirma ng mga dokumento?"
  },
  "Were you assigned additional work outside the nature of your role?": {
    "ur": "کیا آپ کو آپ کے کردار کی نوعیت سے باہر اضافی کام تفویض کیا گیا تھا؟",
    "bn": "আপনার ভূমিকার প্রকৃতির বাইরে আপনাকে কি অতিরিক্ত কাজ দেওয়া হয়েছিল?",
    "id": "Apakah Anda diberi pekerjaan tambahan di luar sifat peran Anda?",
    "ml": "നിങ്ങളുടെ റോളിൻ്റെ സ്വഭാവത്തിന് പുറത്തുള്ള അധിക ജോലി നിങ്ങൾക്ക് നൽകിയിട്ടുണ്ടോ?",
    "tl": "Inatasan ka ba ng karagdagang trabaho sa labas ng likas na katangian ng iyong tungkulin?"
  },
  "Were you compensated for it?": {
    "ur": "کیا آپ کو اس کا معاوضہ دیا گیا؟",
    "bn": "আপনি কি এর জন্য ক্ষতিপূরণ পেয়েছেন?",
    "id": "Apakah Anda mendapat kompensasi untuk itu?",
    "ml": "അതിന് നിങ്ങൾക്ക് നഷ്ടപരിഹാരം ലഭിച്ചോ?",
    "tl": "Nabayaran ka ba para dito?"
  },
  "Were you compensated?": {
    "ur": "کیا آپ کو معاوضہ دیا گیا؟",
    "bn": "আপনি কি ক্ষতিপূরণ পেয়েছেন?",
    "id": "Apakah Anda mendapat kompensasi?",
    "ml": "നിങ്ങൾക്ക് നഷ്ടപരിഹാരം ലഭിച്ചോ?",
    "tl": "Nabayaran ka ba?"
  },
  "Were you ever asked to sign documents without receiving a copy?": {
    "ur": "کیا آپ سے کبھی بھی ایک کاپی حاصل کیے بغیر دستاویزات پر دستخط کرنے کو کہا گیا تھا؟",
    "bn": "আপনাকে কি কখনও একটি অনুলিপি না পেয়ে নথিতে স্বাক্ষর করতে বলা হয়েছিল?",
    "id": "Pernahkah Anda diminta menandatangani dokumen tanpa menerima salinannya?",
    "ml": "ഒരു പകർപ്പ് ലഭിക്കാതെ എപ്പോഴെങ്കിലും പ്രമാണങ്ങളിൽ ഒപ്പിടാൻ നിങ്ങളോട് ആവശ്യപ്പെട്ടിട്ടുണ്ടോ?",
    "tl": "Nahiling ka na bang pumirma sa mga dokumento nang hindi nakakatanggap ng kopya?"
  },
  "Were you given a service certificate?": {
    "ur": "کیا آپ کو سروس سرٹیفکیٹ دیا گیا تھا؟",
    "bn": "আপনি একটি সেবা শংসাপত্র দেওয়া হয়েছিল?",
    "id": "Apakah Anda diberi sertifikat layanan?",
    "ml": "നിങ്ങൾക്ക് ഒരു സേവന സർട്ടിഫിക്കറ്റ് നൽകിയിട്ടുണ്ടോ?",
    "tl": "Binigyan ka ba ng sertipiko ng serbisyo?"
  },
  "Were you notified?": {
    "ur": "کیا آپ کو مطلع کیا گیا تھا؟",
    "bn": "আপনাকে অবহিত করা হয়েছিল?",
    "id": "Apakah Anda diberitahu?",
    "ml": "നിങ്ങൾക്ക് അറിയിപ്പ് ലഭിച്ചോ?",
    "tl": "Naabisuhan ka ba?"
  },
  "Were you threatened with dismissal or pressured to resign?": {
    "ur": "کیا آپ کو برطرفی کی دھمکی دی گئی یا استعفیٰ دینے کے لیے دباؤ ڈالا گیا؟",
    "bn": "আপনাকে কি বরখাস্তের হুমকি দেওয়া হয়েছিল বা পদত্যাগের জন্য চাপ দেওয়া হয়েছিল?",
    "id": "Apakah Anda diancam pemecatan atau ditekan untuk mengundurkan diri?",
    "ml": "പിരിച്ചുവിടുമെന്ന് ഭീഷണിപ്പെടുത്തുകയോ രാജിവെക്കാൻ സമ്മർദ്ദം ചെലുത്തുകയോ ചെയ്തിട്ടുണ്ടോ?",
    "tl": "Binantaan ka ba na tatanggalin ka o pinilit na magbitiw?"
  },
  "Were you transferred?": {
    "ur": "کیا آپ کو منتقل کیا گیا تھا؟",
    "bn": "আপনি কি স্থানান্তরিত হয়েছিলেন?",
    "id": "Apakah kamu dipindahkan?",
    "ml": "നിങ്ങളെ ട്രാൻസ്ഫർ ചെയ്തോ?",
    "tl": "Nalipat ka ba?"
  },
  "Were your benefits reduced?": {
    "ur": "کیا آپ کے فوائد کم ہو گئے؟",
    "bn": "আপনার সুবিধা কমে গেছে?",
    "id": "Apakah tunjangan Anda berkurang?",
    "ml": "നിങ്ങളുടെ ആനുകൂല്യങ്ങൾ കുറച്ചോ?",
    "tl": "Nabawasan ba ang iyong mga benepisyo?"
  },
  "What type of relationship or agreement did you have with the employer?": {
    "ur": "آجر کے ساتھ آپ کا کس قسم کا رشتہ یا معاہدہ تھا؟",
    "bn": "নিয়োগকর্তার সাথে আপনার কি ধরনের সম্পর্ক বা চুক্তি ছিল?",
    "id": "Jenis hubungan atau perjanjian apa yang Anda miliki dengan pemberi kerja?",
    "ml": "നിങ്ങൾക്ക് തൊഴിലുടമയുമായി ഏത് തരത്തിലുള്ള ബന്ധമോ കരാറോ ആണ് ഉണ്ടായിരുന്നത്?",
    "tl": "Anong uri ng relasyon o kasunduan ang mayroon ka sa employer?"
  },
  "What was the average delay?": {
    "ur": "اوسط تاخیر کتنی تھی؟",
    "bn": "গড় বিলম্ব কি ছিল?",
    "id": "Berapa rata-rata penundaannya?",
    "ml": "ശരാശരി കാലതാമസം എന്തായിരുന്നു?",
    "tl": "Ano ang average na pagkaantala?"
  },
  "What was the work schedule?": {
    "ur": "کام کا شیڈول کیا تھا؟",
    "bn": "কাজের সময়সূচী কি ছিল?",
    "id": "Apa jadwal kerjanya?",
    "ml": "എന്തായിരുന്നു വർക്ക് ഷെഡ്യൂൾ?",
    "tl": "Ano ang iskedyul ng trabaho?"
  },
  "When did overtime usually occur?": {
    "ur": "اوور ٹائم عام طور پر کب ہوتا ہے؟",
    "bn": "কখন ওভারটাইম সাধারণত ঘটে?",
    "id": "Kapan biasanya lembur terjadi?",
    "ml": "എപ്പോഴാണ് ഓവർടൈം സാധാരണയായി സംഭവിക്കുന്നത്?",
    "tl": "Kailan karaniwang nangyayari ang overtime?"
  },
  "When did the change occur?": {
    "ur": "تبدیلی کب آئی؟",
    "bn": "পরিবর্তন কখন ঘটেছে?",
    "id": "Kapan perubahan itu terjadi?",
    "ml": "എപ്പോഴാണ് മാറ്റം സംഭവിച്ചത്?",
    "tl": "Kailan nangyari ang pagbabago?"
  },
  "Work start date": {
    "ur": "کام شروع ہونے کی تاریخ",
    "bn": "কাজ শুরুর তারিখ",
    "id": "Tanggal mulai bekerja",
    "ml": "ജോലി ആരംഭിക്കുന്ന തീയതി",
    "tl": "Petsa ng pagsisimula ng trabaho"
  },
  "Work start date is required.": {
    "ur": "کام شروع کرنے کی تاریخ درکار ہے۔",
    "bn": "কাজ শুরুর তারিখ প্রয়োজন।",
    "id": "Tanggal mulai kerja wajib diisi.",
    "ml": "ജോലി ആരംഭിക്കുന്ന തീയതി ആവശ്യമാണ്.",
    "tl": "Kinakailangan ang petsa ng pagsisimula ng trabaho."
  },
  "Working hours changed": {
    "ur": "کام کے اوقات بدل گئے۔",
    "bn": "কাজের সময় পরিবর্তন করা হয়েছে",
    "id": "Jam kerja berubah",
    "ml": "ജോലി സമയം മാറ്റി",
    "tl": "Nagbago ang oras ng trabaho"
  },
  "Workplace changed": {
    "ur": "کام کی جگہ بدل گئی۔",
    "bn": "কর্মক্ষেত্র পরিবর্তন হয়েছে",
    "id": "Tempat kerja berubah",
    "ml": "ജോലിസ്ഥലം മാറി",
    "tl": "Nagbago ang lugar ng trabaho"
  },
  "Write the information you want to correct or clarify": {
    "ur": "وہ معلومات لکھیں جسے آپ درست یا واضح کرنا چاہتے ہیں۔",
    "bn": "আপনি যে তথ্য সংশোধন বা স্পষ্ট করতে চান তা লিখুন",
    "id": "Tulis informasi yang ingin Anda koreksi atau klarifikasi",
    "ml": "നിങ്ങൾക്ക് തിരുത്താനോ വ്യക്തമാക്കാനോ ആഗ്രഹിക്കുന്ന വിവരങ്ങൾ എഴുതുക",
    "tl": "Isulat ang impormasyong nais mong itama o linawin"
  },
  "You can start a new request, and your progress will be saved automatically so it can be resumed later from this page.": {
    "ur": "آپ ایک نئی درخواست شروع کر سکتے ہیں، اور آپ کی پیشرفت خود بخود محفوظ ہو جائے گی تاکہ اسے بعد میں اس صفحہ سے دوبارہ شروع کیا جا سکے۔",
    "bn": "আপনি একটি নতুন অনুরোধ শুরু করতে পারেন, এবং আপনার অগ্রগতি স্বয়ংক্রিয়ভাবে সংরক্ষিত হবে যাতে এটি এই পৃষ্ঠা থেকে পরে আবার শুরু করা যেতে পারে।",
    "id": "Anda dapat memulai permintaan baru, dan kemajuan Anda akan disimpan secara otomatis sehingga dapat dilanjutkan nanti dari halaman ini.",
    "ml": "നിങ്ങൾക്ക് ഒരു പുതിയ അഭ്യർത്ഥന ആരംഭിക്കാൻ കഴിയും, നിങ്ങളുടെ പുരോഗതി സ്വയമേവ സംരക്ഷിക്കപ്പെടുന്നതിനാൽ ഈ പേജിൽ നിന്ന് അത് പിന്നീട് പുനരാരംഭിക്കാനാകും.",
    "tl": "Maaari kang magsimula ng bagong kahilingan, at awtomatikong mase-save ang iyong pag-unlad upang maipagpatuloy ito sa ibang pagkakataon mula sa pahinang ito."
  },
  "You can upload the employer response in the attachments step under \"Employer Response\".": {
    "ur": "آپ \"ایمپلائر ریسپانس\" کے تحت منسلکات کے مرحلے میں آجر کا جواب اپ لوڈ کر سکتے ہیں۔",
    "bn": "আপনি \"নিয়োগকর্তার প্রতিক্রিয়া\" এর অধীনে সংযুক্তি ধাপে নিয়োগকর্তার প্রতিক্রিয়া আপলোড করতে পারেন।",
    "id": "Anda dapat mengunggah respons perusahaan pada langkah lampiran di bawah \"Respon Perusahaan\".",
    "ml": "\"എംപ്ലോയർ റെസ്‌പോൺസ്\" എന്നതിന് താഴെയുള്ള അറ്റാച്ച്‌മെൻ്റ് ഘട്ടത്തിൽ നിങ്ങൾക്ക് തൊഴിലുടമയുടെ പ്രതികരണം അപ്‌ലോഡ് ചെയ്യാം.",
    "tl": "Maaari mong i-upload ang tugon ng employer sa hakbang ng mga attachment sa ilalim ng \"Tugon ng Employer.\""
  },
  "You can upload the objection or claim copy in the attachments step under \"Prior Objection or Claim\".": {
    "ur": "آپ \"پہلے اعتراض یا دعوی\" کے تحت منسلکات کے مرحلے میں اعتراض یا دعوی کی کاپی اپ لوڈ کر سکتے ہیں۔",
    "bn": "আপনি \"আগের আপত্তি বা দাবি\" এর অধীনে সংযুক্তি ধাপে আপত্তি বা দাবি অনুলিপি আপলোড করতে পারেন।",
    "id": "Anda dapat mengunggah salinan keberatan atau klaim pada langkah lampiran di bawah \"Keberatan atau Klaim Sebelumnya\".",
    "ml": "\"മുൻപ് എതിർപ്പ് അല്ലെങ്കിൽ ക്ലെയിം\" എന്നതിന് കീഴിലുള്ള അറ്റാച്ച്‌മെൻ്റ് ഘട്ടത്തിൽ നിങ്ങൾക്ക് എതിർപ്പ് അല്ലെങ്കിൽ ക്ലെയിം പകർപ്പ് അപ്‌ലോഡ് ചെയ്യാം.",
    "tl": "Maaari mong i-upload ang pagtutol o i-claim ang kopya sa mga attachment na hakbang sa ilalim ng \"Naunang Pagtutol o Claim.\""
  },
  "You must confirm the declaration before submission.": {
    "ur": "آپ کو جمع کرانے سے پہلے اعلان کی تصدیق کرنی ہوگی۔",
    "bn": "জমা দেওয়ার আগে আপনাকে অবশ্যই ঘোষণাটি নিশ্চিত করতে হবে।",
    "id": "Anda harus mengkonfirmasi deklarasi sebelum diserahkan.",
    "ml": "സമർപ്പിക്കുന്നതിന് മുമ്പ് നിങ്ങൾ പ്രഖ്യാപനം സ്ഥിരീകരിക്കണം.",
    "tl": "Dapat mong kumpirmahin ang deklarasyon bago isumite."
  },
  "Your progress is saved automatically while you complete the request.": {
    "ur": "جب آپ درخواست مکمل کرتے ہیں تو آپ کی پیشرفت خود بخود محفوظ ہوجاتی ہے۔",
    "bn": "আপনি অনুরোধ সম্পূর্ণ করার সময় আপনার অগ্রগতি স্বয়ংক্রিয়ভাবে সংরক্ষিত হয়।",
    "id": "Kemajuan Anda disimpan secara otomatis saat Anda menyelesaikan permintaan.",
    "ml": "നിങ്ങൾ അഭ്യർത്ഥന പൂർത്തിയാക്കുമ്പോൾ നിങ്ങളുടെ പുരോഗതി സ്വയമേവ സംരക്ഷിക്കപ്പെടും.",
    "tl": "Awtomatikong nase-save ang iyong pag-unlad habang kinukumpleto mo ang kahilingan."
  },
  "Your request has been received successfully": {
    "ur": "آپ کی درخواست کامیابی کے ساتھ موصول ہو گئی ہے۔",
    "bn": "আপনার অনুরোধ সফলভাবে গৃহীত হয়েছে",
    "id": "Permintaan Anda telah berhasil diterima",
    "ml": "നിങ്ങളുടെ അഭ്യർത്ഥന വിജയകരമായി സ്വീകരിച്ചു",
    "tl": "Matagumpay na natanggap ang iyong kahilingan"
  },
  "en-US": {
    "ur": "en-US",
    "bn": "en-US",
    "id": "en-AS",
    "ml": "en-US",
    "tl": "en-US"
  },
  "item(s)": {
    "ur": "اشیاء",
    "bn": "আইটেম(গুলি)",
    "id": "barang",
    "ml": "ഇനം(കൾ)",
    "tl": "(mga) item"
  },
  "of": {
    "ur": "کی",
    "bn": "এর",
    "id": "dari",
    "ml": "യുടെ",
    "tl": "ng"
  }
};
